// Generated by Avo VERSION 234.15.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* eslint-disable */

// fetch() polyfill
(function() {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function() {
        try {
          new Blob();
          return true;
        } catch (e) {
          return false;
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self,
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]',
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return (
          obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
        );
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name');
    }
    return name.toLowerCase();
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value;
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return { done: value === undefined, value: value };
      },
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator;
      };
    }

    return iterator;
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null;
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name));
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items);
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items);
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items);
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'));
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    });
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise;
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('');
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0);
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer;
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (
        support.searchParams &&
        URLSearchParams.prototype.isPrototypeOf(body)
      ) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (
        support.arrayBuffer &&
        (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))
      ) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (
          support.searchParams &&
          URLSearchParams.prototype.isPrototypeOf(body)
        ) {
          this.headers.set(
            'content-type',
            'application/x-www-form-urlencoded;charset=UTF-8'
          );
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected;
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected;
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode);
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse);
    };

    return this;
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method;
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read');
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests');
    }
    this._initBody(body);
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit });
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form;
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers;
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url,
    });
  };

  Response.error = function() {
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response;
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code');
    }

    return new Response(null, { status: status, headers: { location: url } });
  };

  self.DOMException = self.DOMException;
  try {
    new self.DOMException();
  } catch (err) {
    self.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    self.DOMException.prototype = Object.create(Error.prototype);
    self.DOMException.prototype.constructor = self.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new self.DOMException('Aborted', 'AbortError'));
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || ''),
        };
        options.url =
          'responseURL' in xhr
            ? xhr.responseURL
            : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function() {
        reject(new self.DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(
        typeof request._bodyInit === 'undefined' ? null : request._bodyInit
      );
    });
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }
})();

var __AVO_DEV__ = false;
var __AVO_NOOP__ = false;
var __AVO_LOGGER__ = null;
var __AVO_ENV__ = null;
var __REPORT_FAILURE_AS__ = null;
var __STRICT__ = null;

var __WEB_DEBUGGER__ = true;
const avoInspectorApiKey = '0LwnxMrVza9UwOgaWeUP';
var __INSPECTOR__ = null;

// polyfill Array.isArray
if (!Array.isArray) {
  Array.isArray = function(arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
  };
}

// polyfill Object.assign
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, 'assign', {
    value: function assign(target, varArgs) {
      // .length of function is 2
      if (target == null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) {
          // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true,
  });
}

// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
if (!Object.keys) {
  Object.keys = (function() {
    'use strict';
    var hasOwnProperty = Object.prototype.hasOwnProperty,
      hasDontEnumBug = !{ toString: null }.propertyIsEnumerable('toString'),
      dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor',
      ],
      dontEnumsLength = dontEnums.length;

    return function(obj) {
      if (
        typeof obj !== 'function' &&
        (typeof obj !== 'object' || obj === null)
      ) {
        throw new TypeError('Object.keys called on non-object');
      }

      var result = [],
        prop,
        i;

      for (prop in obj) {
        if (hasOwnProperty.call(obj, prop)) {
          result.push(prop);
        }
      }

      if (hasDontEnumBug) {
        for (i = 0; i < dontEnumsLength; i++) {
          if (hasOwnProperty.call(obj, dontEnums[i])) {
            result.push(dontEnums[i]);
          }
        }
      }
      return result;
    };
  })();
}

// polyfill Array.indexOf
if (!Array.prototype.indexOf)
  Array.prototype.indexOf = (function(Object, max, min) {
    'use strict';
    return function indexOf(member, fromIndex) {
      if (this === null || this === undefined)
        throw TypeError('Array.prototype.indexOf called on null or undefined');

      var that = Object(this),
        Len = that.length >>> 0,
        i = min(fromIndex | 0, Len);
      if (i < 0) i = max(0, Len + i);
      else if (i >= Len) return -1;

      if (member === void 0) {
        for (; i !== Len; ++i) if (that[i] === void 0 && i in that) return i; // undefined
      } else if (member !== member) {
        for (; i !== Len; ++i) if (that[i] !== that[i]) return i; // NaN
      } else for (; i !== Len; ++i) if (that[i] === member) return i; // all else

      return -1; // if the value was not found, then return -1
    };
  })(Object, Math.max, Math.min);

var array_difference, AvoAssert, InternalAvoLogger;
array_difference = function array_difference(a1, a2) {
  var result = [];
  for (var i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i]);
    }
  }
  return result;
};

AvoAssert = {
  assertObject: function assertObject(propertyId, propName, obj) {
    if (typeof obj !== 'object') {
      var message =
        propName +
        ' should be of type object but you provided type ' +
        typeof obj +
        ' with value ' +
        JSON.stringify(obj);
      return [
        {
          tag: 'expectedObjectType',
          propertyId: propertyId,
          message: message,
          actualType: typeof obj,
        },
      ];
    } else {
      return [];
    }
  },

  assertString: function assertString(propertyId, propName, str) {
    if (typeof str !== 'string') {
      var message =
        propName +
        ' should be of type string but you provided type ' +
        typeof str +
        ' with value ' +
        JSON.stringify(str);
      return [
        {
          tag: 'expectedStringType',
          propertyId: propertyId,
          message: message,
          actualType: typeof str,
        },
      ];
    } else {
      return [];
    }
  },

  assertInt: function assertInt(propertyId, propName, int) {
    if (typeof int === 'number' && int !== Math.round(int)) {
      var message =
        propName +
        ' should be of type int but you provided type float with value ' +
        JSON.stringify(int);
      return [
        { tag: 'expectedIntType', propertyId: propertyId, actualType: 'float' },
      ];
    } else if (typeof int !== 'number') {
      var message =
        propName +
        ' should be of type int but you provided type ' +
        typeof int +
        ' with value ' +
        JSON.stringify(int);
      return [
        {
          tag: 'expectedIntType',
          propertyId: propertyId,
          message: message,
          actualType: typeof int,
        },
      ];
    } else {
      return [];
    }
  },

  assertLong: function assertLong(propertyId, propName, long) {
    if (typeof long === 'number' && long !== Math.round(long)) {
      var message =
        propName +
        ' should be of type long but you provided type float with value ' +
        JSON.stringify(long);
      return [
        {
          tag: 'expectedLongType',
          propertyId: propertyId,
          actualType: 'float',
        },
      ];
    } else if (typeof long !== 'number') {
      var message =
        propName +
        ' should be of type long but you provided type ' +
        typeof long +
        ' with value ' +
        JSON.stringify(long);
      return [
        {
          tag: 'expectedLongType',
          propertyId: propertyId,
          message: message,
          actualType: typeof long,
        },
      ];
    } else {
      return [];
    }
  },

  assertFloat: function assertFloat(propertyId, propName, float) {
    if (typeof float !== 'number') {
      var message =
        propName +
        ' should be of type float but you provided type ' +
        typeof float +
        ' with value ' +
        JSON.stringify(float);
      return [
        {
          tag: 'expectedFloatType',
          propertyId: propertyId,
          message: message,
          actualType: typeof float,
        },
      ];
    } else {
      return [];
    }
  },

  assertBool: function assertBool(propertyId, propName, bool) {
    if (typeof bool !== 'boolean') {
      var message =
        propName +
        ' should be of type boolean but you provided type ' +
        typeof bool +
        ' with value ' +
        JSON.stringify(bool);
      return [
        {
          tag: 'expectedBoolType',
          propertyId: propertyId,
          message: message,
          actualType: typeof bool,
        },
      ];
    } else {
      return [];
    }
  },

  assertMax: function assertMax(propertyId, propName, max, value) {
    if (value > max) {
      var message =
        propName +
        ' has a maximum value of ' +
        max +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{ tag: 'expectedMax', propertyId: propertyId, message: message }];
    } else {
      return [];
    }
  },

  assertMin: function assertMin(propertyId, propName, min, value) {
    if (value < min) {
      var message =
        propName +
        ' has a minimum value of ' +
        min +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{ tag: 'expectedMin', propertyId: propertyId, message: message }];
    } else {
      return [];
    }
  },

  assertList: function assertList(propertyId, propName, value) {
    if (!Array.isArray(value)) {
      var message =
        propName +
        ' should be of type list but you provided type ' +
        typeof value;
      return [
        {
          tag: 'expectedList',
          propertyId: propertyId,
          message: message,
          actualType: typeof value,
        },
      ];
    } else {
      return [];
    }
  },

  assertNoAdditionalProperties: function assertNoAdditionalProperties(
    eventName,
    input,
    spec
  ) {
    var additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      var message =
        'Additional properties when sending event ' +
        eventName +
        ': ' +
        JSON.stringify(additionalKeys);
      return [
        {
          tag: 'expectedNoAdditionalProperties',
          additionalProperties: additionalKeys,
          message: message,
        },
      ];
    } else {
      return [];
    }
  },

  assertNoAdditionalUserProperties: function assertNoAdditionalProperties(
    eventName,
    input,
    spec
  ) {
    var additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      var message =
        'Additional user properties when sending event ' +
        eventName +
        ': ' +
        JSON.stringify(additionalKeys);
      return [
        {
          tag: 'expectedNoAdditionalUserProperties',
          additionalProperties: additionalKeys,
          message: message,
        },
      ];
    } else {
      return [];
    }
  },
};

const WebDebuggerAssertions = {
  hasKey(obj, key) {
    return obj && obj[key] != null;
  },
  assertKey(obj, key, assert) {
    if (this.hasKey(obj, key) && assert(obj[key])) {
      return true;
    } else {
      throw new Error(
        'WebDebugger: Object key: "' + key + '" failed assertion.'
      );
    }
  },
  assertKeys(obj, arrayOfAssertions) {
    return arrayOfAssertions.every(assertionForKey => {
      if (
        this.hasKey(assertionForKey, 'key') &&
        this.hasKey(assertionForKey, 'assert')
      ) {
        return this.assertKey(obj, assertionForKey.key, assertionForKey.assert);
      } else {
        throw new Error('WebDebugger: Object form for assertion invalid.');
      }
    });
  },
  assertInt(int) {
    return Number.isInteger(int);
  },
};

var WebDebuggerPosition = {
  position: {
    BOTTOM_RIGHT: 'BottomRight',
    BOTTOM_LEFT: 'BottomLeft',
    TOP_RIGHT: 'TopRight',
    TOP_LEFT: 'TopLeft',
  },
  BottomRight(parameters) {
    return (
      WebDebuggerAssertions.assertKeys(parameters, [
        { key: 'bottom', assert: WebDebuggerAssertions.assertInt },
        { key: 'right', assert: WebDebuggerAssertions.assertInt },
      ]) && {
        position: this.position.BOTTOM_RIGHT,
        bottom: parameters.bottom,
        right: parameters.right,
      }
    );
  },
  BottomLeft(parameters) {
    return (
      WebDebuggerAssertions.assertKeys(parameters, [
        { key: 'bottom', assert: WebDebuggerAssertions.assertInt },
        { key: 'left', assert: WebDebuggerAssertions.assertInt },
      ]) && {
        position: this.position.BOTTOM_LEFT,
        bottom: parameters.bottom,
        left: parameters.left,
      }
    );
  },
  TopRight(parameters) {
    return (
      WebDebuggerAssertions.assertKeys(parameters, [
        { key: 'top', assert: WebDebuggerAssertions.assertInt },
        { key: 'right', assert: WebDebuggerAssertions.assertInt },
      ]) && {
        position: this.position.TOP_RIGHT,
        top: parameters.top,
        right: parameters.right,
      }
    );
  },
  TopLeft(parameters) {
    return (
      WebDebuggerAssertions.assertKeys(parameters, [
        { key: 'top', assert: WebDebuggerAssertions.assertInt },
        { key: 'left', assert: WebDebuggerAssertions.assertInt },
      ]) && {
        position: this.position.TOP_LEFT,
        top: parameters.top,
        left: parameters.left,
      }
    );
  },
};

InternalAvoLogger = {
  logEventSent: function logEventSent(
    eventName,
    eventProperties,
    userProperties,
    groupProperties
  ) {
    const message =
      'Event Sent:' +
      eventName +
      'Event Props:' +
      JSON.stringify(eventProperties) +
      'User Props:' +
      JSON.stringify(userProperties) +
      'Group Props:' +
      JSON.stringify(groupProperties);

    if (
      __AVO_LOGGER__ &&
      __AVO_LOGGER__.logDebug &&
      __AVO_LOGGER__.logDebug(__AVO_ENV__, message)
    ) {
      return;
    }
    typeof console !== 'undefined' &&
      console.log(
        '[avo] Event Sent:',
        eventName,
        'Event Props:',
        eventProperties,
        'User Props:',
        userProperties,
        'Group Props:',
        groupProperties
      );
  },

  log: function log(message) {
    if (
      __AVO_LOGGER__ &&
      __AVO_LOGGER__.logDebug &&
      __AVO_LOGGER__.logDebug(__AVO_ENV__, message)
    ) {
      return;
    }
    typeof console !== 'undefined' && console.log('[avo] ' + message);
  },

  warn: function warn(message) {
    if (
      __AVO_LOGGER__ &&
      __AVO_LOGGER__.logWarn &&
      __AVO_LOGGER__.logWarn(__AVO_ENV__, message)
    ) {
      return;
    }
    typeof console !== 'undefined' && console.warn('[avo] ' + message);
  },

  error: function error(message, error) {
    if (
      __AVO_LOGGER__ &&
      __AVO_LOGGER__.logError &&
      __AVO_LOGGER__.logError(__AVO_ENV__, message + error)
    ) {
      return;
    }
    typeof console !== 'undefined' && console.error('[avo] ' + message, error);
  },
};

var _avo_invoke, _avo_invoke_meta;
var _avo_sampling_rate = 1.0;
function _avo_invoke_payload(body) {
  if (typeof window === 'undefined') {
    return;
  }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      fetch('https://api.avo.app/i', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function(res) {
          return res.json();
        })
        .then(function(data) {
          _avo_sampling_rate = data.sa;
        })
        .catch(function() {});
    }
  }
}

_avo_invoke = function _avo_invoke(env, eventId, hash, messages, origin) {
  _avo_invoke_payload({
    ac: 'FP24UaLHVYBsQ5QEVC08',
    br: 'master',
    en: env,
    ev: eventId,
    ha: hash,
    sc: 'dJpfothnobBXH6sZkM2n',
    se: new Date().toISOString(),
    so: 'CotR-aFMi',
    va: messages.length === 0,
    me: messages,
    or: origin,
  });
};

_avo_invoke_meta = function _avo_invoke_meta(env, type, messages, origin) {
  _avo_invoke_payload({
    ac: 'FP24UaLHVYBsQ5QEVC08',
    br: 'master',
    en: env,
    ty: type,
    sc: 'dJpfothnobBXH6sZkM2n',
    se: new Date().toISOString(),
    so: 'CotR-aFMi',
    va: messages.length === 0,
    me: messages,
    or: origin,
  });
};

var _avo_debugger_log;
var _avo_debugger_events_during_boot = [];
var _avo_debugger_ready = false;

if (typeof window !== 'undefined') {
  window.addEventListener('message', function(event) {
    if (event.origin !== 'https://www.avo.app') {
      return;
    }
    var iframe = document.getElementById('avo-debugger');
    if (
      iframe &&
      event &&
      event.data &&
      event.data.type_ === 'avo-debugger-update-style'
    ) {
      iframe.style = event.data.style;
    } else if (
      iframe &&
      event &&
      event.data &&
      event.data.type_ === 'avo-debugger-ready'
    ) {
      var message = {
        type_: 'avo-debugger-boot-events',
        schemaId: 'dJpfothnobBXH6sZkM2n',
        href: window.location.href,
        events: _avo_debugger_events_during_boot,
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(
        message,
        'https://www.avo.app/_debugger'
      );
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(
  eventId,
  eventName,
  messages,
  eventProperties,
  userProperties,
  groupProperties
) {
  if (typeof window === 'undefined') {
    return;
  }
  var event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties: eventProperties,
    userProperties: userProperties,
    groupProperties: groupProperties,
  };

  if (_avo_debugger_ready) {
    var message = { type_: 'avo-debugger-events', events: [event] };
    document
      .getElementById('avo-debugger')
      .contentWindow.postMessage(message, 'https://www.avo.app/_debugger');
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
};

function _avo_debugger_send_position(position) {
  if (typeof window === 'undefined') {
    return;
  }
  window.addEventListener('message', function(event) {
    if (event.origin !== 'https://www.avo.app') {
      return;
    }
    if (event.data.type_ === 'avo-debugger-ready' && position !== null) {
      var message = { type_: 'avo-debugger-position', position: position };
      document
        .getElementById('avo-debugger')
        .contentWindow.postMessage(message, 'https://www.avo.app/_debugger');
    }
  });
}

var Location = {
  HOME_PAGE: 'Home Page',
  CATEGORY_PAGE: 'Category Page',
  PDP: 'PDP',
  GUEST_CHECKOUT: 'Guest Checkout',
  CHECKOUT: 'Checkout',
  DESIGN_SERVICES: 'Design Services',
  CUSTOMER_DASHBOARD: 'Customer Dashboard',
  SHOP_BY_MATERIAL: 'Shop By Material',
  PET_FRIENDLY_PAGE: 'Pet Friendly Page',
  SAFEGUARD_FABRICS_PAGE: 'Safeguard Fabrics Page',
  LOOKBOOKS: 'Lookbooks',
  JOYBIRD_LIVE: 'Joybird Live',
  CART: 'Cart',
  VIDEO_GALLERY: 'Video Gallery',
  BLOG: 'Blog',
  ORDER_TRACKER: 'Order Tracker',
  FEED: 'Feed',
  SWATCHES: 'Swatches',
  BUSINESS: 'Business',
  TRADE_APPLICATION: 'Trade Application',
};

var PaymentMethod = {
  CREDIT_CARD: 'Credit Card',
  SYNCHRONY: 'Synchrony',
  APPLE_PAY: 'Apple Pay',
  AFFIRM: 'Affirm',
  NET: 'Net',
  NO_PAYMENT_REQUIRED: 'No Payment Required',
  OTHER_CSAT: 'Other (CSAT)',
  STOCK: 'Stock',
  OTHER_MARKETING: 'Other (Marketing)',
  PROMOTION: 'Promotion',
  NET_30: 'Net 30',
  _50: '50%',
  OTHER_EMPLOYEE: 'Other (Employee)',
  CHECK: 'Check',
  COD: 'COD',
  FORTIVA: 'Fortiva',
  ON_HOLD: 'On Hold',
  AMAZON: 'Amazon',
  PAY_PAL: 'PayPal',
};

var PageType = {
  HOME: 'Home',
  PDP: 'PDP',
  CATEGORY: 'Category',
  CART: 'Cart',
  OTHER: 'Other',
  CUSTOMER_PHOTOS: 'Customer Photos',
};

var PlanName = {
  LIFE_HAPPENS: 'Life Happens',
  PET_PROTECTOR: 'Pet Protector',
};

var SearchTarget = {
  PRODUCT_GRID: 'Product Grid',
  OTHER_RESULTS_LINK: 'Other Results Link',
  FULL_RESULTS: 'Full Results',
  EXIT_SEARCH: 'Exit Search',
};

var Cta = {
  ROOM_BUILDER: 'Room Builder',
  FULL_SCREEN_VIEW: 'Full Screen View',
  FINANCING: 'Financing',
  COMPARISON_TOOL: 'Comparison Tool',
  _3D_VIEWER: '3D Viewer',
  RETAIL_STORE: 'Retail Store',
  ROOM_REFRESH: 'Room Refresh',
  DISMISS: 'Dismiss',
  BUSINESS: 'Business',
  SUBMIT_TRADE_APPLICATION: 'Submit Trade Application',
};

var Currency = {
  USD: 'USD',
  CAD: 'CAD',
};

var Component = {
  PRODUCT_RECOMMENDATION_CAROUSEL: 'Product Recommendation Carousel',
  RECENTLY_VIEWED_CAROUSEL: 'Recently Viewed Carousel',
  BEST_SELLERS_CAROUSEL: 'Best Sellers Carousel',
  COLLECTION_CAROUSEL: 'Collection Carousel',
  NAVBAR: 'Navbar',
  PRODUCT_TO_PRODUCT_CAROUSEL: 'Product to Product Carousel',
  PRODUCT_CARD: 'Product Card',
  CART: 'Cart',
  JUSTUNO: 'Justuno',
  NEWSLETTER_SIGNUP: 'Newsletter Signup',
  SWATCH_REQUEST: 'Swatch Request',
  SHARE_CART: 'Share Cart',
  ACCOUNT_CREATION: 'Account Creation',
  PRODUCT_GRID: 'Product Grid',
  QUICKVIEW_MODAL: 'Quickview Modal',
  SIDE_PANEL: 'Side Panel',
  DELIVERY_UPDATE: 'Delivery Update',
  TRADE_NEWSLETTER_SIGNUP: 'Trade Newsletter Signup',
  TRADE_APPLICATION: 'Trade Application',
};

function assertNonInteraction(nonInteraction, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertInt(
      '-3Hv24vVaC',
      label_ ? 'non_interaction' + ': ' + label_ : 'non_interaction',
      nonInteraction
    )
  );
  messages = messages.concat(
    AvoAssert.assertMin(
      '-3Hv24vVaC',
      label_ ? 'non_interaction' + ': ' + label_ : 'non_interaction',
      1,
      nonInteraction
    )
  );
  messages = messages.concat(
    AvoAssert.assertMax(
      '-3Hv24vVaC',
      label_ ? 'non_interaction' + ': ' + label_ : 'non_interaction',
      1,
      nonInteraction
    )
  );
  return messages;
}

function assertDeliveryType(deliveryType, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      '-Be6jz-r5H',
      label_ ? 'delivery_type' + ': ' + label_ : 'delivery_type',
      deliveryType
    )
  );
  return messages;
}

function assertOptionalDeliveryType(deliveryType, label_) {
  var messages = [];
  if (deliveryType !== undefined && deliveryType !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        '-Be6jz-r5H',
        label_ ? 'delivery_type' + ': ' + label_ : 'delivery_type',
        deliveryType
      )
    );
  }
  return messages;
}

function assertTopCookies(topCookies, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertList('-D2Sv66IYdW', 'top_cookies', topCookies)
  );
  if (topCookies !== null && topCookies !== undefined && topCookies.forEach) {
    topCookies.forEach(function(value, index) {});
  }
  return messages;
}

function assertProtectionPlanCost(protectionPlanCost, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertFloat(
      '-r2A9Y6Dak',
      label_ ? 'protection_plan_cost' + ': ' + label_ : 'protection_plan_cost',
      protectionPlanCost
    )
  );
  return messages;
}

function assertOptionalProtectionPlanCost(protectionPlanCost, label_) {
  var messages = [];
  if (protectionPlanCost !== undefined && protectionPlanCost !== null) {
    messages = messages.concat(
      AvoAssert.assertFloat(
        '-r2A9Y6Dak',
        label_
          ? 'protection_plan_cost' + ': ' + label_
          : 'protection_plan_cost',
        protectionPlanCost
      )
    );
  }
  return messages;
}

function assertOptionalCampaignUtmTerm(campaignUtmTerm, label_) {
  var messages = [];
  if (campaignUtmTerm !== undefined && campaignUtmTerm !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        '-yJgZgCLf0',
        label_ ? 'campaign_utm_term' + ': ' + label_ : 'campaign_utm_term',
        campaignUtmTerm
      )
    );
  }
  return messages;
}

function assertTax(tax, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertFloat(
      '1PytrUAIdT',
      label_ ? 'tax' + ': ' + label_ : 'tax',
      tax
    )
  );
  return messages;
}

function assertOptionalImageId(imageId, label_) {
  var messages = [];
  if (imageId !== undefined && imageId !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        '1ewdiPaa6hIgJp-wC9s1x',
        label_ ? 'image_id' + ': ' + label_ : 'image_id',
        imageId
      )
    );
  }
  return messages;
}

function assertOptionalStoreId(storeId, label_) {
  var messages = [];
  if (storeId !== undefined && storeId !== null) {
    messages = messages.concat(
      AvoAssert.assertInt(
        '2qM3Rh0Jhb',
        label_ ? 'store_id' + ': ' + label_ : 'store_id',
        storeId
      )
    );
  }
  return messages;
}

function assertCategory(category, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      '3PXRzRK2KK',
      label_ ? 'category' + ': ' + label_ : 'category',
      category
    )
  );
  return messages;
}

function assertOptionalCategory(category, label_) {
  var messages = [];
  if (category !== undefined && category !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        '3PXRzRK2KK',
        label_ ? 'category' + ': ' + label_ : 'category',
        category
      )
    );
  }
  return messages;
}

function assertOptionalShippingMethod(shippingMethod, label_) {
  var messages = [];
  if (shippingMethod !== undefined && shippingMethod !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        '4HTRW0TFrB',
        label_ ? 'shipping_method' + ': ' + label_ : 'shipping_method',
        shippingMethod
      )
    );
  }
  return messages;
}

function assertShipping(shipping, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertFloat(
      '4RK31aMrfu',
      label_ ? 'shipping' + ': ' + label_ : 'shipping',
      shipping
    )
  );
  return messages;
}

function assertOptionalEmail(email, label_) {
  var messages = [];
  if (email !== undefined && email !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        '4rYN-Q_mp',
        label_ ? 'email' + ': ' + label_ : 'email',
        email
      )
    );
  }
  return messages;
}

function assertEmail(email, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      '4rYN-Q_mp',
      label_ ? 'email' + ': ' + label_ : 'email',
      email
    )
  );
  return messages;
}

function assertCompany(company, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      '4v0PdN0X0',
      label_ ? 'company' + ': ' + label_ : 'company',
      company
    )
  );
  return messages;
}

function assertOptionalCompany(company, label_) {
  var messages = [];
  if (company !== undefined && company !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        '4v0PdN0X0',
        label_ ? 'company' + ': ' + label_ : 'company',
        company
      )
    );
  }
  return messages;
}

function assertOptionalNow(now, label_) {
  var messages = [];
  if (now !== undefined && now !== null) {
    messages = messages.concat(
      AvoAssert.assertBool(
        '5wx0Y-QWlE',
        label_ ? 'now' + ': ' + label_ : 'now',
        now
      )
    );
  }
  return messages;
}

function assertOptionalUpholsterySort(upholsterySort, label_) {
  var messages = [];
  if (upholsterySort !== undefined && upholsterySort !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        '6HxqEgV2-H',
        label_ ? 'upholstery_sort' + ': ' + label_ : 'upholstery_sort',
        upholsterySort
      )
    );
  }
  return messages;
}

function assertLastName(lastName, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      '6xBEsvKJnp',
      label_ ? 'last_name' + ': ' + label_ : 'last_name',
      lastName
    )
  );
  return messages;
}

function assertOptionalCampaignUtmMedium(campaignUtmMedium, label_) {
  var messages = [];
  if (campaignUtmMedium !== undefined && campaignUtmMedium !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        '7-kG2dnolL',
        label_ ? 'campaign_utm_medium' + ': ' + label_ : 'campaign_utm_medium',
        campaignUtmMedium
      )
    );
  }
  return messages;
}

function assertOptionalMeasureActivated(measureActivated, label_) {
  var messages = [];
  if (measureActivated !== undefined && measureActivated !== null) {
    messages = messages.concat(
      AvoAssert.assertBool(
        '7RtLBjDvYoNCbOX-Fheeg',
        label_ ? 'measure_activated' + ': ' + label_ : 'measure_activated',
        measureActivated
      )
    );
  }
  return messages;
}

function assertAddressLine2(addressLine2, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      '8Pl1k62qA-',
      label_ ? 'address_line_2' + ': ' + label_ : 'address_line_2',
      addressLine2
    )
  );
  return messages;
}

function assertOptionalAddressLine2(addressLine2, label_) {
  var messages = [];
  if (addressLine2 !== undefined && addressLine2 !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        '8Pl1k62qA-',
        label_ ? 'address_line_2' + ': ' + label_ : 'address_line_2',
        addressLine2
      )
    );
  }
  return messages;
}

function assertSubtotal(subtotal, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertFloat(
      '9LdTHkmJT',
      label_ ? 'subtotal' + ': ' + label_ : 'subtotal',
      subtotal
    )
  );
  return messages;
}

function assertZip(zip, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      '9YayH8EfP9',
      label_ ? 'zip' + ': ' + label_ : 'zip',
      zip
    )
  );
  return messages;
}

function assertLocation(location, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'B71GIESiV8',
      label_ ? 'location' + ': ' + label_ : 'location',
      location
    )
  );
  if (
    'Home Page' !== location &&
    'Category Page' !== location &&
    'PDP' !== location &&
    'Guest Checkout' !== location &&
    'Checkout' !== location &&
    'Design Services' !== location &&
    'Customer Dashboard' !== location &&
    'Shop By Material' !== location &&
    'Pet Friendly Page' !== location &&
    'Safeguard Fabrics Page' !== location &&
    'Lookbooks' !== location &&
    'Joybird Live' !== location &&
    'Cart' !== location &&
    'Video Gallery' !== location &&
    'Blog' !== location &&
    'Order Tracker' !== location &&
    'Feed' !== location &&
    'Swatches' !== location &&
    'Business' !== location &&
    'Trade Application' !== location
  ) {
    var message =
      (label_ ? 'location' + ': ' + label_ : 'location') +
      ' should match one of the following values [ Home Page | Category Page | PDP | Guest Checkout | Checkout | Design Services | Customer Dashboard | Shop By Material | Pet Friendly Page | Safeguard Fabrics Page | Lookbooks | Joybird Live | Cart | Video Gallery | Blog | Order Tracker | Feed | Swatches | Business | Trade Application ] but you provided the value ' +
      location;
    messages = messages.concat([
      {
        tag: 'expectedStringMatch',
        propertyId: 'B71GIESiV8',
        message: message,
      },
    ]);
  }
  return messages;
}

function assertOptionalLocation(location, label_) {
  var messages = [];
  if (location !== undefined && location !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        'B71GIESiV8',
        label_ ? 'location' + ': ' + label_ : 'location',
        location
      )
    );
    if (
      'Home Page' !== location &&
      'Category Page' !== location &&
      'PDP' !== location &&
      'Guest Checkout' !== location &&
      'Checkout' !== location &&
      'Design Services' !== location &&
      'Customer Dashboard' !== location &&
      'Shop By Material' !== location &&
      'Pet Friendly Page' !== location &&
      'Safeguard Fabrics Page' !== location &&
      'Lookbooks' !== location &&
      'Joybird Live' !== location &&
      'Cart' !== location &&
      'Video Gallery' !== location &&
      'Blog' !== location &&
      'Order Tracker' !== location &&
      'Feed' !== location &&
      'Swatches' !== location &&
      'Business' !== location &&
      'Trade Application' !== location
    ) {
      var message =
        (label_ ? 'location' + ': ' + label_ : 'location') +
        ' should match one of the following values [ Home Page | Category Page | PDP | Guest Checkout | Checkout | Design Services | Customer Dashboard | Shop By Material | Pet Friendly Page | Safeguard Fabrics Page | Lookbooks | Joybird Live | Cart | Video Gallery | Blog | Order Tracker | Feed | Swatches | Business | Trade Application ] but you provided the value ' +
        location;
      messages = messages.concat([
        {
          tag: 'expectedStringMatch',
          propertyId: 'B71GIESiV8',
          message: message,
        },
      ]);
    }
  }
  return messages;
}

function assertPhone(phone, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'CNxC4sfhlL',
      label_ ? 'phone' + ': ' + label_ : 'phone',
      phone
    )
  );
  return messages;
}

function assertOptionalPhone(phone, label_) {
  var messages = [];
  if (phone !== undefined && phone !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        'CNxC4sfhlL',
        label_ ? 'phone' + ': ' + label_ : 'phone',
        phone
      )
    );
  }
  return messages;
}

function assertOptedInTrade(optedInTrade, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertBool(
      'CwSBlkF81y',
      label_ ? 'opted_in_trade' + ': ' + label_ : 'opted_in_trade',
      optedInTrade
    )
  );
  return messages;
}

function assertOptionalAnswer(answer, label_) {
  var messages = [];
  if (answer !== undefined && answer !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        'DGtYZWhVMG',
        label_ ? 'answer' + ': ' + label_ : 'answer',
        answer
      )
    );
  }
  return messages;
}

function assertAddressName(addressName, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'D_G2GVXHOW',
      label_ ? 'address_name' + ': ' + label_ : 'address_name',
      addressName
    )
  );
  return messages;
}

function assertOptionalAddressName(addressName, label_) {
  var messages = [];
  if (addressName !== undefined && addressName !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        'D_G2GVXHOW',
        label_ ? 'address_name' + ': ' + label_ : 'address_name',
        addressName
      )
    );
  }
  return messages;
}

function assertUpholsteryFilter(upholsteryFilter, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'DnTlFDY3ZU',
      label_ ? 'upholstery_filter' + ': ' + label_ : 'upholstery_filter',
      upholsteryFilter
    )
  );
  return messages;
}

function assertSwatchRequestId(swatchRequestId, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertInt(
      'DuM7mUDaZL',
      label_ ? 'swatch_request_id' + ': ' + label_ : 'swatch_request_id',
      swatchRequestId
    )
  );
  return messages;
}

function assertOptionalTalkativeCustomerId(talkativeCustomerId, label_) {
  var messages = [];
  if (talkativeCustomerId !== undefined && talkativeCustomerId !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        'E46jtrSf8',
        label_
          ? 'talkative_customer_id' + ': ' + label_
          : 'talkative_customer_id',
        talkativeCustomerId
      )
    );
  }
  return messages;
}

function assertTalkativeCustomerId(talkativeCustomerId, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'E46jtrSf8',
      label_
        ? 'talkative_customer_id' + ': ' + label_
        : 'talkative_customer_id',
      talkativeCustomerId
    )
  );
  return messages;
}

function assertPaymentMethod(paymentMethod, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'ESo9aMY6Dg',
      label_ ? 'payment_method' + ': ' + label_ : 'payment_method',
      paymentMethod
    )
  );
  if (
    'Credit Card' !== paymentMethod &&
    'Synchrony' !== paymentMethod &&
    'Apple Pay' !== paymentMethod &&
    'Affirm' !== paymentMethod &&
    'Net' !== paymentMethod &&
    'No Payment Required' !== paymentMethod &&
    'Other (CSAT)' !== paymentMethod &&
    'Stock' !== paymentMethod &&
    'Other (Marketing)' !== paymentMethod &&
    'Promotion' !== paymentMethod &&
    'Net 30' !== paymentMethod &&
    '50%' !== paymentMethod &&
    'Other (Employee)' !== paymentMethod &&
    'Check' !== paymentMethod &&
    'COD' !== paymentMethod &&
    'Fortiva' !== paymentMethod &&
    'On Hold' !== paymentMethod &&
    'Amazon' !== paymentMethod &&
    'PayPal' !== paymentMethod
  ) {
    var message =
      (label_ ? 'payment_method' + ': ' + label_ : 'payment_method') +
      ' should match one of the following values [ Credit Card | Synchrony | Apple Pay | Affirm | Net | No Payment Required | Other (CSAT) | Stock | Other (Marketing) | Promotion | Net 30 | 50% | Other (Employee) | Check | COD | Fortiva | On Hold | Amazon | PayPal ] but you provided the value ' +
      paymentMethod;
    messages = messages.concat([
      {
        tag: 'expectedStringMatch',
        propertyId: 'ESo9aMY6Dg',
        message: message,
      },
    ]);
  }
  return messages;
}

function assertName(name, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'EghVtONPP',
      label_ ? 'name' + ': ' + label_ : 'name',
      name
    )
  );
  return messages;
}

function assertOptionalName(name, label_) {
  var messages = [];
  if (name !== undefined && name !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        'EghVtONPP',
        label_ ? 'name' + ': ' + label_ : 'name',
        name
      )
    );
  }
  return messages;
}

function assertAffiliation(affiliation, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'EloKvEAu8Y',
      label_ ? 'affiliation' + ': ' + label_ : 'affiliation',
      affiliation
    )
  );
  return messages;
}

function assertOptionalImageIndex(imageIndex, label_) {
  var messages = [];
  if (imageIndex !== undefined && imageIndex !== null) {
    messages = messages.concat(
      AvoAssert.assertInt(
        'EvbevBHEwEUhoozp05cYk',
        label_ ? 'image_index' + ': ' + label_ : 'image_index',
        imageIndex
      )
    );
  }
  return messages;
}

function assertFullPrice(fullPrice, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertFloat(
      'F_0zRLZY6n',
      label_ ? 'full_price' + ': ' + label_ : 'full_price',
      fullPrice
    )
  );
  return messages;
}

function assertOptionalFullPrice(fullPrice, label_) {
  var messages = [];
  if (fullPrice !== undefined && fullPrice !== null) {
    messages = messages.concat(
      AvoAssert.assertFloat(
        'F_0zRLZY6n',
        label_ ? 'full_price' + ': ' + label_ : 'full_price',
        fullPrice
      )
    );
  }
  return messages;
}

function assertIsDecideLater(isDecideLater, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertBool(
      'Fwb-BjQjH1V',
      label_ ? 'is_decide_later' + ': ' + label_ : 'is_decide_later',
      isDecideLater
    )
  );
  return messages;
}

function assertOptionalIsDecideLater(isDecideLater, label_) {
  var messages = [];
  if (isDecideLater !== undefined && isDecideLater !== null) {
    messages = messages.concat(
      AvoAssert.assertBool(
        'Fwb-BjQjH1V',
        label_ ? 'is_decide_later' + ': ' + label_ : 'is_decide_later',
        isDecideLater
      )
    );
  }
  return messages;
}

function assertValue(value, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'Ga6x7Tn-b9',
      label_ ? 'value' + ': ' + label_ : 'value',
      value
    )
  );
  return messages;
}

function assertOptionalAssociateId(associateId, label_) {
  var messages = [];
  if (associateId !== undefined && associateId !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        'H-g_LoQM0',
        label_ ? 'associate_id' + ': ' + label_ : 'associate_id',
        associateId
      )
    );
  }
  return messages;
}

function assertRevenue(revenue, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertFloat(
      'Hg5Zjuw2cd',
      label_ ? 'revenue' + ': ' + label_ : 'revenue',
      revenue
    )
  );
  return messages;
}

function assertCartId(cartId, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'KALt_3pVFV',
      label_ ? 'cart_id' + ': ' + label_ : 'cart_id',
      cartId
    )
  );
  return messages;
}

function assertOptionalTrackingNumber(trackingNumber, label_) {
  var messages = [];
  if (trackingNumber !== undefined && trackingNumber !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        'KwMPoO_BRg',
        label_ ? 'tracking_number' + ': ' + label_ : 'tracking_number',
        trackingNumber
      )
    );
  }
  return messages;
}

function assertOptionalPromotionName(promotionName, label_) {
  var messages = [];
  if (promotionName !== undefined && promotionName !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        'L7_EDDBWXi',
        label_ ? 'promotion_name' + ': ' + label_ : 'promotion_name',
        promotionName
      )
    );
  }
  return messages;
}

function assertContentIds(contentIds, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertList('L98Svx9Tq_', 'content_ids', contentIds)
  );
  if (contentIds !== null && contentIds !== undefined && contentIds.forEach) {
    contentIds.forEach(function(value, index) {});
  }
  return messages;
}

function assertPageType(pageType, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'LSca24_upS',
      label_ ? 'page_type' + ': ' + label_ : 'page_type',
      pageType
    )
  );
  if (
    'Home' !== pageType &&
    'PDP' !== pageType &&
    'Category' !== pageType &&
    'Cart' !== pageType &&
    'Other' !== pageType &&
    'Customer Photos' !== pageType
  ) {
    var message =
      (label_ ? 'page_type' + ': ' + label_ : 'page_type') +
      ' should match one of the following values [ Home | PDP | Category | Cart | Other | Customer Photos ] but you provided the value ' +
      pageType;
    messages = messages.concat([
      {
        tag: 'expectedStringMatch',
        propertyId: 'LSca24_upS',
        message: message,
      },
    ]);
  }
  return messages;
}

function assertExperimentTrackingRoute(experimentTrackingRoute, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'LYznC_8HTG',
      label_
        ? 'experiment_tracking_route' + ': ' + label_
        : 'experiment_tracking_route',
      experimentTrackingRoute
    )
  );
  return messages;
}

function assertHasProtectionPlan(hasProtectionPlan, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertBool(
      'MoIQmnL5AHl',
      label_ ? 'has_protection_plan' + ': ' + label_ : 'has_protection_plan',
      hasProtectionPlan
    )
  );
  return messages;
}

function assertOptionalHasProtectionPlan(hasProtectionPlan, label_) {
  var messages = [];
  if (hasProtectionPlan !== undefined && hasProtectionPlan !== null) {
    messages = messages.concat(
      AvoAssert.assertBool(
        'MoIQmnL5AHl',
        label_ ? 'has_protection_plan' + ': ' + label_ : 'has_protection_plan',
        hasProtectionPlan
      )
    );
  }
  return messages;
}

function assertOptionalLifestyleGalleryOpened(lifestyleGalleryOpened, label_) {
  var messages = [];
  if (lifestyleGalleryOpened !== undefined && lifestyleGalleryOpened !== null) {
    messages = messages.concat(
      AvoAssert.assertBool(
        'NBu0amJ6z4HGuuABGnHFB',
        label_
          ? 'lifestyle_gallery_opened' + ': ' + label_
          : 'lifestyle_gallery_opened',
        lifestyleGalleryOpened
      )
    );
  }
  return messages;
}

function assertDeliveryTimeDelta(deliveryTimeDelta, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertInt(
      'NWs1kmYygx',
      label_ ? 'delivery_time_delta' + ': ' + label_ : 'delivery_time_delta',
      deliveryTimeDelta
    )
  );
  return messages;
}

function assertIsProtectionPlanEligible(isProtectionPlanEligible, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertBool(
      'NdU9dcPzjy',
      label_
        ? 'is_protection_plan_eligible' + ': ' + label_
        : 'is_protection_plan_eligible',
      isProtectionPlanEligible
    )
  );
  return messages;
}

function assertOptionalIsProtectionPlanEligible(
  isProtectionPlanEligible,
  label_
) {
  var messages = [];
  if (
    isProtectionPlanEligible !== undefined &&
    isProtectionPlanEligible !== null
  ) {
    messages = messages.concat(
      AvoAssert.assertBool(
        'NdU9dcPzjy',
        label_
          ? 'is_protection_plan_eligible' + ': ' + label_
          : 'is_protection_plan_eligible',
        isProtectionPlanEligible
      )
    );
  }
  return messages;
}

function assertOptionalOpenStateActivated(openStateActivated, label_) {
  var messages = [];
  if (openStateActivated !== undefined && openStateActivated !== null) {
    messages = messages.concat(
      AvoAssert.assertBool(
        'Nhnz3V8o29gKWOcn5w_py',
        label_
          ? 'open_state_activated' + ': ' + label_
          : 'open_state_activated',
        openStateActivated
      )
    );
  }
  return messages;
}

function assertAddressLine1(addressLine1, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'O8elzNnkN2',
      label_ ? 'address_line_1' + ': ' + label_ : 'address_line_1',
      addressLine1
    )
  );
  return messages;
}

function assertConversationId(conversationId, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'OL7LDS0Icb',
      label_ ? 'conversation_id' + ': ' + label_ : 'conversation_id',
      conversationId
    )
  );
  return messages;
}

function assertShippingAddress(shippingAddress, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertObject(
      'PuQh3C0Z5M',
      label_ ? 'shipping_address' + ': ' + label_ : 'shipping_address',
      shippingAddress
    )
  );
  if (shippingAddress !== null && shippingAddress !== undefined) {
    messages = messages.concat(
      assertOptionalAddressName(shippingAddress.addressName, label_)
    );
    messages = messages.concat(
      assertAddressLine1(shippingAddress.addressLine1, label_)
    );
    messages = messages.concat(
      assertOptionalAddressLine2(shippingAddress.addressLine2, label_)
    );
    messages = messages.concat(assertCity(shippingAddress.city, label_));
    messages = messages.concat(assertState(shippingAddress.state, label_));
    messages = messages.concat(assertZip(shippingAddress.zip, label_));
    messages = messages.concat(assertCountry(shippingAddress.country, label_));
    messages = messages.concat(
      assertOptionalCompany(shippingAddress.company, label_)
    );
  }
  return messages;
}

function assertOrderId(orderId, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'Qo1JxjBu_f',
      label_ ? 'order_id' + ': ' + label_ : 'order_id',
      orderId
    )
  );
  return messages;
}

function assertCouponName(couponName, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'QpXvpQ98wn',
      label_ ? 'coupon_name' + ': ' + label_ : 'coupon_name',
      couponName
    )
  );
  return messages;
}

function assertQuestionNum(questionNum, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertFloat(
      'Qq4x6JX4TD',
      label_ ? 'question_num' + ': ' + label_ : 'question_num',
      questionNum
    )
  );
  return messages;
}

function assertFirstName(firstName, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'RD7HJjbic2',
      label_ ? 'first_name' + ': ' + label_ : 'first_name',
      firstName
    )
  );
  return messages;
}

function assertState(state, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'Sy9VxdW7ja',
      label_ ? 'state' + ': ' + label_ : 'state',
      state
    )
  );
  return messages;
}

function assertOptionalCoupon(coupon, label_) {
  var messages = [];
  if (coupon !== undefined && coupon !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        'TQ69bIm2Z6',
        label_ ? 'coupon' + ': ' + label_ : 'coupon',
        coupon
      )
    );
  }
  return messages;
}

function assertExperimentName(experimentName, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'UC9O3p1ESQ',
      label_ ? 'experiment_name' + ': ' + label_ : 'experiment_name',
      experimentName
    )
  );
  return messages;
}

function assertPlanName(planName, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'VXbdbXehgF',
      label_ ? 'plan_name' + ': ' + label_ : 'plan_name',
      planName
    )
  );
  if ('Life Happens' !== planName && 'Pet Protector' !== planName) {
    var message =
      (label_ ? 'plan_name' + ': ' + label_ : 'plan_name') +
      ' should match one of the following values [ Life Happens | Pet Protector ] but you provided the value ' +
      planName;
    messages = messages.concat([
      {
        tag: 'expectedStringMatch',
        propertyId: 'VXbdbXehgF',
        message: message,
      },
    ]);
  }
  return messages;
}

function assertQuizId(quizId, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertInt(
      'VZ0flBwsah',
      label_ ? 'quiz_id' + ': ' + label_ : 'quiz_id',
      quizId
    )
  );
  return messages;
}

function assertStep(step, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertInt(
      'WZE-XiY0e',
      label_ ? 'step' + ': ' + label_ : 'step',
      step
    )
  );
  return messages;
}

function assertCategoryId(categoryId, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertInt(
      'XJ78zva-wm',
      label_ ? 'category_id' + ': ' + label_ : 'category_id',
      categoryId
    )
  );
  return messages;
}

function assertOptionalGoogleNewCustomer(googleNewCustomer, label_) {
  var messages = [];
  if (googleNewCustomer !== undefined && googleNewCustomer !== null) {
    messages = messages.concat(
      AvoAssert.assertBool(
        'XX9y4M_XSif637S-FbIUV',
        label_ ? 'google_new_customer' + ': ' + label_ : 'google_new_customer',
        googleNewCustomer
      )
    );
  }
  return messages;
}

function assertQuestion(question, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'YkO40sXpE1',
      label_ ? 'question' + ': ' + label_ : 'question',
      question
    )
  );
  return messages;
}

function assertOptionalShippingCarrier(shippingCarrier, label_) {
  var messages = [];
  if (shippingCarrier !== undefined && shippingCarrier !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        'YsXH4GchTs',
        label_ ? 'shipping_carrier' + ': ' + label_ : 'shipping_carrier',
        shippingCarrier
      )
    );
  }
  return messages;
}

function assertOptedInMarketing(optedInMarketing, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertBool(
      'YzWHuN55jX',
      label_ ? 'opted_in_marketing' + ': ' + label_ : 'opted_in_marketing',
      optedInMarketing
    )
  );
  return messages;
}

function assertSearchTarget(searchTarget, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'Z-u59gjnyQ',
      label_ ? 'search_target' + ': ' + label_ : 'search_target',
      searchTarget
    )
  );
  if (
    'Product Grid' !== searchTarget &&
    'Other Results Link' !== searchTarget &&
    'Full Results' !== searchTarget &&
    'Exit Search' !== searchTarget
  ) {
    var message =
      (label_ ? 'search_target' + ': ' + label_ : 'search_target') +
      ' should match one of the following values [ Product Grid | Other Results Link | Full Results | Exit Search ] but you provided the value ' +
      searchTarget;
    messages = messages.concat([
      {
        tag: 'expectedStringMatch',
        propertyId: 'Z-u59gjnyQ',
        message: message,
      },
    ]);
  }
  return messages;
}

function assertOptionalCampaignUtmSource(campaignUtmSource, label_) {
  var messages = [];
  if (campaignUtmSource !== undefined && campaignUtmSource !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        'ZC-o592Ouy',
        label_ ? 'campaign_utm_source' + ': ' + label_ : 'campaign_utm_source',
        campaignUtmSource
      )
    );
  }
  return messages;
}

function assertDeliveryTimeEarliest(deliveryTimeEarliest, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertInt(
      'ZMn0Du3WX9',
      label_
        ? 'delivery_time_earliest' + ': ' + label_
        : 'delivery_time_earliest',
      deliveryTimeEarliest
    )
  );
  return messages;
}

function assertTotal(total, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertFloat(
      'ZUmhrqQhkt',
      label_ ? 'total' + ': ' + label_ : 'total',
      total
    )
  );
  return messages;
}

function assertCta(cta, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'ZrQHFev1wX',
      label_ ? 'cta' + ': ' + label_ : 'cta',
      cta
    )
  );
  if (
    'Room Builder' !== cta &&
    'Full Screen View' !== cta &&
    'Financing' !== cta &&
    'Comparison Tool' !== cta &&
    '3D Viewer' !== cta &&
    'Retail Store' !== cta &&
    'Room Refresh' !== cta &&
    'Dismiss' !== cta &&
    'Business' !== cta &&
    'Submit Trade Application' !== cta
  ) {
    var message =
      (label_ ? 'cta' + ': ' + label_ : 'cta') +
      ' should match one of the following values [ Room Builder | Full Screen View | Financing | Comparison Tool | 3D Viewer | Retail Store | Room Refresh | Dismiss | Business | Submit Trade Application ] but you provided the value ' +
      cta;
    messages = messages.concat([
      {
        tag: 'expectedStringMatch',
        propertyId: 'ZrQHFev1wX',
        message: message,
      },
    ]);
  }
  return messages;
}

function assertCountry(country, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      '_Di-rVVVJN',
      label_ ? 'country' + ': ' + label_ : 'country',
      country
    )
  );
  return messages;
}

function assertCookieSize(cookieSize, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertInt(
      '_bUst-pVux',
      label_ ? 'cookie_size' + ': ' + label_ : 'cookie_size',
      cookieSize
    )
  );
  return messages;
}

function assertQuery(query, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'aIgVffpGJ1',
      label_ ? 'query' + ': ' + label_ : 'query',
      query
    )
  );
  return messages;
}

function assertListId(listId, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'aQjbzLPQy',
      label_ ? 'list_id' + ': ' + label_ : 'list_id',
      listId
    )
  );
  return messages;
}

function assertCustomDestinationPageName_(customDestinationPageName_, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'avo-enriched-type-page-custom-name',
      label_
        ? 'Custom Destination Page Name' + ': ' + label_
        : 'Custom Destination Page Name',
      customDestinationPageName_
    )
  );
  return messages;
}

function assertUserId_(userId_, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'avo-enriched-type-user-id',
      label_ ? 'User Id' + ': ' + label_ : 'User Id',
      userId_
    )
  );
  return messages;
}

function assertType(type, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'ay-Gx5bwiX',
      label_ ? 'type' + ': ' + label_ : 'type',
      type
    )
  );
  return messages;
}

function assertPosition(position, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertInt(
      'b6TXkvaohp',
      label_ ? 'position' + ': ' + label_ : 'position',
      position
    )
  );
  return messages;
}

function assertDiscount(discount, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertFloat(
      'brVZTOFd99',
      label_ ? 'discount' + ': ' + label_ : 'discount',
      discount
    )
  );
  return messages;
}

function assertFabricColor(fabricColor, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'cZN2CHE3RG',
      label_ ? 'fabric_color' + ': ' + label_ : 'fabric_color',
      fabricColor
    )
  );
  return messages;
}

function assertOptionalFabricColor(fabricColor, label_) {
  var messages = [];
  if (fabricColor !== undefined && fabricColor !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        'cZN2CHE3RG',
        label_ ? 'fabric_color' + ': ' + label_ : 'fabric_color',
        fabricColor
      )
    );
  }
  return messages;
}

function assertOptionalCampaignUtmContent(campaignUtmContent, label_) {
  var messages = [];
  if (campaignUtmContent !== undefined && campaignUtmContent !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        'cehAl0GP3c',
        label_
          ? 'campaign_utm_content' + ': ' + label_
          : 'campaign_utm_content',
        campaignUtmContent
      )
    );
  }
  return messages;
}

function assertOptionalRoomName(roomName, label_) {
  var messages = [];
  if (roomName !== undefined && roomName !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        'cxALF7UPor',
        label_ ? 'room_name' + ': ' + label_ : 'room_name',
        roomName
      )
    );
  }
  return messages;
}

function assertOptionalRequestPage(requestPage, label_) {
  var messages = [];
  if (requestPage !== undefined && requestPage !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        'dWamj6Ugcm',
        label_ ? 'request_page' + ': ' + label_ : 'request_page',
        requestPage
      )
    );
  }
  return messages;
}

function assertOptionalSwatchList(swatchList, label_) {
  var messages = [];
  if (swatchList !== undefined && swatchList !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        'eRixxFmBU',
        label_ ? 'swatch_list' + ': ' + label_ : 'swatch_list',
        swatchList
      )
    );
  }
  return messages;
}

function assertOptionalCampaignUtmCampaign(campaignUtmCampaign, label_) {
  var messages = [];
  if (campaignUtmCampaign !== undefined && campaignUtmCampaign !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        'hahjHVdW76',
        label_
          ? 'campaign_utm_campaign' + ': ' + label_
          : 'campaign_utm_campaign',
        campaignUtmCampaign
      )
    );
  }
  return messages;
}

function assertFavorited(favorited, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertBool(
      'hl2Uh6tCvm',
      label_ ? 'favorited' + ': ' + label_ : 'favorited',
      favorited
    )
  );
  return messages;
}

function assertTitle(title, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'ila-C3CyQj',
      label_ ? 'title' + ': ' + label_ : 'title',
      title
    )
  );
  return messages;
}

function assertOptionalArStarted(arStarted, label_) {
  var messages = [];
  if (arStarted !== undefined && arStarted !== null) {
    messages = messages.concat(
      AvoAssert.assertBool(
        'iogUfmRrHgxOuwV7mmJch',
        label_ ? 'ar_started' + ': ' + label_ : 'ar_started',
        arStarted
      )
    );
  }
  return messages;
}

function assertPrice(price, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertFloat(
      'j-kP3_J7Rb',
      label_ ? 'price' + ': ' + label_ : 'price',
      price
    )
  );
  return messages;
}

function assertOptionalPrice(price, label_) {
  var messages = [];
  if (price !== undefined && price !== null) {
    messages = messages.concat(
      AvoAssert.assertFloat(
        'j-kP3_J7Rb',
        label_ ? 'price' + ': ' + label_ : 'price',
        price
      )
    );
  }
  return messages;
}

function assertOptionalZoomedInteracted(zoomedInteracted, label_) {
  var messages = [];
  if (zoomedInteracted !== undefined && zoomedInteracted !== null) {
    messages = messages.concat(
      AvoAssert.assertBool(
        'kwRtnkOtKKkvFrtXNgdZd',
        label_ ? 'zoomed_interacted' + ': ' + label_ : 'zoomed_interacted',
        zoomedInteracted
      )
    );
  }
  return messages;
}

function assertOptionalOptedInSmsMarketing(optedInSmsMarketing, label_) {
  var messages = [];
  if (optedInSmsMarketing !== undefined && optedInSmsMarketing !== null) {
    messages = messages.concat(
      AvoAssert.assertBool(
        'lTV3tSML1r7ZBl230680k',
        label_
          ? 'opted_in_sms_marketing' + ': ' + label_
          : 'opted_in_sms_marketing',
        optedInSmsMarketing
      )
    );
  }
  return messages;
}

function assertExperimentId(experimentId, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'lfH3EWVPWS',
      label_ ? 'experiment_id' + ': ' + label_ : 'experiment_id',
      experimentId
    )
  );
  return messages;
}

function assertFilters(filters, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertList('lq0PSuvEbT', 'filters', filters)
  );
  if (filters !== null && filters !== undefined && filters.forEach) {
    filters.forEach(function(value, index) {
      messages = messages.concat(
        AvoAssert.assertObject(
          'lq0PSuvEbT',
          'item at index ' + index + ' in filters',
          value
        )
      );
      messages = messages.concat(
        assertValue(value.value, 'item at index ' + index + ' in filters')
      );
      messages = messages.concat(
        assertType(value.type, 'item at index ' + index + ' in filters')
      );
    });
  }
  return messages;
}

function assertCurrency(currency, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'mEnst5CFw',
      label_ ? 'currency' + ': ' + label_ : 'currency',
      currency
    )
  );
  if ('USD' !== currency && 'CAD' !== currency) {
    var message =
      (label_ ? 'currency' + ': ' + label_ : 'currency') +
      ' should match one of the following values [ USD | CAD ] but you provided the value ' +
      currency;
    messages = messages.concat([
      { tag: 'expectedStringMatch', propertyId: 'mEnst5CFw', message: message },
    ]);
  }
  return messages;
}

function assertProductId(productId, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertInt(
      'nHu4WfjB0w',
      label_ ? 'product_id' + ': ' + label_ : 'product_id',
      productId
    )
  );
  return messages;
}

function assertOptionalProductId(productId, label_) {
  var messages = [];
  if (productId !== undefined && productId !== null) {
    messages = messages.concat(
      AvoAssert.assertInt(
        'nHu4WfjB0w',
        label_ ? 'product_id' + ': ' + label_ : 'product_id',
        productId
      )
    );
  }
  return messages;
}

function assertPlanPrice(planPrice, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertFloat(
      'nKky3DTbmP',
      label_ ? 'plan_price' + ': ' + label_ : 'plan_price',
      planPrice
    )
  );
  return messages;
}

function assertText(text, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'nNUWXhOcId',
      label_ ? 'text' + ': ' + label_ : 'text',
      text
    )
  );
  return messages;
}

function assertOptionalIterableCampaignId(iterableCampaignId, label_) {
  var messages = [];
  if (iterableCampaignId !== undefined && iterableCampaignId !== null) {
    messages = messages.concat(
      AvoAssert.assertInt(
        'nkw4-m74P9',
        label_
          ? 'iterable_campaign_id' + ': ' + label_
          : 'iterable_campaign_id',
        iterableCampaignId
      )
    );
  }
  return messages;
}

function assertTargetUrl(targetUrl, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'oO5OZf_XuJ',
      label_ ? 'target_url' + ': ' + label_ : 'target_url',
      targetUrl
    )
  );
  return messages;
}

function assertIsFlashSale(isFlashSale, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertBool(
      'ocjd8V8Of8',
      label_ ? 'is_flash_sale' + ': ' + label_ : 'is_flash_sale',
      isFlashSale
    )
  );
  return messages;
}

function assertSorts(sorts, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertList('pnGgVwJOHO', 'sorts', sorts)
  );
  if (sorts !== null && sorts !== undefined && sorts.forEach) {
    sorts.forEach(function(value, index) {
      messages = messages.concat(
        AvoAssert.assertObject(
          'pnGgVwJOHO',
          'item at index ' + index + ' in sorts',
          value
        )
      );
      messages = messages.concat(
        assertValue(value.value, 'item at index ' + index + ' in sorts')
      );
      messages = messages.concat(
        assertType(value.type, 'item at index ' + index + ' in sorts')
      );
    });
  }
  return messages;
}

function assertQuickship(quickship, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertBool(
      'q2dBEu8QaF',
      label_ ? 'quickship' + ': ' + label_ : 'quickship',
      quickship
    )
  );
  return messages;
}

function assertReason(reason, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'qcqKEsz6p4',
      label_ ? 'reason' + ': ' + label_ : 'reason',
      reason
    )
  );
  return messages;
}

function assertTrackingUrl(trackingUrl, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'r0tvvT0Yd7',
      label_ ? 'tracking_url' + ': ' + label_ : 'tracking_url',
      trackingUrl
    )
  );
  return messages;
}

function assertOptionalTrackingUrl(trackingUrl, label_) {
  var messages = [];
  if (trackingUrl !== undefined && trackingUrl !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        'r0tvvT0Yd7',
        label_ ? 'tracking_url' + ': ' + label_ : 'tracking_url',
        trackingUrl
      )
    );
  }
  return messages;
}

function assertQuantity(quantity, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertInt(
      'r7TPl6ZqL8',
      label_ ? 'quantity' + ': ' + label_ : 'quantity',
      quantity
    )
  );
  return messages;
}

function assertExperimentGroup(experimentGroup, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertInt(
      'r8JNfMSYYf',
      label_ ? 'experiment_group' + ': ' + label_ : 'experiment_group',
      experimentGroup
    )
  );
  return messages;
}

function assertProducts(products, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertList('rGITDesDtb', 'products', products)
  );
  if (products !== null && products !== undefined && products.forEach) {
    products.forEach(function(value, index) {
      messages = messages.concat(
        AvoAssert.assertObject(
          'rGITDesDtb',
          'item at index ' + index + ' in products',
          value
        )
      );
      messages = messages.concat(
        assertProductId(
          value.productId,
          'item at index ' + index + ' in products'
        )
      );
      messages = messages.concat(
        assertCategory(
          value.category,
          'item at index ' + index + ' in products'
        )
      );
      messages = messages.concat(
        assertOptionalIsClearance(
          value.isClearance,
          'item at index ' + index + ' in products'
        )
      );
      messages = messages.concat(
        assertName(value.name, 'item at index ' + index + ' in products')
      );
      messages = messages.concat(
        assertPrice(value.price, 'item at index ' + index + ' in products')
      );
      messages = messages.concat(
        assertQuantity(
          value.quantity,
          'item at index ' + index + ' in products'
        )
      );
      messages = messages.concat(
        assertSku(value.sku, 'item at index ' + index + ' in products')
      );
      messages = messages.concat(
        assertOptionalVariant(
          value.variant,
          'item at index ' + index + ' in products'
        )
      );
      messages = messages.concat(
        assertOptionalIsProtectionPlanEligible(
          value.isProtectionPlanEligible,
          'item at index ' + index + ' in products'
        )
      );
      messages = messages.concat(
        assertOptionalHasProtectionPlan(
          value.hasProtectionPlan,
          'item at index ' + index + ' in products'
        )
      );
      messages = messages.concat(
        assertOptionalIsDecideLater(
          value.isDecideLater,
          'item at index ' + index + ' in products'
        )
      );
      messages = messages.concat(
        assertOptionalTrackingUrl(
          value.trackingUrl,
          'item at index ' + index + ' in products'
        )
      );
      messages = messages.concat(
        assertOptionalTrackingNumber(
          value.trackingNumber,
          'item at index ' + index + ' in products'
        )
      );
      messages = messages.concat(
        assertOptionalProtectionPlanCost(
          value.protectionPlanCost,
          'item at index ' + index + ' in products'
        )
      );
      messages = messages.concat(
        assertOptionalDeliveryType(
          value.deliveryType,
          'item at index ' + index + ' in products'
        )
      );
      messages = messages.concat(
        assertOptionalShippingMethod(
          value.shippingMethod,
          'item at index ' + index + ' in products'
        )
      );
      messages = messages.concat(
        assertOptionalShippingCarrier(
          value.shippingCarrier,
          'item at index ' + index + ' in products'
        )
      );
      messages = messages.concat(
        assertOptionalFabricName(
          value.fabricName,
          'item at index ' + index + ' in products'
        )
      );
      messages = messages.concat(
        assertOptionalFabricColor(
          value.fabricColor,
          'item at index ' + index + ' in products'
        )
      );
      messages = messages.concat(
        assertCurrency(
          value.currency,
          'item at index ' + index + ' in products'
        )
      );
      messages = messages.concat(
        assertFullPrice(
          value.fullPrice,
          'item at index ' + index + ' in products'
        )
      );
      messages = messages.concat(
        assertIsFlashSale(
          value.isFlashSale,
          'item at index ' + index + ' in products'
        )
      );
      messages = messages.concat(
        assertGoogleProductCategory(
          value.googleProductCategory,
          'item at index ' + index + ' in products'
        )
      );
    });
  }
  return messages;
}

function assertProductFamily(productFamily, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'rYLq0zrdEe',
      label_ ? 'product_family' + ': ' + label_ : 'product_family',
      productFamily
    )
  );
  return messages;
}

function assertOptionalProductFamily(productFamily, label_) {
  var messages = [];
  if (productFamily !== undefined && productFamily !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        'rYLq0zrdEe',
        label_ ? 'product_family' + ': ' + label_ : 'product_family',
        productFamily
      )
    );
  }
  return messages;
}

function assertOptionalError(error, label_) {
  var messages = [];
  if (error !== undefined && error !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        'scucIInsa',
        label_ ? 'error' + ': ' + label_ : 'error',
        error
      )
    );
  }
  return messages;
}

function assertSku(sku, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'uI2-rwjYtt',
      label_ ? 'sku' + ': ' + label_ : 'sku',
      sku
    )
  );
  return messages;
}

function assertHashedEmail(hashedEmail, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'uO4O8vJeKW',
      label_ ? 'hashed_email' + ': ' + label_ : 'hashed_email',
      hashedEmail
    )
  );
  return messages;
}

function assertDeliveryTimeLatest(deliveryTimeLatest, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertInt(
      'uXclLHai_L',
      label_ ? 'delivery_time_latest' + ': ' + label_ : 'delivery_time_latest',
      deliveryTimeLatest
    )
  );
  return messages;
}

function assertGoogleProductCategory(googleProductCategory, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'vaWiuR41RoGc8FaMrF5pT',
      label_
        ? 'google_product_category' + ': ' + label_
        : 'google_product_category',
      googleProductCategory
    )
  );
  return messages;
}

function assertOptionalFabricId(fabricId, label_) {
  var messages = [];
  if (fabricId !== undefined && fabricId !== null) {
    messages = messages.concat(
      AvoAssert.assertInt(
        'vl8jHhQKP6',
        label_ ? 'fabric_id' + ': ' + label_ : 'fabric_id',
        fabricId
      )
    );
  }
  return messages;
}

function assertFabricId(fabricId, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertInt(
      'vl8jHhQKP6',
      label_ ? 'fabric_id' + ': ' + label_ : 'fabric_id',
      fabricId
    )
  );
  return messages;
}

function assertOptionalIterableTemplateId(iterableTemplateId, label_) {
  var messages = [];
  if (iterableTemplateId !== undefined && iterableTemplateId !== null) {
    messages = messages.concat(
      AvoAssert.assertInt(
        'w9JwEo_jAXP',
        label_
          ? 'iterable_template_id' + ': ' + label_
          : 'iterable_template_id',
        iterableTemplateId
      )
    );
  }
  return messages;
}

function assertOptionalComponent(component, label_) {
  var messages = [];
  if (component !== undefined && component !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        'wRrJhFCX_U',
        label_ ? 'component' + ': ' + label_ : 'component',
        component
      )
    );
    if (
      'Product Recommendation Carousel' !== component &&
      'Recently Viewed Carousel' !== component &&
      'Best Sellers Carousel' !== component &&
      'Collection Carousel' !== component &&
      'Navbar' !== component &&
      'Product to Product Carousel' !== component &&
      'Product Card' !== component &&
      'Cart' !== component &&
      'Justuno' !== component &&
      'Newsletter Signup' !== component &&
      'Swatch Request' !== component &&
      'Share Cart' !== component &&
      'Account Creation' !== component &&
      'Product Grid' !== component &&
      'Quickview Modal' !== component &&
      'Side Panel' !== component &&
      'Delivery Update' !== component &&
      'Trade Newsletter Signup' !== component &&
      'Trade Application' !== component
    ) {
      var message =
        (label_ ? 'component' + ': ' + label_ : 'component') +
        ' should match one of the following values [ Product Recommendation Carousel | Recently Viewed Carousel | Best Sellers Carousel | Collection Carousel | Navbar | Product to Product Carousel | Product Card | Cart | Justuno | Newsletter Signup | Swatch Request | Share Cart | Account Creation | Product Grid | Quickview Modal | Side Panel | Delivery Update | Trade Newsletter Signup | Trade Application ] but you provided the value ' +
        component;
      messages = messages.concat([
        {
          tag: 'expectedStringMatch',
          propertyId: 'wRrJhFCX_U',
          message: message,
        },
      ]);
    }
  }
  return messages;
}

function assertGiftAmount(giftAmount, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertInt(
      'wq1G4WR2aU',
      label_ ? 'gift_amount' + ': ' + label_ : 'gift_amount',
      giftAmount
    )
  );
  return messages;
}

function assertOptionalMessage(message, label_) {
  var messages = [];
  if (message !== undefined && message !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        'xOg92BnGoS',
        label_ ? 'message' + ': ' + label_ : 'message',
        message
      )
    );
  }
  return messages;
}

function assertOptionalAssociateEmployeeId(associateEmployeeId, label_) {
  var messages = [];
  if (associateEmployeeId !== undefined && associateEmployeeId !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        'ySpqRs9Laj',
        label_
          ? 'associate_employee_id' + ': ' + label_
          : 'associate_employee_id',
        associateEmployeeId
      )
    );
  }
  return messages;
}

function assertFabricName(fabricName, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'z-KPDmLIa_',
      label_ ? 'fabric_name' + ': ' + label_ : 'fabric_name',
      fabricName
    )
  );
  return messages;
}

function assertOptionalFabricName(fabricName, label_) {
  var messages = [];
  if (fabricName !== undefined && fabricName !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        'z-KPDmLIa_',
        label_ ? 'fabric_name' + ': ' + label_ : 'fabric_name',
        fabricName
      )
    );
  }
  return messages;
}

function assertCity(city, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'zE__6S8gVh',
      label_ ? 'city' + ': ' + label_ : 'city',
      city
    )
  );
  return messages;
}

function assertIsClearance(isClearance, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertBool(
      'zPeher-BjQ',
      label_ ? 'is_clearance' + ': ' + label_ : 'is_clearance',
      isClearance
    )
  );
  return messages;
}

function assertOptionalIsClearance(isClearance, label_) {
  var messages = [];
  if (isClearance !== undefined && isClearance !== null) {
    messages = messages.concat(
      AvoAssert.assertBool(
        'zPeher-BjQ',
        label_ ? 'is_clearance' + ': ' + label_ : 'is_clearance',
        isClearance
      )
    );
  }
  return messages;
}

function assertBackendEmail(backendEmail, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'zjUFB7hRiT',
      label_ ? 'backend_email' + ': ' + label_ : 'backend_email',
      backendEmail
    )
  );
  return messages;
}

function assertVariant(variant, label_) {
  var messages = [];
  messages = messages.concat(
    AvoAssert.assertString(
      'zsMuCAiZ4D',
      label_ ? 'variant' + ': ' + label_ : 'variant',
      variant
    )
  );
  return messages;
}

function assertOptionalVariant(variant, label_) {
  var messages = [];
  if (variant !== undefined && variant !== null) {
    messages = messages.concat(
      AvoAssert.assertString(
        'zsMuCAiZ4D',
        label_ ? 'variant' + ': ' + label_ : 'variant',
        variant
      )
    );
  }
  return messages;
}

function setAvoLogger(avoLogger) {
  __AVO_LOGGER__ = avoLogger;
}

var RudderstackJavascript;
function setup_(
  options,
  systemProperties,
  RudderstackJavascriptDestination,
  destinationOptions
) {
  __WEB_DEBUGGER__ = false;
  if (options.validateProperties === true) {
    __AVO_DEV__ = true;
  }

  destinationOptions = destinationOptions || {};

  if (!__AVO_NOOP__) {
    if (options.useProductionKey) {
    } else {
    }

    RudderstackJavascript = RudderstackJavascriptDestination;
    RudderstackJavascript.make(options.useProductionKey);
    if (__AVO_DEV__) {
      // debug console in Avo
      _avo_invoke_meta(__AVO_ENV__, 'setup', [], 'setup');
    }
  }
}

function initAvo(
  options,
  systemProperties,
  destinationOptions,
  RudderstackJavascriptDestination
) {
  if (__AVO_ENV__ !== null) {
    return;
  }
  __AVO_ENV__ = options.env.toLowerCase();
  if (options.avoLogger !== undefined) {
    __AVO_LOGGER__ = options.avoLogger;
  }
  if (options.noop === true) {
    __AVO_NOOP__ = true;
  }
  if (__AVO_NOOP__ && __AVO_ENV__ == 'prod') {
    InternalAvoLogger.warn(
      '****************************************************'
    );
    InternalAvoLogger.warn(
      'WARNING Avo cannot be initialized in noop mode in production:'
    );
    InternalAvoLogger.warn('- Overwriting configuration with noop=false.');
    InternalAvoLogger.warn(
      '- Please reach out if you want to be able to run Avo in production mode with noop=true'
    );
    InternalAvoLogger.warn(
      '****************************************************'
    );
    __AVO_NOOP__ = false;
  }
  if (__AVO_NOOP__) {
    InternalAvoLogger.log(
      '****************************************************'
    );
    InternalAvoLogger.log('Avo is now initialized in noop mode. This means:');
    InternalAvoLogger.log('- No events will be sent');
    InternalAvoLogger.log('- No network requests are made');
    InternalAvoLogger.log(
      '****************************************************'
    );
  }
  if (options.strict !== undefined) {
    __STRICT__ = options.strict !== false;
  }
  if (options.reportFailureAs !== undefined) {
    __REPORT_FAILURE_AS__ = options.reportFailureAs;
  }
  __WEB_DEBUGGER__ =
    !__AVO_NOOP__ &&
    ((typeof window !== 'undefined' &&
      window.location.search.indexOf('avo_debug=1') > -1) ||
      (options.webDebugger !== false && __AVO_ENV__ !== 'prod'));
  if (!__AVO_NOOP__ && options.inspector !== undefined) {
    __INSPECTOR__ = options.inspector;
  } else if (__AVO_ENV__ !== 'prod') {
    InternalAvoLogger.warn('Avo Inspector not provided in initAvo() call');
  }
  if (__AVO_ENV__ !== 'prod') {
    __AVO_DEV__ = true;
  }

  destinationOptions = destinationOptions || {};

  if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions && options.webDebuggerOptions.position) {
      const {
        BOTTOM_RIGHT,
        BOTTOM_LEFT,
        TOP_RIGHT,
        TOP_LEFT,
      } = WebDebuggerPosition.position;

      try {
        WebDebuggerAssertions.assertKey(
          options.webDebuggerOptions.position,
          'position',
          position => {
            return (
              position === BOTTOM_RIGHT ||
              position === BOTTOM_LEFT ||
              position === TOP_RIGHT ||
              position === TOP_LEFT
            );
          }
        );
      } catch (e) {
        throw new Error(
          'WebDebugger: Position object incorrect. Use methods from WebDebuggerPosition.'
        );
      }

      const top = options.webDebuggerOptions.position.top || 0;
      const right = options.webDebuggerOptions.position.right || 0;
      const bottom = options.webDebuggerOptions.position.bottom || 0;
      const left = options.webDebuggerOptions.position.left || 0;

      let positionParams;

      switch (options.webDebuggerOptions.position.position) {
        case BOTTOM_RIGHT:
          positionParams = {
            position: BOTTOM_RIGHT,
            bottom,
            right,
          };
          break;
        case BOTTOM_LEFT:
          positionParams = {
            position: BOTTOM_LEFT,
            bottom,
            left,
          };
          break;
        case TOP_RIGHT:
          positionParams = {
            position: TOP_RIGHT,
            top,
            right,
          };
          break;
        case TOP_LEFT:
          positionParams = {
            position: TOP_LEFT,
            top,
            left,
          };
          break;
        default:
          throw new Error(
            'WebDebugger: Position object incorrect. Use methods from WebDebuggerPosition.'
          );
      }

      _avo_debugger_send_position(positionParams);
    }

    (function() {
      if (typeof window === 'undefined') {
        return;
      }
      var init = function() {
        if (document.getElementById('avo-debugger') === null) {
          var iframe = document.createElement('iframe');
          document.body.appendChild(iframe);
          iframe.id = 'avo-debugger';
          iframe.src = 'https://www.avo.app/_debugger';
          iframe.style = 'display: none;';
        }
      };

      if (document.body) {
        init();
      } else {
        document.addEventListener('DOMContentLoaded', init);
      }
    })();
  }
  if (!__AVO_NOOP__) {
    if (__AVO_ENV__ === 'prod') {
    }
    if (__AVO_ENV__ === 'dev') {
    }

    RudderstackJavascript = RudderstackJavascriptDestination;
    if (__AVO_ENV__ === 'prod') {
      RudderstackJavascript.make &&
        RudderstackJavascript.make(__AVO_ENV__, '1oJKoBP5nPhAZzX9rfxLN9HZGAe');
    } else if (__AVO_ENV__ === 'dev') {
      RudderstackJavascript.make &&
        RudderstackJavascript.make(__AVO_ENV__, '1oJNZkODCRuGd4nIy06C4KQzgCU');
    } else {
      console[__REPORT_FAILURE_AS__ || 'error'](
        '[avo] No staging key is set for Rudderstack Javascript. Head to destination settings in Avo to set a staging key.'
      );
      RudderstackJavascript.make &&
        RudderstackJavascript.make(__AVO_ENV__, null);
    }
    if (__AVO_DEV__) {
      // debug console in Avo
      _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
    }
  }
}

/**
 * Order Completed: Fired when an order is confirmed to be completed.
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.userId_ - The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param {Array<object>} properties.products - A list of products.
 * @param {string} properties.affiliation - The store or affiliation from which this transaction occurred (e.g. 'Online', 'Brooklyn', etc.)
 * @param {string} [properties.coupon] - The coupon code used (i.e. 'SUMMER_SALE2020')
 * @param {int} properties.deliveryTimeDelta - The number of days between the `deliveryTimeEarliest` and `deliveryTimeLatest`
 * @param {int} properties.deliveryTimeEarliest - The earlier number of days a product will ship in from the current date (if today is Oct 7 and the estimated delivery is Oct 10 - Oct 15, the value should be 3)
 * @param {int} properties.deliveryTimeLatest - The later number of days a product will ship in from the current date (if today is the Oct 7 and the estimated delivery is Oct 10 - Oct 15, the value should be 8 (15-7 = 8))
 * @param {float} properties.discount - Total discount amount (i.e. 153.82)
 * @param {string} properties.orderId - The stringified order id
 * @param {string} properties.paymentMethod - Either 'Credit Card', 'Affirm', 'Synchrony', or 'Apply Pay' depending on the customer's checkout method on the front end or the payment type on the backend
 * @param {string} [properties.promotionName] - The name of the promotion (i.e. 'Labor Day Sale').
 * @param {string} properties.phone - Phone number in the format `1234567890`. May also be sent as a string in E.164 format (eg `+11234567890`) where required.
 * @param {float} properties.shipping - The price paid for shipping.
 * @param {float} properties.tax - The price paid for tax.
 * @param {float} properties.total - The grand total price of the order.
 * @param {float} properties.subtotal - Order total after discounts but before taxes and shipping
 * @param {float} properties.revenue - Revenue ($) associated with the transaction (excluding shipping and tax). This does include the price of protection plans.
 * @param {int} [properties.storeId] - Retail store id
 * Stores:
 * NY, Brooklyn: 1
 * DC, Logan Circle: 2
 * Serbia Office: 3
 * CHI, Lincoln Park: 4
 * @param {string} properties.cartId - The id of the cart (i.e. 194823)
 * @param {string} properties.currency - The currency (i.e. 'USD', 'CAD', etc.)
 * @param {string} properties.city - City name
 * @param {string} properties.state - State name
 * @param {string} properties.zip - Zipcode sent as a string
 * @param {string} [properties.talkativeCustomerId] - The site visitor's customer ID from Talkative, if the user used the on-site chat.
 * This information is stored in a cookie by Talkative: talkative_ecs__eu__[wildcard UUID]__customer__uuid
 * Additional documentation at https://support.gettalkative.com/knowledge/cookie-policy-1
 * @param {int} properties.giftAmount - The total amount that was paid using gift vouchers or gift coupons
 * @param {bool} [properties.googleNewCustomer] - check if the customer has make a purchased within 540 days
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/Ji7vj5-uX}
 */
export function orderCompleted(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertUserId_(properties.userId_));
    messages = messages.concat(assertProducts(properties.products));
    messages = messages.concat(assertAffiliation(properties.affiliation));
    messages = messages.concat(assertOptionalCoupon(properties.coupon));
    messages = messages.concat(
      assertDeliveryTimeDelta(properties.deliveryTimeDelta)
    );
    messages = messages.concat(
      assertDeliveryTimeEarliest(properties.deliveryTimeEarliest)
    );
    messages = messages.concat(
      assertDeliveryTimeLatest(properties.deliveryTimeLatest)
    );
    messages = messages.concat(assertDiscount(properties.discount));
    messages = messages.concat(assertOrderId(properties.orderId));
    messages = messages.concat(assertPaymentMethod(properties.paymentMethod));
    messages = messages.concat(
      assertOptionalPromotionName(properties.promotionName)
    );
    messages = messages.concat(assertPhone(properties.phone));
    messages = messages.concat(assertShipping(properties.shipping));
    messages = messages.concat(assertTax(properties.tax));
    messages = messages.concat(assertTotal(properties.total));
    messages = messages.concat(assertSubtotal(properties.subtotal));
    messages = messages.concat(assertRevenue(properties.revenue));
    messages = messages.concat(assertOptionalStoreId(properties.storeId));
    messages = messages.concat(assertCartId(properties.cartId));
    messages = messages.concat(assertCurrency(properties.currency));
    messages = messages.concat(assertCity(properties.city));
    messages = messages.concat(assertState(properties.state));
    messages = messages.concat(assertZip(properties.zip));
    messages = messages.concat(
      assertOptionalTalkativeCustomerId(properties.talkativeCustomerId)
    );
    messages = messages.concat(assertGiftAmount(properties.giftAmount));
    messages = messages.concat(
      assertOptionalGoogleNewCustomer(properties.googleNewCustomer)
    );
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Order Completed',
        Object.keys(properties),
        [
          'userId_',
          'products',
          'affiliation',
          'coupon',
          'deliveryTimeDelta',
          'deliveryTimeEarliest',
          'deliveryTimeLatest',
          'discount',
          'orderId',
          'paymentMethod',
          'promotionName',
          'phone',
          'shipping',
          'tax',
          'total',
          'subtotal',
          'revenue',
          'storeId',
          'cartId',
          'currency',
          'city',
          'state',
          'zip',
          'talkativeCustomerId',
          'giftAmount',
          'googleNewCustomer',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'Ji7vj5-uX',
        'ee0808140fc4fdc81a6d352260efedf2f72c811ff043207fca89476a4d29e74e',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Order Completed',
      {
        products: properties.products.map(function(value) {
          return {
            product_id: value.productId,
            category: value.category,
            is_clearance: value.isClearance,
            name: value.name,
            price: value.price,
            quantity: value.quantity,
            sku: value.sku,
            variant: value.variant,
            is_protection_plan_eligible: value.isProtectionPlanEligible,
            has_protection_plan: value.hasProtectionPlan,
            is_decide_later: value.isDecideLater,
            tracking_url: value.trackingUrl,
            tracking_number: value.trackingNumber,
            protection_plan_cost: value.protectionPlanCost,
            delivery_type: value.deliveryType,
            shipping_method: value.shippingMethod,
            shipping_carrier: value.shippingCarrier,
            fabric_name: value.fabricName,
            fabric_color: value.fabricColor,
            currency: value.currency,
            full_price: value.fullPrice,
            is_flash_sale: value.isFlashSale,
            google_product_category: value.googleProductCategory,
          };
        }),
        affiliation: properties.affiliation,
        coupon: properties.coupon,
        delivery_time_delta: properties.deliveryTimeDelta,
        delivery_time_earliest: properties.deliveryTimeEarliest,
        delivery_time_latest: properties.deliveryTimeLatest,
        discount: properties.discount,
        order_id: properties.orderId,
        payment_method: properties.paymentMethod,
        promotion_name: properties.promotionName,
        phone: properties.phone,
        shipping: properties.shipping,
        tax: properties.tax,
        total: properties.total,
        subtotal: properties.subtotal,
        revenue: properties.revenue,
        store_id: properties.storeId,
        cart_id: properties.cartId,
        currency: properties.currency,
        city: properties.city,
        state: properties.state,
        zip: properties.zip,
        talkative_customer_id: properties.talkativeCustomerId,
        gift_amount: properties.giftAmount,
        google_new_customer: properties.googleNewCustomer,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'Ji7vj5-uX',
        'Order Completed',
        messages,
        [
          {
            id: '-Be6jz-r5H',
            name: 'delivery_type',
            value: properties.deliveryType,
          },
          {
            id: '-r2A9Y6Dak',
            name: 'protection_plan_cost',
            value: properties.protectionPlanCost,
          },
          { id: '1PytrUAIdT', name: 'tax', value: properties.tax },
          { id: '2qM3Rh0Jhb', name: 'store_id', value: properties.storeId },
          { id: '3PXRzRK2KK', name: 'category', value: properties.category },
          {
            id: '4HTRW0TFrB',
            name: 'shipping_method',
            value: properties.shippingMethod,
          },
          { id: '4RK31aMrfu', name: 'shipping', value: properties.shipping },
          { id: '9LdTHkmJT', name: 'subtotal', value: properties.subtotal },
          { id: '9YayH8EfP9', name: 'zip', value: properties.zip },
          { id: 'CNxC4sfhlL', name: 'phone', value: properties.phone },
          {
            id: 'E46jtrSf8',
            name: 'talkative_customer_id',
            value: properties.talkativeCustomerId,
          },
          {
            id: 'ESo9aMY6Dg',
            name: 'payment_method',
            value: properties.paymentMethod,
          },
          { id: 'EghVtONPP', name: 'name', value: properties.name },
          {
            id: 'EloKvEAu8Y',
            name: 'affiliation',
            value: properties.affiliation,
          },
          { id: 'F_0zRLZY6n', name: 'full_price', value: properties.fullPrice },
          {
            id: 'Fwb-BjQjH1V',
            name: 'is_decide_later',
            value: properties.isDecideLater,
          },
          { id: 'Hg5Zjuw2cd', name: 'revenue', value: properties.revenue },
          { id: 'KALt_3pVFV', name: 'cart_id', value: properties.cartId },
          {
            id: 'KwMPoO_BRg',
            name: 'tracking_number',
            value: properties.trackingNumber,
          },
          {
            id: 'L7_EDDBWXi',
            name: 'promotion_name',
            value: properties.promotionName,
          },
          {
            id: 'MoIQmnL5AHl',
            name: 'has_protection_plan',
            value: properties.hasProtectionPlan,
          },
          {
            id: 'NWs1kmYygx',
            name: 'delivery_time_delta',
            value: properties.deliveryTimeDelta,
          },
          {
            id: 'NdU9dcPzjy',
            name: 'is_protection_plan_eligible',
            value: properties.isProtectionPlanEligible,
          },
          { id: 'Qo1JxjBu_f', name: 'order_id', value: properties.orderId },
          { id: 'Sy9VxdW7ja', name: 'state', value: properties.state },
          { id: 'TQ69bIm2Z6', name: 'coupon', value: properties.coupon },
          {
            id: 'XX9y4M_XSif637S-FbIUV',
            name: 'google_new_customer',
            value: properties.googleNewCustomer,
          },
          {
            id: 'YsXH4GchTs',
            name: 'shipping_carrier',
            value: properties.shippingCarrier,
          },
          {
            id: 'ZMn0Du3WX9',
            name: 'delivery_time_earliest',
            value: properties.deliveryTimeEarliest,
          },
          { id: 'ZUmhrqQhkt', name: 'total', value: properties.total },
          { id: 'brVZTOFd99', name: 'discount', value: properties.discount },
          {
            id: 'cZN2CHE3RG',
            name: 'fabric_color',
            value: properties.fabricColor,
          },
          { id: 'j-kP3_J7Rb', name: 'price', value: properties.price },
          { id: 'mEnst5CFw', name: 'currency', value: properties.currency },
          { id: 'nHu4WfjB0w', name: 'product_id', value: properties.productId },
          {
            id: 'ocjd8V8Of8',
            name: 'is_flash_sale',
            value: properties.isFlashSale,
          },
          {
            id: 'r0tvvT0Yd7',
            name: 'tracking_url',
            value: properties.trackingUrl,
          },
          { id: 'r7TPl6ZqL8', name: 'quantity', value: properties.quantity },
          { id: 'rGITDesDtb', name: 'products', value: properties.products },
          { id: 'uI2-rwjYtt', name: 'sku', value: properties.sku },
          {
            id: 'uXclLHai_L',
            name: 'delivery_time_latest',
            value: properties.deliveryTimeLatest,
          },
          {
            id: 'vaWiuR41RoGc8FaMrF5pT',
            name: 'google_product_category',
            value: properties.googleProductCategory,
          },
          {
            id: 'wq1G4WR2aU',
            name: 'gift_amount',
            value: properties.giftAmount,
          },
          {
            id: 'z-KPDmLIa_',
            name: 'fabric_name',
            value: properties.fabricName,
          },
          { id: 'zE__6S8gVh', name: 'city', value: properties.city },
          {
            id: 'zPeher-BjQ',
            name: 'is_clearance',
            value: properties.isClearance,
          },
          { id: 'zsMuCAiZ4D', name: 'variant', value: properties.variant },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Order Completed': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Order Completed',
        {
          products: properties.products.map(function(value) {
            return {
              product_id: value.productId,
              category: value.category,
              is_clearance: value.isClearance,
              name: value.name,
              price: value.price,
              quantity: value.quantity,
              sku: value.sku,
              variant: value.variant,
              is_protection_plan_eligible: value.isProtectionPlanEligible,
              has_protection_plan: value.hasProtectionPlan,
              is_decide_later: value.isDecideLater,
              tracking_url: value.trackingUrl,
              tracking_number: value.trackingNumber,
              protection_plan_cost: value.protectionPlanCost,
              delivery_type: value.deliveryType,
              shipping_method: value.shippingMethod,
              shipping_carrier: value.shippingCarrier,
              fabric_name: value.fabricName,
              fabric_color: value.fabricColor,
              currency: value.currency,
              full_price: value.fullPrice,
              is_flash_sale: value.isFlashSale,
              google_product_category: value.googleProductCategory,
            };
          }),
          affiliation: properties.affiliation,
          coupon: properties.coupon,
          delivery_time_delta: properties.deliveryTimeDelta,
          delivery_time_earliest: properties.deliveryTimeEarliest,
          delivery_time_latest: properties.deliveryTimeLatest,
          discount: properties.discount,
          order_id: properties.orderId,
          payment_method: properties.paymentMethod,
          promotion_name: properties.promotionName,
          phone: properties.phone,
          shipping: properties.shipping,
          tax: properties.tax,
          total: properties.total,
          subtotal: properties.subtotal,
          revenue: properties.revenue,
          store_id: properties.storeId,
          cart_id: properties.cartId,
          currency: properties.currency,
          city: properties.city,
          state: properties.state,
          zip: properties.zip,
          talkative_customer_id: properties.talkativeCustomerId,
          gift_amount: properties.giftAmount,
          google_new_customer: properties.googleNewCustomer,
        },
        'Ji7vj5-uX',
        'ee0808140fc4fdc81a6d352260efedf2f72c811ff043207fca89476a4d29e74e'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.identify(properties.userId_);
    RudderstackJavascript.logEvent('Order Completed', {
      products: properties.products.map(function(value) {
        return {
          product_id: value.productId,
          category: value.category,
          is_clearance: value.isClearance,
          name: value.name,
          price: value.price,
          quantity: value.quantity,
          sku: value.sku,
          variant: value.variant,
          is_protection_plan_eligible: value.isProtectionPlanEligible,
          has_protection_plan: value.hasProtectionPlan,
          is_decide_later: value.isDecideLater,
          tracking_url: value.trackingUrl,
          tracking_number: value.trackingNumber,
          protection_plan_cost: value.protectionPlanCost,
          delivery_type: value.deliveryType,
          shipping_method: value.shippingMethod,
          shipping_carrier: value.shippingCarrier,
          fabric_name: value.fabricName,
          fabric_color: value.fabricColor,
          currency: value.currency,
          full_price: value.fullPrice,
          is_flash_sale: value.isFlashSale,
          google_product_category: value.googleProductCategory,
        };
      }),
      affiliation: properties.affiliation,
      coupon: properties.coupon,
      delivery_time_delta: properties.deliveryTimeDelta,
      delivery_time_earliest: properties.deliveryTimeEarliest,
      delivery_time_latest: properties.deliveryTimeLatest,
      discount: properties.discount,
      order_id: properties.orderId,
      payment_method: properties.paymentMethod,
      promotion_name: properties.promotionName,
      phone: properties.phone,
      shipping: properties.shipping,
      tax: properties.tax,
      total: properties.total,
      subtotal: properties.subtotal,
      revenue: properties.revenue,
      store_id: properties.storeId,
      cart_id: properties.cartId,
      currency: properties.currency,
      city: properties.city,
      state: properties.state,
      zip: properties.zip,
      talkative_customer_id: properties.talkativeCustomerId,
      gift_amount: properties.giftAmount,
      google_new_customer: properties.googleNewCustomer,
    });
  } else {
    // do nothing
  }
}

/**
 * Product Added: Fired when a user adds a product to cart. This SHOULD NOT fire when a user increments quantity in cart.
 *
 * @param {object} properties - the properties associated with this event
 * @param {int} properties.productId - The 3-5 digit product id (i.e. `623` corresponds to Hughes Sofa)
 * @param {int} properties.nonInteraction - This property should always be set to 1. Any event with the `non_interaction` property equal to 1 will not decrease the bounce rate
 * @param {float} properties.price - The price the user pays. If there is a sale, this is the sale price, if there is no sale, this is the full price
 * @param {int} properties.quantity - The quantity of products
 * @param {string} properties.sku - The full sku (i.e. 'JB103853-CF200-WS03')
 * Product Viewed -> Send the full sku of the first image shown (not the fabric that's selected)
 * @param {string} properties.cartId - The id of the cart (i.e. 194823)
 * @param {string} properties.name - Full product name (i.e. 'Hughes Grand Sofa')
 * @param {string} properties.variant - All product options for a product, separated by a comma and a space (i.e. 'Taylor Felt Grey, Mocha, Left, Cone').
 * If a user selected 'Decide Later', the variant should be 'Decide Later'.
 * @param {bool} properties.quickship - True if the product is available for quickship
 * @param {float} properties.fullPrice - The full price of the product
 * @param {string} properties.location - The location where the event occurred. Possibilities are listed below:
 * * For the 'Email Acquired' event, options are: 'Guest Checkout', 'Swatch Request', 'Justuno', or 'Account Creation'
 * * For the 'Product Clicked' event, options are: 'Home Page', 'Category Page',  'PDP', or 'Cart'
 * * For the 'Product Added to Wishlist' event, options are: 'Home Page', 'Category Page', or 'PDP'
 * * For the 'Protection Plan Added' event, options are: 'PDP', 'Cart', 'Checkout'
 * * For the 'Coupon Applied/Denied/Entered/Removed' events, options are: 'PDP' & 'Checkout'
 * * For the 'Fabric Favorited/Unfavorited' events, options are: 'PDP', 'Shop By Material', 'Pet Friendly Page', & 'Safeguard Fabrics Page'
 * @param {string} [properties.component] - The component the event occurred in.
 * 'Trade Newsletter Signup' - the trade-only email capture
 * 'Trade Application' - trade application pages
 * 'Product Recommendation Carousel' - the carousel with the heading 'Recommended for you
 * 'Recently Viewed Carousel' - the recently viewed carousel at the bottom of category pages & pdps
 * 'Best Sellers Carousel' - the best sellers carousel at the bottom of category pages
 * 'Collection Carousel' - the collection at the bottom of PDPs with products in the same family (i.e. if you're on the Hughes Sofa chair the Collection Carousel would have Hughes Chair, Hughes Loveseat, etc.)
 * 'Navbar' - the navbar component
 * 'Product to Product Carousel' - the product-to-product recommendation carousel on PDPs
 * 'Bambuser' - Bambuser video player
 * 'Product Card' - the product cards shown on category pages, PDPs, etc.
 * 'Cart' - the cart modal that pops up after clicking on cart icon
 * 'Newsletter Signup' - checkbox in footer/checkout/etc that allows marketing emails to be sent to customer
 * 'Swatch Request' - the swatch request modal
 * 'Share Cart' - the share cart modal
 * 'Account Creation' - the account creation modal
 * 'Product Grid' - the collection of product cards found on category pages and in search dropdown
 * 'Side Panel' - the right-hand panel on PDPs containing the product name, customizer, customer reviews, etc.
 * 'Delivery Update' - the modal that pops up on /tracking to inform users about a change to their delivery date
 * @param {string} properties.fabricName - The fabric name (i.e. 'Taylor Felt Grey')
 * If a user selected 'Decide Later', the fabric name should be 'Decide Later'.
 * @param {string} properties.fabricColor - The fabric's parent color (i.e. Green, Red, Blue, etc.).
 * If a user selected 'Decide Later', the fabric color should be 'Decide Later'.
 * @param {string} properties.currency - The currency (i.e. 'USD', 'CAD', etc.)
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/HXTsOYDLH2}
 */
export function productAdded(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertProductId(properties.productId));
    messages = messages.concat(assertNonInteraction(properties.nonInteraction));
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(assertQuantity(properties.quantity));
    messages = messages.concat(assertSku(properties.sku));
    messages = messages.concat(assertCartId(properties.cartId));
    messages = messages.concat(assertName(properties.name));
    messages = messages.concat(assertVariant(properties.variant));
    messages = messages.concat(assertQuickship(properties.quickship));
    messages = messages.concat(assertFullPrice(properties.fullPrice));
    messages = messages.concat(assertLocation(properties.location));
    messages = messages.concat(assertOptionalComponent(properties.component));
    messages = messages.concat(assertFabricName(properties.fabricName));
    messages = messages.concat(assertFabricColor(properties.fabricColor));
    messages = messages.concat(assertCurrency(properties.currency));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Product Added',
        Object.keys(properties),
        [
          'productId',
          'nonInteraction',
          'price',
          'quantity',
          'sku',
          'cartId',
          'name',
          'variant',
          'quickship',
          'fullPrice',
          'location',
          'component',
          'fabricName',
          'fabricColor',
          'currency',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'HXTsOYDLH2',
        '030db552c7c90793efe095de3aa917676d01e8230c98ea9d0d58976ef4279617',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Product Added',
      {
        product_id: properties.productId,
        non_interaction: properties.nonInteraction,
        price: properties.price,
        quantity: properties.quantity,
        sku: properties.sku,
        cart_id: properties.cartId,
        name: properties.name,
        variant: properties.variant,
        quickship: properties.quickship,
        full_price: properties.fullPrice,
        location: properties.location,
        component: properties.component,
        fabric_name: properties.fabricName,
        fabric_color: properties.fabricColor,
        currency: properties.currency,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'HXTsOYDLH2',
        'Product Added',
        messages,
        [
          {
            id: '-3Hv24vVaC',
            name: 'non_interaction',
            value: properties.nonInteraction,
          },
          { id: 'B71GIESiV8', name: 'location', value: properties.location },
          { id: 'EghVtONPP', name: 'name', value: properties.name },
          { id: 'F_0zRLZY6n', name: 'full_price', value: properties.fullPrice },
          { id: 'KALt_3pVFV', name: 'cart_id', value: properties.cartId },
          {
            id: 'cZN2CHE3RG',
            name: 'fabric_color',
            value: properties.fabricColor,
          },
          { id: 'j-kP3_J7Rb', name: 'price', value: properties.price },
          { id: 'mEnst5CFw', name: 'currency', value: properties.currency },
          { id: 'nHu4WfjB0w', name: 'product_id', value: properties.productId },
          { id: 'q2dBEu8QaF', name: 'quickship', value: properties.quickship },
          { id: 'r7TPl6ZqL8', name: 'quantity', value: properties.quantity },
          { id: 'uI2-rwjYtt', name: 'sku', value: properties.sku },
          { id: 'wRrJhFCX_U', name: 'component', value: properties.component },
          {
            id: 'z-KPDmLIa_',
            name: 'fabric_name',
            value: properties.fabricName,
          },
          { id: 'zsMuCAiZ4D', name: 'variant', value: properties.variant },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Product Added': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Product Added',
        {
          product_id: properties.productId,
          non_interaction: properties.nonInteraction,
          price: properties.price,
          quantity: properties.quantity,
          sku: properties.sku,
          cart_id: properties.cartId,
          name: properties.name,
          variant: properties.variant,
          quickship: properties.quickship,
          full_price: properties.fullPrice,
          location: properties.location,
          component: properties.component,
          fabric_name: properties.fabricName,
          fabric_color: properties.fabricColor,
          currency: properties.currency,
        },
        'HXTsOYDLH2',
        '030db552c7c90793efe095de3aa917676d01e8230c98ea9d0d58976ef4279617'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Product Added', {
      product_id: properties.productId,
      non_interaction: properties.nonInteraction,
      price: properties.price,
      quantity: properties.quantity,
      sku: properties.sku,
      cart_id: properties.cartId,
      name: properties.name,
      variant: properties.variant,
      quickship: properties.quickship,
      full_price: properties.fullPrice,
      location: properties.location,
      component: properties.component,
      fabric_name: properties.fabricName,
      fabric_color: properties.fabricColor,
      currency: properties.currency,
    });
  } else {
    // do nothing
  }
}

/**
 * Product Added to Wishlist: Fired when a product is added to a wishlist
 *
 * @param {object} properties - the properties associated with this event
 * @param {int} properties.productId - The 3-5 digit product id (i.e. `623` corresponds to Hughes Sofa)
 * @param {int} [properties.fabricId] - The fabric id (i.e. For Bentley Daisy it's 263)
 * @param {string} [properties.fabricName] - The fabric name (i.e. 'Taylor Felt Grey')
 * If a user selected 'Decide Later', the fabric name should be 'Decide Later'.
 * @param {float} properties.price - The price the user pays. If there is a sale, this is the sale price, if there is no sale, this is the full price
 * @param {string} properties.productFamily - The family of the product (i.e. 'Hughes', 'Soto', ect.).
 * @param {string} properties.sku - The full sku (i.e. 'JB103853-CF200-WS03')
 * Product Viewed -> Send the full sku of the first image shown (not the fabric that's selected)
 * @param {string} [properties.fabricColor] - The fabric's parent color (i.e. Green, Red, Blue, etc.).
 * If a user selected 'Decide Later', the fabric color should be 'Decide Later'.
 * @param {float} properties.fullPrice - The full price of the product
 * @param {bool} properties.isClearance - Whether or not the item was on clearance
 * @param {bool} properties.quickship - True if the product is available for quickship
 * @param {string} properties.location - The location where the event occurred. Possibilities are listed below:
 * * For the 'Email Acquired' event, options are: 'Guest Checkout', 'Swatch Request', 'Justuno', or 'Account Creation'
 * * For the 'Product Clicked' event, options are: 'Home Page', 'Category Page',  'PDP', or 'Cart'
 * * For the 'Product Added to Wishlist' event, options are: 'Home Page', 'Category Page', or 'PDP'
 * * For the 'Protection Plan Added' event, options are: 'PDP', 'Cart', 'Checkout'
 * * For the 'Coupon Applied/Denied/Entered/Removed' events, options are: 'PDP' & 'Checkout'
 * * For the 'Fabric Favorited/Unfavorited' events, options are: 'PDP', 'Shop By Material', 'Pet Friendly Page', & 'Safeguard Fabrics Page'
 * @param {string} properties.name - Full product name (i.e. 'Hughes Grand Sofa')
 * @param {string} properties.variant - All product options for a product, separated by a comma and a space (i.e. 'Taylor Felt Grey, Mocha, Left, Cone').
 * If a user selected 'Decide Later', the variant should be 'Decide Later'.
 * @param {string} properties.category - The product type (i.e. 'Chair', 'Sofa', etc.). This is NOT the category in terms of Joybird's use of the term 'category', this is the product type.
 * @param {string} properties.currency - The currency (i.e. 'USD', 'CAD', etc.)
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/m_L6aET2Ea}
 */
export function productAddedToWishlist(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertProductId(properties.productId));
    messages = messages.concat(assertOptionalFabricId(properties.fabricId));
    messages = messages.concat(assertOptionalFabricName(properties.fabricName));
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(assertProductFamily(properties.productFamily));
    messages = messages.concat(assertSku(properties.sku));
    messages = messages.concat(
      assertOptionalFabricColor(properties.fabricColor)
    );
    messages = messages.concat(assertFullPrice(properties.fullPrice));
    messages = messages.concat(assertIsClearance(properties.isClearance));
    messages = messages.concat(assertQuickship(properties.quickship));
    messages = messages.concat(assertLocation(properties.location));
    messages = messages.concat(assertName(properties.name));
    messages = messages.concat(assertVariant(properties.variant));
    messages = messages.concat(assertCategory(properties.category));
    messages = messages.concat(assertCurrency(properties.currency));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Product Added to Wishlist',
        Object.keys(properties),
        [
          'productId',
          'fabricId',
          'fabricName',
          'price',
          'productFamily',
          'sku',
          'fabricColor',
          'fullPrice',
          'isClearance',
          'quickship',
          'location',
          'name',
          'variant',
          'category',
          'currency',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'm_L6aET2Ea',
        'da8c386419e896e8769cf198d82ba146bdbc1dac483c8ac44525144d041068ad',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Product Added to Wishlist',
      {
        product_id: properties.productId,
        fabric_id: properties.fabricId,
        fabric_name: properties.fabricName,
        price: properties.price,
        product_family: properties.productFamily,
        sku: properties.sku,
        fabric_color: properties.fabricColor,
        full_price: properties.fullPrice,
        is_clearance: properties.isClearance,
        quickship: properties.quickship,
        location: properties.location,
        name: properties.name,
        variant: properties.variant,
        category: properties.category,
        currency: properties.currency,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'm_L6aET2Ea',
        'Product Added to Wishlist',
        messages,
        [
          { id: '3PXRzRK2KK', name: 'category', value: properties.category },
          { id: 'B71GIESiV8', name: 'location', value: properties.location },
          { id: 'EghVtONPP', name: 'name', value: properties.name },
          { id: 'F_0zRLZY6n', name: 'full_price', value: properties.fullPrice },
          {
            id: 'cZN2CHE3RG',
            name: 'fabric_color',
            value: properties.fabricColor,
          },
          { id: 'j-kP3_J7Rb', name: 'price', value: properties.price },
          { id: 'mEnst5CFw', name: 'currency', value: properties.currency },
          { id: 'nHu4WfjB0w', name: 'product_id', value: properties.productId },
          { id: 'q2dBEu8QaF', name: 'quickship', value: properties.quickship },
          {
            id: 'rYLq0zrdEe',
            name: 'product_family',
            value: properties.productFamily,
          },
          { id: 'uI2-rwjYtt', name: 'sku', value: properties.sku },
          { id: 'vl8jHhQKP6', name: 'fabric_id', value: properties.fabricId },
          {
            id: 'z-KPDmLIa_',
            name: 'fabric_name',
            value: properties.fabricName,
          },
          {
            id: 'zPeher-BjQ',
            name: 'is_clearance',
            value: properties.isClearance,
          },
          { id: 'zsMuCAiZ4D', name: 'variant', value: properties.variant },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Product Added to Wishlist': " +
            messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Product Added to Wishlist',
        {
          product_id: properties.productId,
          fabric_id: properties.fabricId,
          fabric_name: properties.fabricName,
          price: properties.price,
          product_family: properties.productFamily,
          sku: properties.sku,
          fabric_color: properties.fabricColor,
          full_price: properties.fullPrice,
          is_clearance: properties.isClearance,
          quickship: properties.quickship,
          location: properties.location,
          name: properties.name,
          variant: properties.variant,
          category: properties.category,
          currency: properties.currency,
        },
        'm_L6aET2Ea',
        'da8c386419e896e8769cf198d82ba146bdbc1dac483c8ac44525144d041068ad'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Product Added to Wishlist', {
      product_id: properties.productId,
      fabric_id: properties.fabricId,
      fabric_name: properties.fabricName,
      price: properties.price,
      product_family: properties.productFamily,
      sku: properties.sku,
      fabric_color: properties.fabricColor,
      full_price: properties.fullPrice,
      is_clearance: properties.isClearance,
      quickship: properties.quickship,
      location: properties.location,
      name: properties.name,
      variant: properties.variant,
      category: properties.category,
      currency: properties.currency,
    });
  } else {
    // do nothing
  }
}

/**
 * Checkout Started: Fired when a user first lands on /checkout.
 *
 * @param {object} properties - the properties associated with this event
 * @param {Array<object>} properties.products - A list of products.
 * @param {string} properties.affiliation - The store or affiliation from which this transaction occurred (e.g. 'Online', 'Brooklyn', etc.)
 * @param {float} properties.tax - The price paid for tax.
 * @param {float} properties.shipping - The price paid for shipping.
 * @param {float} properties.discount - Total discount amount (i.e. 153.82)
 * @param {float} properties.revenue - Revenue ($) associated with the transaction (excluding shipping and tax). This does include the price of protection plans.
 * @param {string} properties.cartId - The id of the cart (i.e. 194823)
 * @param {string} properties.currency - The currency (i.e. 'USD', 'CAD', etc.)
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/RjXalRu6Mr}
 */
export function checkoutStarted(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertProducts(properties.products));
    messages = messages.concat(assertAffiliation(properties.affiliation));
    messages = messages.concat(assertTax(properties.tax));
    messages = messages.concat(assertShipping(properties.shipping));
    messages = messages.concat(assertDiscount(properties.discount));
    messages = messages.concat(assertRevenue(properties.revenue));
    messages = messages.concat(assertCartId(properties.cartId));
    messages = messages.concat(assertCurrency(properties.currency));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Checkout Started',
        Object.keys(properties),
        [
          'products',
          'affiliation',
          'tax',
          'shipping',
          'discount',
          'revenue',
          'cartId',
          'currency',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'RjXalRu6Mr',
        '7d495ca66829d55832d8f5f76d9aaa8c3a1897563d27570d8ac95c1b07b75613',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Checkout Started',
      {
        products: properties.products.map(function(value) {
          return {
            product_id: value.productId,
            category: value.category,
            is_clearance: value.isClearance,
            name: value.name,
            price: value.price,
            quantity: value.quantity,
            sku: value.sku,
            variant: value.variant,
            is_protection_plan_eligible: value.isProtectionPlanEligible,
            has_protection_plan: value.hasProtectionPlan,
            is_decide_later: value.isDecideLater,
            tracking_url: value.trackingUrl,
            tracking_number: value.trackingNumber,
            protection_plan_cost: value.protectionPlanCost,
            delivery_type: value.deliveryType,
            shipping_method: value.shippingMethod,
            shipping_carrier: value.shippingCarrier,
            fabric_name: value.fabricName,
            fabric_color: value.fabricColor,
            currency: value.currency,
            full_price: value.fullPrice,
            is_flash_sale: value.isFlashSale,
            google_product_category: value.googleProductCategory,
          };
        }),
        affiliation: properties.affiliation,
        tax: properties.tax,
        shipping: properties.shipping,
        discount: properties.discount,
        revenue: properties.revenue,
        cart_id: properties.cartId,
        currency: properties.currency,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'RjXalRu6Mr',
        'Checkout Started',
        messages,
        [
          {
            id: '-Be6jz-r5H',
            name: 'delivery_type',
            value: properties.deliveryType,
          },
          {
            id: '-r2A9Y6Dak',
            name: 'protection_plan_cost',
            value: properties.protectionPlanCost,
          },
          { id: '1PytrUAIdT', name: 'tax', value: properties.tax },
          { id: '3PXRzRK2KK', name: 'category', value: properties.category },
          {
            id: '4HTRW0TFrB',
            name: 'shipping_method',
            value: properties.shippingMethod,
          },
          { id: '4RK31aMrfu', name: 'shipping', value: properties.shipping },
          { id: 'EghVtONPP', name: 'name', value: properties.name },
          {
            id: 'EloKvEAu8Y',
            name: 'affiliation',
            value: properties.affiliation,
          },
          { id: 'F_0zRLZY6n', name: 'full_price', value: properties.fullPrice },
          {
            id: 'Fwb-BjQjH1V',
            name: 'is_decide_later',
            value: properties.isDecideLater,
          },
          { id: 'Hg5Zjuw2cd', name: 'revenue', value: properties.revenue },
          { id: 'KALt_3pVFV', name: 'cart_id', value: properties.cartId },
          {
            id: 'KwMPoO_BRg',
            name: 'tracking_number',
            value: properties.trackingNumber,
          },
          {
            id: 'MoIQmnL5AHl',
            name: 'has_protection_plan',
            value: properties.hasProtectionPlan,
          },
          {
            id: 'NdU9dcPzjy',
            name: 'is_protection_plan_eligible',
            value: properties.isProtectionPlanEligible,
          },
          {
            id: 'YsXH4GchTs',
            name: 'shipping_carrier',
            value: properties.shippingCarrier,
          },
          { id: 'brVZTOFd99', name: 'discount', value: properties.discount },
          {
            id: 'cZN2CHE3RG',
            name: 'fabric_color',
            value: properties.fabricColor,
          },
          { id: 'j-kP3_J7Rb', name: 'price', value: properties.price },
          { id: 'mEnst5CFw', name: 'currency', value: properties.currency },
          { id: 'nHu4WfjB0w', name: 'product_id', value: properties.productId },
          {
            id: 'ocjd8V8Of8',
            name: 'is_flash_sale',
            value: properties.isFlashSale,
          },
          {
            id: 'r0tvvT0Yd7',
            name: 'tracking_url',
            value: properties.trackingUrl,
          },
          { id: 'r7TPl6ZqL8', name: 'quantity', value: properties.quantity },
          { id: 'rGITDesDtb', name: 'products', value: properties.products },
          { id: 'uI2-rwjYtt', name: 'sku', value: properties.sku },
          {
            id: 'vaWiuR41RoGc8FaMrF5pT',
            name: 'google_product_category',
            value: properties.googleProductCategory,
          },
          {
            id: 'z-KPDmLIa_',
            name: 'fabric_name',
            value: properties.fabricName,
          },
          {
            id: 'zPeher-BjQ',
            name: 'is_clearance',
            value: properties.isClearance,
          },
          { id: 'zsMuCAiZ4D', name: 'variant', value: properties.variant },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Checkout Started': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Checkout Started',
        {
          products: properties.products.map(function(value) {
            return {
              product_id: value.productId,
              category: value.category,
              is_clearance: value.isClearance,
              name: value.name,
              price: value.price,
              quantity: value.quantity,
              sku: value.sku,
              variant: value.variant,
              is_protection_plan_eligible: value.isProtectionPlanEligible,
              has_protection_plan: value.hasProtectionPlan,
              is_decide_later: value.isDecideLater,
              tracking_url: value.trackingUrl,
              tracking_number: value.trackingNumber,
              protection_plan_cost: value.protectionPlanCost,
              delivery_type: value.deliveryType,
              shipping_method: value.shippingMethod,
              shipping_carrier: value.shippingCarrier,
              fabric_name: value.fabricName,
              fabric_color: value.fabricColor,
              currency: value.currency,
              full_price: value.fullPrice,
              is_flash_sale: value.isFlashSale,
              google_product_category: value.googleProductCategory,
            };
          }),
          affiliation: properties.affiliation,
          tax: properties.tax,
          shipping: properties.shipping,
          discount: properties.discount,
          revenue: properties.revenue,
          cart_id: properties.cartId,
          currency: properties.currency,
        },
        'RjXalRu6Mr',
        '7d495ca66829d55832d8f5f76d9aaa8c3a1897563d27570d8ac95c1b07b75613'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Checkout Started', {
      products: properties.products.map(function(value) {
        return {
          product_id: value.productId,
          category: value.category,
          is_clearance: value.isClearance,
          name: value.name,
          price: value.price,
          quantity: value.quantity,
          sku: value.sku,
          variant: value.variant,
          is_protection_plan_eligible: value.isProtectionPlanEligible,
          has_protection_plan: value.hasProtectionPlan,
          is_decide_later: value.isDecideLater,
          tracking_url: value.trackingUrl,
          tracking_number: value.trackingNumber,
          protection_plan_cost: value.protectionPlanCost,
          delivery_type: value.deliveryType,
          shipping_method: value.shippingMethod,
          shipping_carrier: value.shippingCarrier,
          fabric_name: value.fabricName,
          fabric_color: value.fabricColor,
          currency: value.currency,
          full_price: value.fullPrice,
          is_flash_sale: value.isFlashSale,
          google_product_category: value.googleProductCategory,
        };
      }),
      affiliation: properties.affiliation,
      tax: properties.tax,
      shipping: properties.shipping,
      discount: properties.discount,
      revenue: properties.revenue,
      cart_id: properties.cartId,
      currency: properties.currency,
    });
  } else {
    // do nothing
  }
}

/**
 * Checkout Step Viewed: Fired each time a checkout step is displayed. It is still fired when a user goes backwords (i.e. Going from step 3 to 2 should fire an event).
 *
 * @param {object} properties - the properties associated with this event
 * @param {int} properties.step - The step of the checkout funnel (starting at 1)
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/hV9hTY2yIs}
 */
export function checkoutStepViewed(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertStep(properties.step));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Checkout Step Viewed',
        Object.keys(properties),
        ['step']
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'hV9hTY2yIs',
        '63730125aab08b0be80f7c8134bedabe3a79534508c76e206af3054de013b522',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Checkout Step Viewed',
      {
        step: properties.step,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'hV9hTY2yIs',
        'Checkout Step Viewed',
        messages,
        [{ id: 'WZE-XiY0e', name: 'step', value: properties.step }],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Checkout Step Viewed': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Checkout Step Viewed',
        {
          step: properties.step,
        },
        'hV9hTY2yIs',
        '63730125aab08b0be80f7c8134bedabe3a79534508c76e206af3054de013b522'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Checkout Step Viewed', {
      step: properties.step,
    });
  } else {
    // do nothing
  }
}

/**
 * Checkout Step Completed: Fired each time a user clicks the "Continue To ..." button to proceed to the next step.
 *
 * @param {object} properties - the properties associated with this event
 * @param {int} properties.step - The step of the checkout funnel (starting at 1)
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/vWQR00ZEfk}
 */
export function checkoutStepCompleted(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertStep(properties.step));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Checkout Step Completed',
        Object.keys(properties),
        ['step']
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'vWQR00ZEfk',
        '3dc968b0a9f6b10dc876d6263cb02eaaaf1d1d312d21b412408752611aa8c06b',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Checkout Step Completed',
      {
        step: properties.step,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'vWQR00ZEfk',
        'Checkout Step Completed',
        messages,
        [{ id: 'WZE-XiY0e', name: 'step', value: properties.step }],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Checkout Step Completed': " +
            messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Checkout Step Completed',
        {
          step: properties.step,
        },
        'vWQR00ZEfk',
        '3dc968b0a9f6b10dc876d6263cb02eaaaf1d1d312d21b412408752611aa8c06b'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Checkout Step Completed', {
      step: properties.step,
    });
  } else {
    // do nothing
  }
}

/**
 * DS Quiz Started: Fired when a user clicks on the button to start the Design Services Quiz.
 *
 * @param {object} properties - the properties associated with this event
 * @param {int} properties.quizId - The Design Services quiz id. On the old DS quiz, the first DS quiz should have an id of 1 and the follow-up DS quiz should have an id of 2. On the new DS quiz, the 'find your style' quiz should have an id of 3, the 'start your project' quiz should have an id of 4, the 'room images' quiz should have an id of 5, and the 'room measurements' quiz should have an id of 6.
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/C9xbRyWm9J}
 */
export function dsQuizStarted(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertQuizId(properties.quizId));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'DS Quiz Started',
        Object.keys(properties),
        ['quizId']
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'C9xbRyWm9J',
        'aa8e92798465a315453b144d53c5b8e7956e511b9e10e49b50a1e96485b808aa',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'DS Quiz Started',
      {
        quiz_id: properties.quizId,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'C9xbRyWm9J',
        'DS Quiz Started',
        messages,
        [{ id: 'VZ0flBwsah', name: 'quiz_id', value: properties.quizId }],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'DS Quiz Started': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'DS Quiz Started',
        {
          quiz_id: properties.quizId,
        },
        'C9xbRyWm9J',
        'aa8e92798465a315453b144d53c5b8e7956e511b9e10e49b50a1e96485b808aa'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('DS Quiz Started', {
      quiz_id: properties.quizId,
    });
  } else {
    // do nothing
  }
}

/**
 * DS Quiz Step Completed: Fired each time a user completes a quiz question.
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} [properties.answer] - The stringified & comma-separated answer(s) (i.e. 'cats, dogs')
 * @param {string} properties.question - The full question, along with the question number (i.e. '3. Do you have any pets?')
 * @param {float} properties.questionNum - Question number (starting at 1)
 * @param {int} properties.quizId - The Design Services quiz id. On the old DS quiz, the first DS quiz should have an id of 1 and the follow-up DS quiz should have an id of 2. On the new DS quiz, the 'find your style' quiz should have an id of 3, the 'start your project' quiz should have an id of 4, the 'room images' quiz should have an id of 5, and the 'room measurements' quiz should have an id of 6.
 * @param {string} [properties.roomName] - The name of the room the quiz step/question applies to, e.g. 'Living Room', 'Bedroom', 'Dining Room', 'Office', or 'Other'. Only applies to the new DS quiz (quiz_id 3, 4, 5, or 6), and only sent for room-specific questions.
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/XcOW9w0K5U}
 */
export function dsQuizStepCompleted(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertOptionalAnswer(properties.answer));
    messages = messages.concat(assertQuestion(properties.question));
    messages = messages.concat(assertQuestionNum(properties.questionNum));
    messages = messages.concat(assertQuizId(properties.quizId));
    messages = messages.concat(assertOptionalRoomName(properties.roomName));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'DS Quiz Step Completed',
        Object.keys(properties),
        ['answer', 'question', 'questionNum', 'quizId', 'roomName']
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'XcOW9w0K5U',
        '75fb2c5805079afeaeef660c274ba6c2f4dc1c81d76a237062bbc8baf2c46dea',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'DS Quiz Step Completed',
      {
        answer: properties.answer,
        question: properties.question,
        question_num: properties.questionNum,
        quiz_id: properties.quizId,
        room_name: properties.roomName,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'XcOW9w0K5U',
        'DS Quiz Step Completed',
        messages,
        [
          { id: 'DGtYZWhVMG', name: 'answer', value: properties.answer },
          {
            id: 'Qq4x6JX4TD',
            name: 'question_num',
            value: properties.questionNum,
          },
          { id: 'VZ0flBwsah', name: 'quiz_id', value: properties.quizId },
          { id: 'YkO40sXpE1', name: 'question', value: properties.question },
          { id: 'cxALF7UPor', name: 'room_name', value: properties.roomName },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'DS Quiz Step Completed': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'DS Quiz Step Completed',
        {
          answer: properties.answer,
          question: properties.question,
          question_num: properties.questionNum,
          quiz_id: properties.quizId,
          room_name: properties.roomName,
        },
        'XcOW9w0K5U',
        '75fb2c5805079afeaeef660c274ba6c2f4dc1c81d76a237062bbc8baf2c46dea'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('DS Quiz Step Completed', {
      answer: properties.answer,
      question: properties.question,
      question_num: properties.questionNum,
      quiz_id: properties.quizId,
      room_name: properties.roomName,
    });
  } else {
    // do nothing
  }
}

/**
 * DS Quiz Completed: Fired when a Design Service quiz has been confirmed to be completed.
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.userId_ - The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param {string} [properties.email] - The email address (i.e. 'christoph@joybird.com')
 * @param {int} properties.quizId - The Design Services quiz id. On the old DS quiz, the first DS quiz should have an id of 1 and the follow-up DS quiz should have an id of 2. On the new DS quiz, the 'find your style' quiz should have an id of 3, the 'start your project' quiz should have an id of 4, the 'room images' quiz should have an id of 5, and the 'room measurements' quiz should have an id of 6.
 * @param {string} properties.backendEmail - Email address from the server
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/iFOklNVrrn}
 */
export function dsQuizCompleted(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertUserId_(properties.userId_));
    messages = messages.concat(assertOptionalEmail(properties.email));
    messages = messages.concat(assertQuizId(properties.quizId));
    messages = messages.concat(assertBackendEmail(properties.backendEmail));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'DS Quiz Completed',
        Object.keys(properties),
        ['userId_', 'email', 'quizId', 'backendEmail']
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'iFOklNVrrn',
        '0655793327f28f9bea5e5d7146af26d9aa21380fa4a1ac7e3c75556e4506eef1',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'DS Quiz Completed',
      {
        email: properties.email,
        quiz_id: properties.quizId,
      },
      {
        backend_email: properties.backendEmail,
      },
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'iFOklNVrrn',
        'DS Quiz Completed',
        messages,
        [
          { id: '4rYN-Q_mp', name: 'email', value: properties.email },
          { id: 'VZ0flBwsah', name: 'quiz_id', value: properties.quizId },
        ],
        [
          {
            id: 'zjUFB7hRiT',
            name: 'backend_email',
            value: properties.backendEmail,
          },
        ],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'DS Quiz Completed': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'DS Quiz Completed',
        {
          email: properties.email,
          quiz_id: properties.quizId,
        },
        'iFOklNVrrn',
        '0655793327f28f9bea5e5d7146af26d9aa21380fa4a1ac7e3c75556e4506eef1'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.setUserProperties(properties.userId_, {
      email: properties.backendEmail,
    });
    RudderstackJavascript.logEvent('DS Quiz Completed', {
      email: properties.email,
      quiz_id: properties.quizId,
    });
  } else {
    // do nothing
  }
}

/**
 * Email Acquired: Fired any time a user enters their email address. This includes:
 * * Account Created
 * * Swatch Request
 * * First step in guest checkout
 * * Lead capture popup (Justuno)
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.userId_ - The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param {string} properties.email - The email address (i.e. 'christoph@joybird.com')
 * @param {string} properties.location - The location where the event occurred. Possibilities are listed below:
 * * For the 'Email Acquired' event, options are: 'Guest Checkout', 'Swatch Request', 'Justuno', or 'Account Creation'
 * * For the 'Product Clicked' event, options are: 'Home Page', 'Category Page',  'PDP', or 'Cart'
 * * For the 'Product Added to Wishlist' event, options are: 'Home Page', 'Category Page', or 'PDP'
 * * For the 'Protection Plan Added' event, options are: 'PDP', 'Cart', 'Checkout'
 * * For the 'Coupon Applied/Denied/Entered/Removed' events, options are: 'PDP' & 'Checkout'
 * * For the 'Fabric Favorited/Unfavorited' events, options are: 'PDP', 'Shop By Material', 'Pet Friendly Page', & 'Safeguard Fabrics Page'
 * @param {bool} properties.optedInMarketing - Whether or not the user opted in to marketing emails
 * @param {string} properties.backendEmail - Email address from the server
 * @param {string} [properties.component] - The component the event occurred in.
 * 'Trade Newsletter Signup' - the trade-only email capture
 * 'Trade Application' - trade application pages
 * 'Product Recommendation Carousel' - the carousel with the heading 'Recommended for you
 * 'Recently Viewed Carousel' - the recently viewed carousel at the bottom of category pages & pdps
 * 'Best Sellers Carousel' - the best sellers carousel at the bottom of category pages
 * 'Collection Carousel' - the collection at the bottom of PDPs with products in the same family (i.e. if you're on the Hughes Sofa chair the Collection Carousel would have Hughes Chair, Hughes Loveseat, etc.)
 * 'Navbar' - the navbar component
 * 'Product to Product Carousel' - the product-to-product recommendation carousel on PDPs
 * 'Bambuser' - Bambuser video player
 * 'Product Card' - the product cards shown on category pages, PDPs, etc.
 * 'Cart' - the cart modal that pops up after clicking on cart icon
 * 'Newsletter Signup' - checkbox in footer/checkout/etc that allows marketing emails to be sent to customer
 * 'Swatch Request' - the swatch request modal
 * 'Share Cart' - the share cart modal
 * 'Account Creation' - the account creation modal
 * 'Product Grid' - the collection of product cards found on category pages and in search dropdown
 * 'Side Panel' - the right-hand panel on PDPs containing the product name, customizer, customer reviews, etc.
 * 'Delivery Update' - the modal that pops up on /tracking to inform users about a change to their delivery date
 * @param {string} [properties.talkativeCustomerId] - The site visitor's customer ID from Talkative, if the user used the on-site chat.
 * This information is stored in a cookie by Talkative: talkative_ecs__eu__[wildcard UUID]__customer__uuid
 * Additional documentation at https://support.gettalkative.com/knowledge/cookie-policy-1
 * @param {bool} [properties.optedInSmsMarketing] - Whether or not the user opted in to SMS marketing
 * @param {string} [properties.phone] - Phone number in the format `1234567890`. May also be sent as a string in E.164 format (eg `+11234567890`) where required.
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/-w9iIBzvFL}
 */
export function emailAcquired(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertUserId_(properties.userId_));
    messages = messages.concat(assertEmail(properties.email));
    messages = messages.concat(assertLocation(properties.location));
    messages = messages.concat(
      assertOptedInMarketing(properties.optedInMarketing)
    );
    messages = messages.concat(assertBackendEmail(properties.backendEmail));
    messages = messages.concat(assertOptionalComponent(properties.component));
    messages = messages.concat(
      assertOptionalTalkativeCustomerId(properties.talkativeCustomerId)
    );
    messages = messages.concat(
      assertOptionalOptedInSmsMarketing(properties.optedInSmsMarketing)
    );
    messages = messages.concat(assertOptionalPhone(properties.phone));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Email Acquired',
        Object.keys(properties),
        [
          'userId_',
          'email',
          'location',
          'optedInMarketing',
          'backendEmail',
          'component',
          'talkativeCustomerId',
          'optedInSmsMarketing',
          'phone',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '-w9iIBzvFL',
        '9e75ff81ba2e748aacda8f9b0cd44933e9c338d135ddf11a698bfe4e1321882d',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Email Acquired',
      {
        email: properties.email,
        location: properties.location,
        opted_in_marketing: properties.optedInMarketing,
        component: properties.component,
        talkative_customer_id: properties.talkativeCustomerId,
        opted_in_sms_marketing: properties.optedInSmsMarketing,
        phone: properties.phone,
      },
      {
        backend_email: properties.backendEmail,
      },
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '-w9iIBzvFL',
        'Email Acquired',
        messages,
        [
          { id: '4rYN-Q_mp', name: 'email', value: properties.email },
          { id: 'B71GIESiV8', name: 'location', value: properties.location },
          { id: 'CNxC4sfhlL', name: 'phone', value: properties.phone },
          {
            id: 'E46jtrSf8',
            name: 'talkative_customer_id',
            value: properties.talkativeCustomerId,
          },
          {
            id: 'YzWHuN55jX',
            name: 'opted_in_marketing',
            value: properties.optedInMarketing,
          },
          {
            id: 'lTV3tSML1r7ZBl230680k',
            name: 'opted_in_sms_marketing',
            value: properties.optedInSmsMarketing,
          },
          { id: 'wRrJhFCX_U', name: 'component', value: properties.component },
        ],
        [
          {
            id: 'zjUFB7hRiT',
            name: 'backend_email',
            value: properties.backendEmail,
          },
        ],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Email Acquired': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Email Acquired',
        {
          email: properties.email,
          location: properties.location,
          opted_in_marketing: properties.optedInMarketing,
          component: properties.component,
          talkative_customer_id: properties.talkativeCustomerId,
          opted_in_sms_marketing: properties.optedInSmsMarketing,
          phone: properties.phone,
        },
        '-w9iIBzvFL',
        '9e75ff81ba2e748aacda8f9b0cd44933e9c338d135ddf11a698bfe4e1321882d'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.setUserProperties(properties.userId_, {
      email: properties.backendEmail,
    });
    RudderstackJavascript.logEvent('Email Acquired', {
      email: properties.email,
      location: properties.location,
      opted_in_marketing: properties.optedInMarketing,
      component: properties.component,
      talkative_customer_id: properties.talkativeCustomerId,
      opted_in_sms_marketing: properties.optedInSmsMarketing,
      phone: properties.phone,
    });
  } else {
    // do nothing
  }
}

/**
 * Product Clicked: Fired any time a user clicks on a Product Card - whether it's on the Home Page, Category Page, PDP, etc.
 *
 * @param {object} properties - the properties associated with this event
 * @param {int} properties.productId - The 3-5 digit product id (i.e. `623` corresponds to Hughes Sofa)
 * @param {string} properties.category - The product type (i.e. 'Chair', 'Sofa', etc.). This is NOT the category in terms of Joybird's use of the term 'category', this is the product type.
 * @param {bool} properties.isClearance - Whether or not the item was on clearance
 * @param {string} properties.name - Full product name (i.e. 'Hughes Grand Sofa')
 * @param {float} properties.price - The price the user pays. If there is a sale, this is the sale price, if there is no sale, this is the full price
 * @param {int} properties.quantity - The quantity of products
 * @param {string} properties.sku - The full sku (i.e. 'JB103853-CF200-WS03')
 * Product Viewed -> Send the full sku of the first image shown (not the fabric that's selected)
 * @param {string} properties.variant - All product options for a product, separated by a comma and a space (i.e. 'Taylor Felt Grey, Mocha, Left, Cone').
 * If a user selected 'Decide Later', the variant should be 'Decide Later'.
 * @param {float} properties.fullPrice - The full price of the product
 * @param {string} properties.productFamily - The family of the product (i.e. 'Hughes', 'Soto', ect.).
 * @param {Array<string>} properties.contentIds - The base product sku(s) (i.e. if the sku is 'JB11069110-CF423-WS03', the value for Content IDs should be ['JB11069110']).
 * @param {bool} properties.isFlashSale - Whether or not the item was on flash sale
 * @param {int} properties.position - The position on the page, top to bottom, left to right. The top-most & left-most position is `position: 1`.
 * @param {string} [properties.component] - The component the event occurred in.
 * 'Trade Newsletter Signup' - the trade-only email capture
 * 'Trade Application' - trade application pages
 * 'Product Recommendation Carousel' - the carousel with the heading 'Recommended for you
 * 'Recently Viewed Carousel' - the recently viewed carousel at the bottom of category pages & pdps
 * 'Best Sellers Carousel' - the best sellers carousel at the bottom of category pages
 * 'Collection Carousel' - the collection at the bottom of PDPs with products in the same family (i.e. if you're on the Hughes Sofa chair the Collection Carousel would have Hughes Chair, Hughes Loveseat, etc.)
 * 'Navbar' - the navbar component
 * 'Product to Product Carousel' - the product-to-product recommendation carousel on PDPs
 * 'Bambuser' - Bambuser video player
 * 'Product Card' - the product cards shown on category pages, PDPs, etc.
 * 'Cart' - the cart modal that pops up after clicking on cart icon
 * 'Newsletter Signup' - checkbox in footer/checkout/etc that allows marketing emails to be sent to customer
 * 'Swatch Request' - the swatch request modal
 * 'Share Cart' - the share cart modal
 * 'Account Creation' - the account creation modal
 * 'Product Grid' - the collection of product cards found on category pages and in search dropdown
 * 'Side Panel' - the right-hand panel on PDPs containing the product name, customizer, customer reviews, etc.
 * 'Delivery Update' - the modal that pops up on /tracking to inform users about a change to their delivery date
 * @param {string} properties.location - The location where the event occurred. Possibilities are listed below:
 * * For the 'Email Acquired' event, options are: 'Guest Checkout', 'Swatch Request', 'Justuno', or 'Account Creation'
 * * For the 'Product Clicked' event, options are: 'Home Page', 'Category Page',  'PDP', or 'Cart'
 * * For the 'Product Added to Wishlist' event, options are: 'Home Page', 'Category Page', or 'PDP'
 * * For the 'Protection Plan Added' event, options are: 'PDP', 'Cart', 'Checkout'
 * * For the 'Coupon Applied/Denied/Entered/Removed' events, options are: 'PDP' & 'Checkout'
 * * For the 'Fabric Favorited/Unfavorited' events, options are: 'PDP', 'Shop By Material', 'Pet Friendly Page', & 'Safeguard Fabrics Page'
 * @param {bool} properties.quickship - True if the product is available for quickship
 * @param {string} properties.currency - The currency (i.e. 'USD', 'CAD', etc.)
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/xQi7V_KhqI}
 */
export function productClicked(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertProductId(properties.productId));
    messages = messages.concat(assertCategory(properties.category));
    messages = messages.concat(assertIsClearance(properties.isClearance));
    messages = messages.concat(assertName(properties.name));
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(assertQuantity(properties.quantity));
    messages = messages.concat(assertSku(properties.sku));
    messages = messages.concat(assertVariant(properties.variant));
    messages = messages.concat(assertFullPrice(properties.fullPrice));
    messages = messages.concat(assertProductFamily(properties.productFamily));
    messages = messages.concat(assertContentIds(properties.contentIds));
    messages = messages.concat(assertIsFlashSale(properties.isFlashSale));
    messages = messages.concat(assertPosition(properties.position));
    messages = messages.concat(assertOptionalComponent(properties.component));
    messages = messages.concat(assertLocation(properties.location));
    messages = messages.concat(assertQuickship(properties.quickship));
    messages = messages.concat(assertCurrency(properties.currency));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Product Clicked',
        Object.keys(properties),
        [
          'productId',
          'category',
          'isClearance',
          'name',
          'price',
          'quantity',
          'sku',
          'variant',
          'fullPrice',
          'productFamily',
          'contentIds',
          'isFlashSale',
          'position',
          'component',
          'location',
          'quickship',
          'currency',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'xQi7V_KhqI',
        'ee9e42844f3e29f7a6af17cfcdf76f26767f5dbc6cada4773582b407d5517546',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Product Clicked',
      {
        product_id: properties.productId,
        category: properties.category,
        is_clearance: properties.isClearance,
        name: properties.name,
        price: properties.price,
        quantity: properties.quantity,
        sku: properties.sku,
        variant: properties.variant,
        full_price: properties.fullPrice,
        product_family: properties.productFamily,
        content_ids: properties.contentIds,
        is_flash_sale: properties.isFlashSale,
        position: properties.position,
        component: properties.component,
        location: properties.location,
        quickship: properties.quickship,
        currency: properties.currency,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'xQi7V_KhqI',
        'Product Clicked',
        messages,
        [
          { id: '3PXRzRK2KK', name: 'category', value: properties.category },
          { id: 'B71GIESiV8', name: 'location', value: properties.location },
          { id: 'EghVtONPP', name: 'name', value: properties.name },
          { id: 'F_0zRLZY6n', name: 'full_price', value: properties.fullPrice },
          {
            id: 'L98Svx9Tq_',
            name: 'content_ids',
            value: properties.contentIds,
          },
          { id: 'b6TXkvaohp', name: 'position', value: properties.position },
          { id: 'j-kP3_J7Rb', name: 'price', value: properties.price },
          { id: 'mEnst5CFw', name: 'currency', value: properties.currency },
          { id: 'nHu4WfjB0w', name: 'product_id', value: properties.productId },
          {
            id: 'ocjd8V8Of8',
            name: 'is_flash_sale',
            value: properties.isFlashSale,
          },
          { id: 'q2dBEu8QaF', name: 'quickship', value: properties.quickship },
          { id: 'r7TPl6ZqL8', name: 'quantity', value: properties.quantity },
          {
            id: 'rYLq0zrdEe',
            name: 'product_family',
            value: properties.productFamily,
          },
          { id: 'uI2-rwjYtt', name: 'sku', value: properties.sku },
          { id: 'wRrJhFCX_U', name: 'component', value: properties.component },
          {
            id: 'zPeher-BjQ',
            name: 'is_clearance',
            value: properties.isClearance,
          },
          { id: 'zsMuCAiZ4D', name: 'variant', value: properties.variant },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Product Clicked': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Product Clicked',
        {
          product_id: properties.productId,
          category: properties.category,
          is_clearance: properties.isClearance,
          name: properties.name,
          price: properties.price,
          quantity: properties.quantity,
          sku: properties.sku,
          variant: properties.variant,
          full_price: properties.fullPrice,
          product_family: properties.productFamily,
          content_ids: properties.contentIds,
          is_flash_sale: properties.isFlashSale,
          position: properties.position,
          component: properties.component,
          location: properties.location,
          quickship: properties.quickship,
          currency: properties.currency,
        },
        'xQi7V_KhqI',
        'ee9e42844f3e29f7a6af17cfcdf76f26767f5dbc6cada4773582b407d5517546'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Product Clicked', {
      product_id: properties.productId,
      category: properties.category,
      is_clearance: properties.isClearance,
      name: properties.name,
      price: properties.price,
      quantity: properties.quantity,
      sku: properties.sku,
      variant: properties.variant,
      full_price: properties.fullPrice,
      product_family: properties.productFamily,
      content_ids: properties.contentIds,
      is_flash_sale: properties.isFlashSale,
      position: properties.position,
      component: properties.component,
      location: properties.location,
      quickship: properties.quickship,
      currency: properties.currency,
    });
  } else {
    // do nothing
  }
}

/**
 * Protection Plan Added: Fired when a protection plan has been added for a product, either on PDP or checkout.
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} [properties.fabricColor] - The fabric's parent color (i.e. Green, Red, Blue, etc.).
 * If a user selected 'Decide Later', the fabric color should be 'Decide Later'.
 * @param {int} [properties.fabricId] - The fabric id (i.e. For Bentley Daisy it's 263)
 * @param {string} [properties.fabricName] - The fabric name (i.e. 'Taylor Felt Grey')
 * If a user selected 'Decide Later', the fabric name should be 'Decide Later'.
 * @param {bool} properties.favorited - Whether the product is part of their favorites or not
 * @param {float} properties.fullPrice - The full price of the product
 * @param {float} properties.planPrice - The price of the protection plan.
 * @param {string} properties.planName - The name of the protection plan (i.e. 'Life Happens', 'Pet Protector').
 * @param {float} properties.price - The price the user pays. If there is a sale, this is the sale price, if there is no sale, this is the full price
 * @param {string} properties.productFamily - The family of the product (i.e. 'Hughes', 'Soto', ect.).
 * @param {int} properties.productId - The 3-5 digit product id (i.e. `623` corresponds to Hughes Sofa)
 * @param {string} properties.location - The location where the event occurred. Possibilities are listed below:
 * * For the 'Email Acquired' event, options are: 'Guest Checkout', 'Swatch Request', 'Justuno', or 'Account Creation'
 * * For the 'Product Clicked' event, options are: 'Home Page', 'Category Page',  'PDP', or 'Cart'
 * * For the 'Product Added to Wishlist' event, options are: 'Home Page', 'Category Page', or 'PDP'
 * * For the 'Protection Plan Added' event, options are: 'PDP', 'Cart', 'Checkout'
 * * For the 'Coupon Applied/Denied/Entered/Removed' events, options are: 'PDP' & 'Checkout'
 * * For the 'Fabric Favorited/Unfavorited' events, options are: 'PDP', 'Shop By Material', 'Pet Friendly Page', & 'Safeguard Fabrics Page'
 * @param {string} properties.name - Full product name (i.e. 'Hughes Grand Sofa')
 * @param {string} properties.category - The product type (i.e. 'Chair', 'Sofa', etc.). This is NOT the category in terms of Joybird's use of the term 'category', this is the product type.
 * @param {string} [properties.component] - The component the event occurred in.
 * 'Trade Newsletter Signup' - the trade-only email capture
 * 'Trade Application' - trade application pages
 * 'Product Recommendation Carousel' - the carousel with the heading 'Recommended for you
 * 'Recently Viewed Carousel' - the recently viewed carousel at the bottom of category pages & pdps
 * 'Best Sellers Carousel' - the best sellers carousel at the bottom of category pages
 * 'Collection Carousel' - the collection at the bottom of PDPs with products in the same family (i.e. if you're on the Hughes Sofa chair the Collection Carousel would have Hughes Chair, Hughes Loveseat, etc.)
 * 'Navbar' - the navbar component
 * 'Product to Product Carousel' - the product-to-product recommendation carousel on PDPs
 * 'Bambuser' - Bambuser video player
 * 'Product Card' - the product cards shown on category pages, PDPs, etc.
 * 'Cart' - the cart modal that pops up after clicking on cart icon
 * 'Newsletter Signup' - checkbox in footer/checkout/etc that allows marketing emails to be sent to customer
 * 'Swatch Request' - the swatch request modal
 * 'Share Cart' - the share cart modal
 * 'Account Creation' - the account creation modal
 * 'Product Grid' - the collection of product cards found on category pages and in search dropdown
 * 'Side Panel' - the right-hand panel on PDPs containing the product name, customizer, customer reviews, etc.
 * 'Delivery Update' - the modal that pops up on /tracking to inform users about a change to their delivery date
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/xwtaYYCNKB}
 */
export function protectionPlanAdded(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(
      assertOptionalFabricColor(properties.fabricColor)
    );
    messages = messages.concat(assertOptionalFabricId(properties.fabricId));
    messages = messages.concat(assertOptionalFabricName(properties.fabricName));
    messages = messages.concat(assertFavorited(properties.favorited));
    messages = messages.concat(assertFullPrice(properties.fullPrice));
    messages = messages.concat(assertPlanPrice(properties.planPrice));
    messages = messages.concat(assertPlanName(properties.planName));
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(assertProductFamily(properties.productFamily));
    messages = messages.concat(assertProductId(properties.productId));
    messages = messages.concat(assertLocation(properties.location));
    messages = messages.concat(assertName(properties.name));
    messages = messages.concat(assertCategory(properties.category));
    messages = messages.concat(assertOptionalComponent(properties.component));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Protection Plan Added',
        Object.keys(properties),
        [
          'fabricColor',
          'fabricId',
          'fabricName',
          'favorited',
          'fullPrice',
          'planPrice',
          'planName',
          'price',
          'productFamily',
          'productId',
          'location',
          'name',
          'category',
          'component',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'xwtaYYCNKB',
        'c997bdce5231fed83f85f26070a7d9fb0b1b9a72a1dd19b43c0a6b0e4fd1ad4c',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Protection Plan Added',
      {
        fabric_color: properties.fabricColor,
        fabric_id: properties.fabricId,
        fabric_name: properties.fabricName,
        favorited: properties.favorited,
        full_price: properties.fullPrice,
        plan_price: properties.planPrice,
        plan_name: properties.planName,
        price: properties.price,
        product_family: properties.productFamily,
        product_id: properties.productId,
        location: properties.location,
        name: properties.name,
        category: properties.category,
        component: properties.component,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'xwtaYYCNKB',
        'Protection Plan Added',
        messages,
        [
          { id: '3PXRzRK2KK', name: 'category', value: properties.category },
          { id: 'B71GIESiV8', name: 'location', value: properties.location },
          { id: 'EghVtONPP', name: 'name', value: properties.name },
          { id: 'F_0zRLZY6n', name: 'full_price', value: properties.fullPrice },
          { id: 'VXbdbXehgF', name: 'plan_name', value: properties.planName },
          {
            id: 'cZN2CHE3RG',
            name: 'fabric_color',
            value: properties.fabricColor,
          },
          { id: 'hl2Uh6tCvm', name: 'favorited', value: properties.favorited },
          { id: 'j-kP3_J7Rb', name: 'price', value: properties.price },
          { id: 'nHu4WfjB0w', name: 'product_id', value: properties.productId },
          { id: 'nKky3DTbmP', name: 'plan_price', value: properties.planPrice },
          {
            id: 'rYLq0zrdEe',
            name: 'product_family',
            value: properties.productFamily,
          },
          { id: 'vl8jHhQKP6', name: 'fabric_id', value: properties.fabricId },
          { id: 'wRrJhFCX_U', name: 'component', value: properties.component },
          {
            id: 'z-KPDmLIa_',
            name: 'fabric_name',
            value: properties.fabricName,
          },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Protection Plan Added': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Protection Plan Added',
        {
          fabric_color: properties.fabricColor,
          fabric_id: properties.fabricId,
          fabric_name: properties.fabricName,
          favorited: properties.favorited,
          full_price: properties.fullPrice,
          plan_price: properties.planPrice,
          plan_name: properties.planName,
          price: properties.price,
          product_family: properties.productFamily,
          product_id: properties.productId,
          location: properties.location,
          name: properties.name,
          category: properties.category,
          component: properties.component,
        },
        'xwtaYYCNKB',
        'c997bdce5231fed83f85f26070a7d9fb0b1b9a72a1dd19b43c0a6b0e4fd1ad4c'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Protection Plan Added', {
      fabric_color: properties.fabricColor,
      fabric_id: properties.fabricId,
      fabric_name: properties.fabricName,
      favorited: properties.favorited,
      full_price: properties.fullPrice,
      plan_price: properties.planPrice,
      plan_name: properties.planName,
      price: properties.price,
      product_family: properties.productFamily,
      product_id: properties.productId,
      location: properties.location,
      name: properties.name,
      category: properties.category,
      component: properties.component,
    });
  } else {
    // do nothing
  }
}

/**
 * Product Removed: Fired when a product has been removed from cart. This should NOT fire when quantity is decreased in cart where quantity > 1.
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.category - The product type (i.e. 'Chair', 'Sofa', etc.). This is NOT the category in terms of Joybird's use of the term 'category', this is the product type.
 * @param {string} properties.name - Full product name (i.e. 'Hughes Grand Sofa')
 * @param {float} properties.price - The price the user pays. If there is a sale, this is the sale price, if there is no sale, this is the full price
 * @param {int} properties.productId - The 3-5 digit product id (i.e. `623` corresponds to Hughes Sofa)
 * @param {int} properties.quantity - The quantity of products
 * @param {string} properties.sku - The full sku (i.e. 'JB103853-CF200-WS03')
 * Product Viewed -> Send the full sku of the first image shown (not the fabric that's selected)
 * @param {string} properties.variant - All product options for a product, separated by a comma and a space (i.e. 'Taylor Felt Grey, Mocha, Left, Cone').
 * If a user selected 'Decide Later', the variant should be 'Decide Later'.
 * @param {string} properties.productFamily - The family of the product (i.e. 'Hughes', 'Soto', ect.).
 * @param {string} properties.cartId - The id of the cart (i.e. 194823)
 * @param {string} properties.fabricName - The fabric name (i.e. 'Taylor Felt Grey')
 * If a user selected 'Decide Later', the fabric name should be 'Decide Later'.
 * @param {string} properties.fabricColor - The fabric's parent color (i.e. Green, Red, Blue, etc.).
 * If a user selected 'Decide Later', the fabric color should be 'Decide Later'.
 * @param {string} properties.currency - The currency (i.e. 'USD', 'CAD', etc.)
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/Eb1SREPUpt}
 */
export function productRemoved(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertCategory(properties.category));
    messages = messages.concat(assertName(properties.name));
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(assertProductId(properties.productId));
    messages = messages.concat(assertQuantity(properties.quantity));
    messages = messages.concat(assertSku(properties.sku));
    messages = messages.concat(assertVariant(properties.variant));
    messages = messages.concat(assertProductFamily(properties.productFamily));
    messages = messages.concat(assertCartId(properties.cartId));
    messages = messages.concat(assertFabricName(properties.fabricName));
    messages = messages.concat(assertFabricColor(properties.fabricColor));
    messages = messages.concat(assertCurrency(properties.currency));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Product Removed',
        Object.keys(properties),
        [
          'category',
          'name',
          'price',
          'productId',
          'quantity',
          'sku',
          'variant',
          'productFamily',
          'cartId',
          'fabricName',
          'fabricColor',
          'currency',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'Eb1SREPUpt',
        '1900b9098815ffbd86c95df97ab273dbdf67faa47407dc2f9da4852212edf6b7',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Product Removed',
      {
        category: properties.category,
        name: properties.name,
        price: properties.price,
        product_id: properties.productId,
        quantity: properties.quantity,
        sku: properties.sku,
        variant: properties.variant,
        product_family: properties.productFamily,
        cart_id: properties.cartId,
        fabric_name: properties.fabricName,
        fabric_color: properties.fabricColor,
        currency: properties.currency,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'Eb1SREPUpt',
        'Product Removed',
        messages,
        [
          { id: '3PXRzRK2KK', name: 'category', value: properties.category },
          { id: 'EghVtONPP', name: 'name', value: properties.name },
          { id: 'KALt_3pVFV', name: 'cart_id', value: properties.cartId },
          {
            id: 'cZN2CHE3RG',
            name: 'fabric_color',
            value: properties.fabricColor,
          },
          { id: 'j-kP3_J7Rb', name: 'price', value: properties.price },
          { id: 'mEnst5CFw', name: 'currency', value: properties.currency },
          { id: 'nHu4WfjB0w', name: 'product_id', value: properties.productId },
          { id: 'r7TPl6ZqL8', name: 'quantity', value: properties.quantity },
          {
            id: 'rYLq0zrdEe',
            name: 'product_family',
            value: properties.productFamily,
          },
          { id: 'uI2-rwjYtt', name: 'sku', value: properties.sku },
          {
            id: 'z-KPDmLIa_',
            name: 'fabric_name',
            value: properties.fabricName,
          },
          { id: 'zsMuCAiZ4D', name: 'variant', value: properties.variant },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Product Removed': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Product Removed',
        {
          category: properties.category,
          name: properties.name,
          price: properties.price,
          product_id: properties.productId,
          quantity: properties.quantity,
          sku: properties.sku,
          variant: properties.variant,
          product_family: properties.productFamily,
          cart_id: properties.cartId,
          fabric_name: properties.fabricName,
          fabric_color: properties.fabricColor,
          currency: properties.currency,
        },
        'Eb1SREPUpt',
        '1900b9098815ffbd86c95df97ab273dbdf67faa47407dc2f9da4852212edf6b7'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Product Removed', {
      category: properties.category,
      name: properties.name,
      price: properties.price,
      product_id: properties.productId,
      quantity: properties.quantity,
      sku: properties.sku,
      variant: properties.variant,
      product_family: properties.productFamily,
      cart_id: properties.cartId,
      fabric_name: properties.fabricName,
      fabric_color: properties.fabricColor,
      currency: properties.currency,
    });
  } else {
    // do nothing
  }
}

/**
 * Variation Selected: Fired each time a product option value is selected, whether it be fabric, orientation, etc.
 *
 * @param {object} properties - the properties associated with this event
 * @param {Array<string>} properties.contentIds - The base product sku(s) (i.e. if the sku is 'JB11069110-CF423-WS03', the value for Content IDs should be ['JB11069110']).
 * @param {string} [properties.fabricColor] - The fabric's parent color (i.e. Green, Red, Blue, etc.).
 * If a user selected 'Decide Later', the fabric color should be 'Decide Later'.
 * @param {int} [properties.fabricId] - The fabric id (i.e. For Bentley Daisy it's 263)
 * @param {string} [properties.fabricName] - The fabric name (i.e. 'Taylor Felt Grey')
 * If a user selected 'Decide Later', the fabric name should be 'Decide Later'.
 * @param {float} properties.fullPrice - The full price of the product
 * @param {float} properties.price - The price the user pays. If there is a sale, this is the sale price, if there is no sale, this is the full price
 * @param {string} properties.productFamily - The family of the product (i.e. 'Hughes', 'Soto', ect.).
 * @param {int} properties.productId - The 3-5 digit product id (i.e. `623` corresponds to Hughes Sofa)
 * @param {string} properties.sku - The full sku (i.e. 'JB103853-CF200-WS03')
 * Product Viewed -> Send the full sku of the first image shown (not the fabric that's selected)
 * @param {string} properties.name - Full product name (i.e. 'Hughes Grand Sofa')
 * @param {string} properties.currency - The currency (i.e. 'USD', 'CAD', etc.)
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/ht0r6FSsNB}
 */
export function variationSelected(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertContentIds(properties.contentIds));
    messages = messages.concat(
      assertOptionalFabricColor(properties.fabricColor)
    );
    messages = messages.concat(assertOptionalFabricId(properties.fabricId));
    messages = messages.concat(assertOptionalFabricName(properties.fabricName));
    messages = messages.concat(assertFullPrice(properties.fullPrice));
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(assertProductFamily(properties.productFamily));
    messages = messages.concat(assertProductId(properties.productId));
    messages = messages.concat(assertSku(properties.sku));
    messages = messages.concat(assertName(properties.name));
    messages = messages.concat(assertCurrency(properties.currency));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Variation Selected',
        Object.keys(properties),
        [
          'contentIds',
          'fabricColor',
          'fabricId',
          'fabricName',
          'fullPrice',
          'price',
          'productFamily',
          'productId',
          'sku',
          'name',
          'currency',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'ht0r6FSsNB',
        '84f4591388baf3563eb5876e9150a2561accd391c7dccf5ea5708a2721df6390',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Variation Selected',
      {
        content_ids: properties.contentIds,
        fabric_color: properties.fabricColor,
        fabric_id: properties.fabricId,
        fabric_name: properties.fabricName,
        full_price: properties.fullPrice,
        price: properties.price,
        product_family: properties.productFamily,
        product_id: properties.productId,
        sku: properties.sku,
        name: properties.name,
        currency: properties.currency,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'ht0r6FSsNB',
        'Variation Selected',
        messages,
        [
          { id: 'EghVtONPP', name: 'name', value: properties.name },
          { id: 'F_0zRLZY6n', name: 'full_price', value: properties.fullPrice },
          {
            id: 'L98Svx9Tq_',
            name: 'content_ids',
            value: properties.contentIds,
          },
          {
            id: 'cZN2CHE3RG',
            name: 'fabric_color',
            value: properties.fabricColor,
          },
          { id: 'j-kP3_J7Rb', name: 'price', value: properties.price },
          { id: 'mEnst5CFw', name: 'currency', value: properties.currency },
          { id: 'nHu4WfjB0w', name: 'product_id', value: properties.productId },
          {
            id: 'rYLq0zrdEe',
            name: 'product_family',
            value: properties.productFamily,
          },
          { id: 'uI2-rwjYtt', name: 'sku', value: properties.sku },
          { id: 'vl8jHhQKP6', name: 'fabric_id', value: properties.fabricId },
          {
            id: 'z-KPDmLIa_',
            name: 'fabric_name',
            value: properties.fabricName,
          },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Variation Selected': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Variation Selected',
        {
          content_ids: properties.contentIds,
          fabric_color: properties.fabricColor,
          fabric_id: properties.fabricId,
          fabric_name: properties.fabricName,
          full_price: properties.fullPrice,
          price: properties.price,
          product_family: properties.productFamily,
          product_id: properties.productId,
          sku: properties.sku,
          name: properties.name,
          currency: properties.currency,
        },
        'ht0r6FSsNB',
        '84f4591388baf3563eb5876e9150a2561accd391c7dccf5ea5708a2721df6390'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Variation Selected', {
      content_ids: properties.contentIds,
      fabric_color: properties.fabricColor,
      fabric_id: properties.fabricId,
      fabric_name: properties.fabricName,
      full_price: properties.fullPrice,
      price: properties.price,
      product_family: properties.productFamily,
      product_id: properties.productId,
      sku: properties.sku,
      name: properties.name,
      currency: properties.currency,
    });
  } else {
    // do nothing
  }
}

/**
 * Swatches Requested: Fired when a user is confirmed to have ordered swatches.
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.userId_ - The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param {string} properties.email - The email address (i.e. 'christoph@joybird.com')
 * @param {int} properties.swatchRequestId - The auto-generated swatch request ID from Backbone
 * @param {string} [properties.swatchList] - The list of swatches requested
 * @param {string} [properties.requestPage] - The url of the page where the swatches or trade account were requested
 * @param {object} properties.shippingAddress - Shipping address object
 * @param {string} properties.backendEmail - Email address from the server
 * @param {string} properties.location - The location where the event occurred. Possibilities are listed below:
 * * For the 'Email Acquired' event, options are: 'Guest Checkout', 'Swatch Request', 'Justuno', or 'Account Creation'
 * * For the 'Product Clicked' event, options are: 'Home Page', 'Category Page',  'PDP', or 'Cart'
 * * For the 'Product Added to Wishlist' event, options are: 'Home Page', 'Category Page', or 'PDP'
 * * For the 'Protection Plan Added' event, options are: 'PDP', 'Cart', 'Checkout'
 * * For the 'Coupon Applied/Denied/Entered/Removed' events, options are: 'PDP' & 'Checkout'
 * * For the 'Fabric Favorited/Unfavorited' events, options are: 'PDP', 'Shop By Material', 'Pet Friendly Page', & 'Safeguard Fabrics Page'
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/jo1ijIPFZs}
 */
export function swatchesRequested(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertUserId_(properties.userId_));
    messages = messages.concat(assertEmail(properties.email));
    messages = messages.concat(
      assertSwatchRequestId(properties.swatchRequestId)
    );
    messages = messages.concat(assertOptionalSwatchList(properties.swatchList));
    messages = messages.concat(
      assertOptionalRequestPage(properties.requestPage)
    );
    messages = messages.concat(
      assertShippingAddress(properties.shippingAddress)
    );
    messages = messages.concat(assertBackendEmail(properties.backendEmail));
    messages = messages.concat(assertLocation(properties.location));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Swatches Requested',
        Object.keys(properties),
        [
          'userId_',
          'email',
          'swatchRequestId',
          'swatchList',
          'requestPage',
          'shippingAddress',
          'backendEmail',
          'location',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'jo1ijIPFZs',
        'fbdd09c4b5d19d35f9b0ed30529d35ac5bdeabbdbaafd279d881979c9f78a4eb',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Swatches Requested',
      {
        email: properties.email,
        swatch_request_id: properties.swatchRequestId,
        swatch_list: properties.swatchList,
        request_page: properties.requestPage,
        shipping_address: {
          address_name: properties.shippingAddress.addressName,
          address_line_1: properties.shippingAddress.addressLine1,
          address_line_2: properties.shippingAddress.addressLine2,
          city: properties.shippingAddress.city,
          state: properties.shippingAddress.state,
          zip: properties.shippingAddress.zip,
          country: properties.shippingAddress.country,
          company: properties.shippingAddress.company,
        },
        location: properties.location,
      },
      {
        backend_email: properties.backendEmail,
      },
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'jo1ijIPFZs',
        'Swatches Requested',
        messages,
        [
          { id: '4rYN-Q_mp', name: 'email', value: properties.email },
          { id: '4v0PdN0X0', name: 'company', value: properties.company },
          {
            id: '8Pl1k62qA-',
            name: 'address_line_2',
            value: properties.addressLine2,
          },
          { id: '9YayH8EfP9', name: 'zip', value: properties.zip },
          { id: 'B71GIESiV8', name: 'location', value: properties.location },
          {
            id: 'D_G2GVXHOW',
            name: 'address_name',
            value: properties.addressName,
          },
          {
            id: 'DuM7mUDaZL',
            name: 'swatch_request_id',
            value: properties.swatchRequestId,
          },
          {
            id: 'O8elzNnkN2',
            name: 'address_line_1',
            value: properties.addressLine1,
          },
          {
            id: 'PuQh3C0Z5M',
            name: 'shipping_address',
            value: properties.shippingAddress,
          },
          { id: 'Sy9VxdW7ja', name: 'state', value: properties.state },
          { id: '_Di-rVVVJN', name: 'country', value: properties.country },
          {
            id: 'dWamj6Ugcm',
            name: 'request_page',
            value: properties.requestPage,
          },
          {
            id: 'eRixxFmBU',
            name: 'swatch_list',
            value: properties.swatchList,
          },
          { id: 'zE__6S8gVh', name: 'city', value: properties.city },
        ],
        [
          {
            id: 'zjUFB7hRiT',
            name: 'backend_email',
            value: properties.backendEmail,
          },
        ],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Swatches Requested': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Swatches Requested',
        {
          email: properties.email,
          swatch_request_id: properties.swatchRequestId,
          swatch_list: properties.swatchList,
          request_page: properties.requestPage,
          shipping_address: {
            address_name: properties.shippingAddress.addressName,
            address_line_1: properties.shippingAddress.addressLine1,
            address_line_2: properties.shippingAddress.addressLine2,
            city: properties.shippingAddress.city,
            state: properties.shippingAddress.state,
            zip: properties.shippingAddress.zip,
            country: properties.shippingAddress.country,
            company: properties.shippingAddress.company,
          },
          location: properties.location,
        },
        'jo1ijIPFZs',
        'fbdd09c4b5d19d35f9b0ed30529d35ac5bdeabbdbaafd279d881979c9f78a4eb'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.setUserProperties(properties.userId_, {
      email: properties.backendEmail,
    });
    RudderstackJavascript.logEvent('Swatches Requested', {
      email: properties.email,
      swatch_request_id: properties.swatchRequestId,
      swatch_list: properties.swatchList,
      request_page: properties.requestPage,
      shipping_address: {
        address_name: properties.shippingAddress.addressName,
        address_line_1: properties.shippingAddress.addressLine1,
        address_line_2: properties.shippingAddress.addressLine2,
        city: properties.shippingAddress.city,
        state: properties.shippingAddress.state,
        zip: properties.shippingAddress.zip,
        country: properties.shippingAddress.country,
        company: properties.shippingAddress.company,
      },
      location: properties.location,
    });
  } else {
    // do nothing
  }
}

/**
 * Upholstery Filtered: Fired when a user filters the upholstery on PDPs.
 *
 * @param {object} properties - the properties associated with this event
 * @param {float} [properties.fullPrice] - The full price of the product
 * @param {float} [properties.price] - The price the user pays. If there is a sale, this is the sale price, if there is no sale, this is the full price
 * @param {string} [properties.productFamily] - The family of the product (i.e. 'Hughes', 'Soto', ect.).
 * @param {int} [properties.productId] - The 3-5 digit product id (i.e. `623` corresponds to Hughes Sofa)
 * @param {string} properties.upholsteryFilter - Filter applied on upholstery filter (i.e. 'popular', 'all', 'pet-friendly', 'safeguard', and color selections i.e. 'color: blue', 'color: red', etc.). Format should be <filter>:<value> i.e. co
 * @param {string} [properties.upholsterySort] - Upholstery sorting on pdps. Sort name followed by a colon and 'ascending' or 'descending' (if applicable) (i.e. 'safeguard', 'popularity: descending', 'price: ascending', 'pet-friendly', etc.)
 * @param {string} properties.name - Full product name (i.e. 'Hughes Grand Sofa')
 * @param {string} [properties.category] - The product type (i.e. 'Chair', 'Sofa', etc.). This is NOT the category in terms of Joybird's use of the term 'category', this is the product type.
 * @param {string} properties.location - The location where the event occurred. Possibilities are listed below:
 * * For the 'Email Acquired' event, options are: 'Guest Checkout', 'Swatch Request', 'Justuno', or 'Account Creation'
 * * For the 'Product Clicked' event, options are: 'Home Page', 'Category Page',  'PDP', or 'Cart'
 * * For the 'Product Added to Wishlist' event, options are: 'Home Page', 'Category Page', or 'PDP'
 * * For the 'Protection Plan Added' event, options are: 'PDP', 'Cart', 'Checkout'
 * * For the 'Coupon Applied/Denied/Entered/Removed' events, options are: 'PDP' & 'Checkout'
 * * For the 'Fabric Favorited/Unfavorited' events, options are: 'PDP', 'Shop By Material', 'Pet Friendly Page', & 'Safeguard Fabrics Page'
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/MnLwm6gg9a}
 */
export function upholsteryFiltered(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertOptionalFullPrice(properties.fullPrice));
    messages = messages.concat(assertOptionalPrice(properties.price));
    messages = messages.concat(
      assertOptionalProductFamily(properties.productFamily)
    );
    messages = messages.concat(assertOptionalProductId(properties.productId));
    messages = messages.concat(
      assertUpholsteryFilter(properties.upholsteryFilter)
    );
    messages = messages.concat(
      assertOptionalUpholsterySort(properties.upholsterySort)
    );
    messages = messages.concat(assertName(properties.name));
    messages = messages.concat(assertOptionalCategory(properties.category));
    messages = messages.concat(assertLocation(properties.location));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Upholstery Filtered',
        Object.keys(properties),
        [
          'fullPrice',
          'price',
          'productFamily',
          'productId',
          'upholsteryFilter',
          'upholsterySort',
          'name',
          'category',
          'location',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'MnLwm6gg9a',
        '0169fc62b25f781a0b067196d23db874b627946636c32eff78299973abc6c96b',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Upholstery Filtered',
      {
        full_price: properties.fullPrice,
        price: properties.price,
        product_family: properties.productFamily,
        product_id: properties.productId,
        upholstery_filter: properties.upholsteryFilter,
        upholstery_sort: properties.upholsterySort,
        name: properties.name,
        category: properties.category,
        location: properties.location,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'MnLwm6gg9a',
        'Upholstery Filtered',
        messages,
        [
          { id: '3PXRzRK2KK', name: 'category', value: properties.category },
          {
            id: '6HxqEgV2-H',
            name: 'upholstery_sort',
            value: properties.upholsterySort,
          },
          { id: 'B71GIESiV8', name: 'location', value: properties.location },
          {
            id: 'DnTlFDY3ZU',
            name: 'upholstery_filter',
            value: properties.upholsteryFilter,
          },
          { id: 'EghVtONPP', name: 'name', value: properties.name },
          { id: 'F_0zRLZY6n', name: 'full_price', value: properties.fullPrice },
          { id: 'j-kP3_J7Rb', name: 'price', value: properties.price },
          { id: 'nHu4WfjB0w', name: 'product_id', value: properties.productId },
          {
            id: 'rYLq0zrdEe',
            name: 'product_family',
            value: properties.productFamily,
          },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Upholstery Filtered': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Upholstery Filtered',
        {
          full_price: properties.fullPrice,
          price: properties.price,
          product_family: properties.productFamily,
          product_id: properties.productId,
          upholstery_filter: properties.upholsteryFilter,
          upholstery_sort: properties.upholsterySort,
          name: properties.name,
          category: properties.category,
          location: properties.location,
        },
        'MnLwm6gg9a',
        '0169fc62b25f781a0b067196d23db874b627946636c32eff78299973abc6c96b'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Upholstery Filtered', {
      full_price: properties.fullPrice,
      price: properties.price,
      product_family: properties.productFamily,
      product_id: properties.productId,
      upholstery_filter: properties.upholsteryFilter,
      upholstery_sort: properties.upholsterySort,
      name: properties.name,
      category: properties.category,
      location: properties.location,
    });
  } else {
    // do nothing
  }
}

/**
 * Upsell Product Added: Fired when an upsell product is added to cart. The properties in this even should be for the upsold product, NOT the parent product
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} [properties.fabricColor] - The fabric's parent color (i.e. Green, Red, Blue, etc.).
 * If a user selected 'Decide Later', the fabric color should be 'Decide Later'.
 * @param {int} [properties.fabricId] - The fabric id (i.e. For Bentley Daisy it's 263)
 * @param {string} [properties.fabricName] - The fabric name (i.e. 'Taylor Felt Grey')
 * If a user selected 'Decide Later', the fabric name should be 'Decide Later'.
 * @param {bool} properties.favorited - Whether the product is part of their favorites or not
 * @param {float} properties.fullPrice - The full price of the product
 * @param {float} properties.price - The price the user pays. If there is a sale, this is the sale price, if there is no sale, this is the full price
 * @param {string} properties.productFamily - The family of the product (i.e. 'Hughes', 'Soto', ect.).
 * @param {int} properties.productId - The 3-5 digit product id (i.e. `623` corresponds to Hughes Sofa)
 * @param {string} properties.name - Full product name (i.e. 'Hughes Grand Sofa')
 * @param {string} properties.category - The product type (i.e. 'Chair', 'Sofa', etc.). This is NOT the category in terms of Joybird's use of the term 'category', this is the product type.
 * @param {string} properties.sku - The full sku (i.e. 'JB103853-CF200-WS03')
 * Product Viewed -> Send the full sku of the first image shown (not the fabric that's selected)
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/rymvju2ETO}
 */
export function upsellProductAdded(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(
      assertOptionalFabricColor(properties.fabricColor)
    );
    messages = messages.concat(assertOptionalFabricId(properties.fabricId));
    messages = messages.concat(assertOptionalFabricName(properties.fabricName));
    messages = messages.concat(assertFavorited(properties.favorited));
    messages = messages.concat(assertFullPrice(properties.fullPrice));
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(assertProductFamily(properties.productFamily));
    messages = messages.concat(assertProductId(properties.productId));
    messages = messages.concat(assertName(properties.name));
    messages = messages.concat(assertCategory(properties.category));
    messages = messages.concat(assertSku(properties.sku));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Upsell Product Added',
        Object.keys(properties),
        [
          'fabricColor',
          'fabricId',
          'fabricName',
          'favorited',
          'fullPrice',
          'price',
          'productFamily',
          'productId',
          'name',
          'category',
          'sku',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'rymvju2ETO',
        'f3124e0ab8196c98f1d0b33658d15a6e70549f6c79ddbf4a7d26c1878e172850',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Upsell Product Added',
      {
        fabric_color: properties.fabricColor,
        fabric_id: properties.fabricId,
        fabric_name: properties.fabricName,
        favorited: properties.favorited,
        full_price: properties.fullPrice,
        price: properties.price,
        product_family: properties.productFamily,
        product_id: properties.productId,
        name: properties.name,
        category: properties.category,
        sku: properties.sku,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'rymvju2ETO',
        'Upsell Product Added',
        messages,
        [
          { id: '3PXRzRK2KK', name: 'category', value: properties.category },
          { id: 'EghVtONPP', name: 'name', value: properties.name },
          { id: 'F_0zRLZY6n', name: 'full_price', value: properties.fullPrice },
          {
            id: 'cZN2CHE3RG',
            name: 'fabric_color',
            value: properties.fabricColor,
          },
          { id: 'hl2Uh6tCvm', name: 'favorited', value: properties.favorited },
          { id: 'j-kP3_J7Rb', name: 'price', value: properties.price },
          { id: 'nHu4WfjB0w', name: 'product_id', value: properties.productId },
          {
            id: 'rYLq0zrdEe',
            name: 'product_family',
            value: properties.productFamily,
          },
          { id: 'uI2-rwjYtt', name: 'sku', value: properties.sku },
          { id: 'vl8jHhQKP6', name: 'fabric_id', value: properties.fabricId },
          {
            id: 'z-KPDmLIa_',
            name: 'fabric_name',
            value: properties.fabricName,
          },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Upsell Product Added': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Upsell Product Added',
        {
          fabric_color: properties.fabricColor,
          fabric_id: properties.fabricId,
          fabric_name: properties.fabricName,
          favorited: properties.favorited,
          full_price: properties.fullPrice,
          price: properties.price,
          product_family: properties.productFamily,
          product_id: properties.productId,
          name: properties.name,
          category: properties.category,
          sku: properties.sku,
        },
        'rymvju2ETO',
        'f3124e0ab8196c98f1d0b33658d15a6e70549f6c79ddbf4a7d26c1878e172850'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Upsell Product Added', {
      fabric_color: properties.fabricColor,
      fabric_id: properties.fabricId,
      fabric_name: properties.fabricName,
      favorited: properties.favorited,
      full_price: properties.fullPrice,
      price: properties.price,
      product_family: properties.productFamily,
      product_id: properties.productId,
      name: properties.name,
      category: properties.category,
      sku: properties.sku,
    });
  } else {
    // do nothing
  }
}

/**
 * Product List Filtered: Fired when a user filters or sorts a category page.
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.category - The product type (i.e. 'Chair', 'Sofa', etc.). This is NOT the category in terms of Joybird's use of the term 'category', this is the product type.
 * @param {int} properties.categoryId - The category id. This is NOT the product type id.
 * @param {Array<object>} properties.filters - All filters that are applied on category pages (i.e. [{type: 'material', value: 'fabric'}, {type: 'seating', value: '3+ seater'}]
 * @param {Array<object>} properties.products - A list of products.
 * @param {Array<object>} properties.sorts - Product sorting that the customer is using (i.e. sorts: [
 *     {
 *       type: 'price',
 *       value: 'desc'
 *     }
 *   ],)
 * @param {string} properties.listId - The category name or PLP page name (i.e. 'Bedroom Furniture', 'Chairs', 'Warm & Inviting', etc.)
 * Docs: https://rudderstack.com/docs/destinations/analytics/google-analytics-ga/#measuring-product-impressions
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/Oc0p8_ohJc}
 */
export function productListFiltered(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertCategory(properties.category));
    messages = messages.concat(assertCategoryId(properties.categoryId));
    messages = messages.concat(assertFilters(properties.filters));
    messages = messages.concat(assertProducts(properties.products));
    messages = messages.concat(assertSorts(properties.sorts));
    messages = messages.concat(assertListId(properties.listId));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Product List Filtered',
        Object.keys(properties),
        ['category', 'categoryId', 'filters', 'products', 'sorts', 'listId']
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'Oc0p8_ohJc',
        '6eac00b521ef567e1009970047dece4aed2a2a2ccaf1875c4b5b833182e8915c',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Product List Filtered',
      {
        category: properties.category,
        category_id: properties.categoryId,
        filters: properties.filters.map(function(value) {
          return {
            value: value.value,
            type: value.type,
          };
        }),
        products: properties.products.map(function(value) {
          return {
            product_id: value.productId,
            category: value.category,
            is_clearance: value.isClearance,
            name: value.name,
            price: value.price,
            quantity: value.quantity,
            sku: value.sku,
            variant: value.variant,
            is_protection_plan_eligible: value.isProtectionPlanEligible,
            has_protection_plan: value.hasProtectionPlan,
            is_decide_later: value.isDecideLater,
            tracking_url: value.trackingUrl,
            tracking_number: value.trackingNumber,
            protection_plan_cost: value.protectionPlanCost,
            delivery_type: value.deliveryType,
            shipping_method: value.shippingMethod,
            shipping_carrier: value.shippingCarrier,
            fabric_name: value.fabricName,
            fabric_color: value.fabricColor,
            currency: value.currency,
            full_price: value.fullPrice,
            is_flash_sale: value.isFlashSale,
            google_product_category: value.googleProductCategory,
          };
        }),
        sorts: properties.sorts.map(function(value) {
          return {
            value: value.value,
            type: value.type,
          };
        }),
        list_id: properties.listId,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'Oc0p8_ohJc',
        'Product List Filtered',
        messages,
        [
          {
            id: '-Be6jz-r5H',
            name: 'delivery_type',
            value: properties.deliveryType,
          },
          {
            id: '-r2A9Y6Dak',
            name: 'protection_plan_cost',
            value: properties.protectionPlanCost,
          },
          { id: '3PXRzRK2KK', name: 'category', value: properties.category },
          {
            id: '4HTRW0TFrB',
            name: 'shipping_method',
            value: properties.shippingMethod,
          },
          { id: 'EghVtONPP', name: 'name', value: properties.name },
          { id: 'F_0zRLZY6n', name: 'full_price', value: properties.fullPrice },
          {
            id: 'Fwb-BjQjH1V',
            name: 'is_decide_later',
            value: properties.isDecideLater,
          },
          { id: 'Ga6x7Tn-b9', name: 'value', value: properties.value },
          {
            id: 'KwMPoO_BRg',
            name: 'tracking_number',
            value: properties.trackingNumber,
          },
          {
            id: 'MoIQmnL5AHl',
            name: 'has_protection_plan',
            value: properties.hasProtectionPlan,
          },
          {
            id: 'NdU9dcPzjy',
            name: 'is_protection_plan_eligible',
            value: properties.isProtectionPlanEligible,
          },
          {
            id: 'XJ78zva-wm',
            name: 'category_id',
            value: properties.categoryId,
          },
          {
            id: 'YsXH4GchTs',
            name: 'shipping_carrier',
            value: properties.shippingCarrier,
          },
          { id: 'aQjbzLPQy', name: 'list_id', value: properties.listId },
          { id: 'ay-Gx5bwiX', name: 'type', value: properties.type },
          {
            id: 'cZN2CHE3RG',
            name: 'fabric_color',
            value: properties.fabricColor,
          },
          { id: 'j-kP3_J7Rb', name: 'price', value: properties.price },
          { id: 'lq0PSuvEbT', name: 'filters', value: properties.filters },
          { id: 'mEnst5CFw', name: 'currency', value: properties.currency },
          { id: 'nHu4WfjB0w', name: 'product_id', value: properties.productId },
          {
            id: 'ocjd8V8Of8',
            name: 'is_flash_sale',
            value: properties.isFlashSale,
          },
          { id: 'pnGgVwJOHO', name: 'sorts', value: properties.sorts },
          {
            id: 'r0tvvT0Yd7',
            name: 'tracking_url',
            value: properties.trackingUrl,
          },
          { id: 'r7TPl6ZqL8', name: 'quantity', value: properties.quantity },
          { id: 'rGITDesDtb', name: 'products', value: properties.products },
          { id: 'uI2-rwjYtt', name: 'sku', value: properties.sku },
          {
            id: 'vaWiuR41RoGc8FaMrF5pT',
            name: 'google_product_category',
            value: properties.googleProductCategory,
          },
          {
            id: 'z-KPDmLIa_',
            name: 'fabric_name',
            value: properties.fabricName,
          },
          {
            id: 'zPeher-BjQ',
            name: 'is_clearance',
            value: properties.isClearance,
          },
          { id: 'zsMuCAiZ4D', name: 'variant', value: properties.variant },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Product List Filtered': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Product List Filtered',
        {
          category: properties.category,
          category_id: properties.categoryId,
          filters: properties.filters.map(function(value) {
            return {
              value: value.value,
              type: value.type,
            };
          }),
          products: properties.products.map(function(value) {
            return {
              product_id: value.productId,
              category: value.category,
              is_clearance: value.isClearance,
              name: value.name,
              price: value.price,
              quantity: value.quantity,
              sku: value.sku,
              variant: value.variant,
              is_protection_plan_eligible: value.isProtectionPlanEligible,
              has_protection_plan: value.hasProtectionPlan,
              is_decide_later: value.isDecideLater,
              tracking_url: value.trackingUrl,
              tracking_number: value.trackingNumber,
              protection_plan_cost: value.protectionPlanCost,
              delivery_type: value.deliveryType,
              shipping_method: value.shippingMethod,
              shipping_carrier: value.shippingCarrier,
              fabric_name: value.fabricName,
              fabric_color: value.fabricColor,
              currency: value.currency,
              full_price: value.fullPrice,
              is_flash_sale: value.isFlashSale,
              google_product_category: value.googleProductCategory,
            };
          }),
          sorts: properties.sorts.map(function(value) {
            return {
              value: value.value,
              type: value.type,
            };
          }),
          list_id: properties.listId,
        },
        'Oc0p8_ohJc',
        '6eac00b521ef567e1009970047dece4aed2a2a2ccaf1875c4b5b833182e8915c'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Product List Filtered', {
      category: properties.category,
      category_id: properties.categoryId,
      filters: properties.filters.map(function(value) {
        return {
          value: value.value,
          type: value.type,
        };
      }),
      products: properties.products.map(function(value) {
        return {
          product_id: value.productId,
          category: value.category,
          is_clearance: value.isClearance,
          name: value.name,
          price: value.price,
          quantity: value.quantity,
          sku: value.sku,
          variant: value.variant,
          is_protection_plan_eligible: value.isProtectionPlanEligible,
          has_protection_plan: value.hasProtectionPlan,
          is_decide_later: value.isDecideLater,
          tracking_url: value.trackingUrl,
          tracking_number: value.trackingNumber,
          protection_plan_cost: value.protectionPlanCost,
          delivery_type: value.deliveryType,
          shipping_method: value.shippingMethod,
          shipping_carrier: value.shippingCarrier,
          fabric_name: value.fabricName,
          fabric_color: value.fabricColor,
          currency: value.currency,
          full_price: value.fullPrice,
          is_flash_sale: value.isFlashSale,
          google_product_category: value.googleProductCategory,
        };
      }),
      sorts: properties.sorts.map(function(value) {
        return {
          value: value.value,
          type: value.type,
        };
      }),
      list_id: properties.listId,
    });
  } else {
    // do nothing
  }
}

/**
 * Product List Viewed: Fires when a user views a category page.
 *
 * @param {object} properties - the properties associated with this event
 * @param {int} properties.categoryId - The category id. This is NOT the product type id.
 * @param {string} properties.category - The product type (i.e. 'Chair', 'Sofa', etc.). This is NOT the category in terms of Joybird's use of the term 'category', this is the product type.
 * @param {Array<object>} properties.filters - All filters that are applied on category pages (i.e. [{type: 'material', value: 'fabric'}, {type: 'seating', value: '3+ seater'}]
 * @param {Array<object>} properties.products - A list of products.
 * @param {string} properties.listId - The category name or PLP page name (i.e. 'Bedroom Furniture', 'Chairs', 'Warm & Inviting', etc.)
 * Docs: https://rudderstack.com/docs/destinations/analytics/google-analytics-ga/#measuring-product-impressions
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/eD2HbVojeG}
 */
export function productListViewed(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertCategoryId(properties.categoryId));
    messages = messages.concat(assertCategory(properties.category));
    messages = messages.concat(assertFilters(properties.filters));
    messages = messages.concat(assertProducts(properties.products));
    messages = messages.concat(assertListId(properties.listId));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Product List Viewed',
        Object.keys(properties),
        ['categoryId', 'category', 'filters', 'products', 'listId']
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'eD2HbVojeG',
        'ef227e13fba9437388b1d415dc388578ab6557556dc05426f1106e821e583257',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Product List Viewed',
      {
        category_id: properties.categoryId,
        category: properties.category,
        filters: properties.filters.map(function(value) {
          return {
            value: value.value,
            type: value.type,
          };
        }),
        products: properties.products.map(function(value) {
          return {
            product_id: value.productId,
            category: value.category,
            is_clearance: value.isClearance,
            name: value.name,
            price: value.price,
            quantity: value.quantity,
            sku: value.sku,
            variant: value.variant,
            is_protection_plan_eligible: value.isProtectionPlanEligible,
            has_protection_plan: value.hasProtectionPlan,
            is_decide_later: value.isDecideLater,
            tracking_url: value.trackingUrl,
            tracking_number: value.trackingNumber,
            protection_plan_cost: value.protectionPlanCost,
            delivery_type: value.deliveryType,
            shipping_method: value.shippingMethod,
            shipping_carrier: value.shippingCarrier,
            fabric_name: value.fabricName,
            fabric_color: value.fabricColor,
            currency: value.currency,
            full_price: value.fullPrice,
            is_flash_sale: value.isFlashSale,
            google_product_category: value.googleProductCategory,
          };
        }),
        list_id: properties.listId,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'eD2HbVojeG',
        'Product List Viewed',
        messages,
        [
          {
            id: '-Be6jz-r5H',
            name: 'delivery_type',
            value: properties.deliveryType,
          },
          {
            id: '-r2A9Y6Dak',
            name: 'protection_plan_cost',
            value: properties.protectionPlanCost,
          },
          { id: '3PXRzRK2KK', name: 'category', value: properties.category },
          {
            id: '4HTRW0TFrB',
            name: 'shipping_method',
            value: properties.shippingMethod,
          },
          { id: 'EghVtONPP', name: 'name', value: properties.name },
          { id: 'F_0zRLZY6n', name: 'full_price', value: properties.fullPrice },
          {
            id: 'Fwb-BjQjH1V',
            name: 'is_decide_later',
            value: properties.isDecideLater,
          },
          { id: 'Ga6x7Tn-b9', name: 'value', value: properties.value },
          {
            id: 'KwMPoO_BRg',
            name: 'tracking_number',
            value: properties.trackingNumber,
          },
          {
            id: 'MoIQmnL5AHl',
            name: 'has_protection_plan',
            value: properties.hasProtectionPlan,
          },
          {
            id: 'NdU9dcPzjy',
            name: 'is_protection_plan_eligible',
            value: properties.isProtectionPlanEligible,
          },
          {
            id: 'XJ78zva-wm',
            name: 'category_id',
            value: properties.categoryId,
          },
          {
            id: 'YsXH4GchTs',
            name: 'shipping_carrier',
            value: properties.shippingCarrier,
          },
          { id: 'aQjbzLPQy', name: 'list_id', value: properties.listId },
          { id: 'ay-Gx5bwiX', name: 'type', value: properties.type },
          {
            id: 'cZN2CHE3RG',
            name: 'fabric_color',
            value: properties.fabricColor,
          },
          { id: 'j-kP3_J7Rb', name: 'price', value: properties.price },
          { id: 'lq0PSuvEbT', name: 'filters', value: properties.filters },
          { id: 'mEnst5CFw', name: 'currency', value: properties.currency },
          { id: 'nHu4WfjB0w', name: 'product_id', value: properties.productId },
          {
            id: 'ocjd8V8Of8',
            name: 'is_flash_sale',
            value: properties.isFlashSale,
          },
          {
            id: 'r0tvvT0Yd7',
            name: 'tracking_url',
            value: properties.trackingUrl,
          },
          { id: 'r7TPl6ZqL8', name: 'quantity', value: properties.quantity },
          { id: 'rGITDesDtb', name: 'products', value: properties.products },
          { id: 'uI2-rwjYtt', name: 'sku', value: properties.sku },
          {
            id: 'vaWiuR41RoGc8FaMrF5pT',
            name: 'google_product_category',
            value: properties.googleProductCategory,
          },
          {
            id: 'z-KPDmLIa_',
            name: 'fabric_name',
            value: properties.fabricName,
          },
          {
            id: 'zPeher-BjQ',
            name: 'is_clearance',
            value: properties.isClearance,
          },
          { id: 'zsMuCAiZ4D', name: 'variant', value: properties.variant },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Product List Viewed': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Product List Viewed',
        {
          category_id: properties.categoryId,
          category: properties.category,
          filters: properties.filters.map(function(value) {
            return {
              value: value.value,
              type: value.type,
            };
          }),
          products: properties.products.map(function(value) {
            return {
              product_id: value.productId,
              category: value.category,
              is_clearance: value.isClearance,
              name: value.name,
              price: value.price,
              quantity: value.quantity,
              sku: value.sku,
              variant: value.variant,
              is_protection_plan_eligible: value.isProtectionPlanEligible,
              has_protection_plan: value.hasProtectionPlan,
              is_decide_later: value.isDecideLater,
              tracking_url: value.trackingUrl,
              tracking_number: value.trackingNumber,
              protection_plan_cost: value.protectionPlanCost,
              delivery_type: value.deliveryType,
              shipping_method: value.shippingMethod,
              shipping_carrier: value.shippingCarrier,
              fabric_name: value.fabricName,
              fabric_color: value.fabricColor,
              currency: value.currency,
              full_price: value.fullPrice,
              is_flash_sale: value.isFlashSale,
              google_product_category: value.googleProductCategory,
            };
          }),
          list_id: properties.listId,
        },
        'eD2HbVojeG',
        'ef227e13fba9437388b1d415dc388578ab6557556dc05426f1106e821e583257'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Product List Viewed', {
      category_id: properties.categoryId,
      category: properties.category,
      filters: properties.filters.map(function(value) {
        return {
          value: value.value,
          type: value.type,
        };
      }),
      products: properties.products.map(function(value) {
        return {
          product_id: value.productId,
          category: value.category,
          is_clearance: value.isClearance,
          name: value.name,
          price: value.price,
          quantity: value.quantity,
          sku: value.sku,
          variant: value.variant,
          is_protection_plan_eligible: value.isProtectionPlanEligible,
          has_protection_plan: value.hasProtectionPlan,
          is_decide_later: value.isDecideLater,
          tracking_url: value.trackingUrl,
          tracking_number: value.trackingNumber,
          protection_plan_cost: value.protectionPlanCost,
          delivery_type: value.deliveryType,
          shipping_method: value.shippingMethod,
          shipping_carrier: value.shippingCarrier,
          fabric_name: value.fabricName,
          fabric_color: value.fabricColor,
          currency: value.currency,
          full_price: value.fullPrice,
          is_flash_sale: value.isFlashSale,
          google_product_category: value.googleProductCategory,
        };
      }),
      list_id: properties.listId,
    });
  } else {
    // do nothing
  }
}

/**
 * Product Viewed: Fired each time a user views a PDP
 *
 * @param {object} properties - the properties associated with this event
 * @param {int} properties.productId - The 3-5 digit product id (i.e. `623` corresponds to Hughes Sofa)
 * @param {string} properties.category - The product type (i.e. 'Chair', 'Sofa', etc.). This is NOT the category in terms of Joybird's use of the term 'category', this is the product type.
 * @param {bool} properties.isClearance - Whether or not the item was on clearance
 * @param {string} properties.name - Full product name (i.e. 'Hughes Grand Sofa')
 * @param {float} properties.price - The price the user pays. If there is a sale, this is the sale price, if there is no sale, this is the full price
 * @param {int} properties.quantity - The quantity of products
 * @param {string} properties.sku - The full sku (i.e. 'JB103853-CF200-WS03')
 * Product Viewed -> Send the full sku of the first image shown (not the fabric that's selected)
 * @param {string} properties.variant - All product options for a product, separated by a comma and a space (i.e. 'Taylor Felt Grey, Mocha, Left, Cone').
 * If a user selected 'Decide Later', the variant should be 'Decide Later'.
 * @param {float} properties.fullPrice - The full price of the product
 * @param {string} properties.productFamily - The family of the product (i.e. 'Hughes', 'Soto', ect.).
 * @param {Array<string>} properties.contentIds - The base product sku(s) (i.e. if the sku is 'JB11069110-CF423-WS03', the value for Content IDs should be ['JB11069110']).
 * @param {bool} properties.isFlashSale - Whether or not the item was on flash sale
 * @param {string} properties.currency - The currency (i.e. 'USD', 'CAD', etc.)
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/IufHbCpVnq}
 */
export function productViewed(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertProductId(properties.productId));
    messages = messages.concat(assertCategory(properties.category));
    messages = messages.concat(assertIsClearance(properties.isClearance));
    messages = messages.concat(assertName(properties.name));
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(assertQuantity(properties.quantity));
    messages = messages.concat(assertSku(properties.sku));
    messages = messages.concat(assertVariant(properties.variant));
    messages = messages.concat(assertFullPrice(properties.fullPrice));
    messages = messages.concat(assertProductFamily(properties.productFamily));
    messages = messages.concat(assertContentIds(properties.contentIds));
    messages = messages.concat(assertIsFlashSale(properties.isFlashSale));
    messages = messages.concat(assertCurrency(properties.currency));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Product Viewed',
        Object.keys(properties),
        [
          'productId',
          'category',
          'isClearance',
          'name',
          'price',
          'quantity',
          'sku',
          'variant',
          'fullPrice',
          'productFamily',
          'contentIds',
          'isFlashSale',
          'currency',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'IufHbCpVnq',
        'b05497548042bcde3e3db3909c6df0b0bbc8bfff113d95721298cbcf5d0ccb09',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Product Viewed',
      {
        product_id: properties.productId,
        category: properties.category,
        is_clearance: properties.isClearance,
        name: properties.name,
        price: properties.price,
        quantity: properties.quantity,
        sku: properties.sku,
        variant: properties.variant,
        full_price: properties.fullPrice,
        product_family: properties.productFamily,
        content_ids: properties.contentIds,
        is_flash_sale: properties.isFlashSale,
        currency: properties.currency,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'IufHbCpVnq',
        'Product Viewed',
        messages,
        [
          { id: '3PXRzRK2KK', name: 'category', value: properties.category },
          { id: 'EghVtONPP', name: 'name', value: properties.name },
          { id: 'F_0zRLZY6n', name: 'full_price', value: properties.fullPrice },
          {
            id: 'L98Svx9Tq_',
            name: 'content_ids',
            value: properties.contentIds,
          },
          { id: 'j-kP3_J7Rb', name: 'price', value: properties.price },
          { id: 'mEnst5CFw', name: 'currency', value: properties.currency },
          { id: 'nHu4WfjB0w', name: 'product_id', value: properties.productId },
          {
            id: 'ocjd8V8Of8',
            name: 'is_flash_sale',
            value: properties.isFlashSale,
          },
          { id: 'r7TPl6ZqL8', name: 'quantity', value: properties.quantity },
          {
            id: 'rYLq0zrdEe',
            name: 'product_family',
            value: properties.productFamily,
          },
          { id: 'uI2-rwjYtt', name: 'sku', value: properties.sku },
          {
            id: 'zPeher-BjQ',
            name: 'is_clearance',
            value: properties.isClearance,
          },
          { id: 'zsMuCAiZ4D', name: 'variant', value: properties.variant },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Product Viewed': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Product Viewed',
        {
          product_id: properties.productId,
          category: properties.category,
          is_clearance: properties.isClearance,
          name: properties.name,
          price: properties.price,
          quantity: properties.quantity,
          sku: properties.sku,
          variant: properties.variant,
          full_price: properties.fullPrice,
          product_family: properties.productFamily,
          content_ids: properties.contentIds,
          is_flash_sale: properties.isFlashSale,
          currency: properties.currency,
        },
        'IufHbCpVnq',
        'b05497548042bcde3e3db3909c6df0b0bbc8bfff113d95721298cbcf5d0ccb09'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Product Viewed', {
      product_id: properties.productId,
      category: properties.category,
      is_clearance: properties.isClearance,
      name: properties.name,
      price: properties.price,
      quantity: properties.quantity,
      sku: properties.sku,
      variant: properties.variant,
      full_price: properties.fullPrice,
      product_family: properties.productFamily,
      content_ids: properties.contentIds,
      is_flash_sale: properties.isFlashSale,
      currency: properties.currency,
    });
  } else {
    // do nothing
  }
}

/**
 * Targeted Overlay: This is fired automatically from Justuno. There is no dev work required for this event
 *
 * @param {object} properties - the properties associated with this event
 * @param {int} properties.nonInteraction - This property should always be set to 1. Any event with the `non_interaction` property equal to 1 will not decrease the bounce rate
 * @param {string} properties.title - The title of the form or modal
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/dDEIwFFuA6}
 */
export function targetedOverlay(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertNonInteraction(properties.nonInteraction));
    messages = messages.concat(assertTitle(properties.title));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Targeted Overlay',
        Object.keys(properties),
        ['nonInteraction', 'title']
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'dDEIwFFuA6',
        '04e12d4642df35a6427945ad2ac044aa81dffa3eb34e94b91f9f4ed2a6ef0324',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Targeted Overlay',
      {
        non_interaction: properties.nonInteraction,
        title: properties.title,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'dDEIwFFuA6',
        'Targeted Overlay',
        messages,
        [
          {
            id: '-3Hv24vVaC',
            name: 'non_interaction',
            value: properties.nonInteraction,
          },
          { id: 'ila-C3CyQj', name: 'title', value: properties.title },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Targeted Overlay': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Targeted Overlay',
        {
          non_interaction: properties.nonInteraction,
          title: properties.title,
        },
        'dDEIwFFuA6',
        '04e12d4642df35a6427945ad2ac044aa81dffa3eb34e94b91f9f4ed2a6ef0324'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Targeted Overlay', {
      non_interaction: properties.nonInteraction,
      title: properties.title,
    });
  } else {
    // do nothing
  }
}

/**
 * Experiment Started: Fired when an experiment is started.
 *
 * @param {object} properties - the properties associated with this event
 * @param {int} properties.experimentGroup - 1 if user is viewing a test, 0 if user is viewing control
 * @param {string} properties.experimentId - The experiment id (i.e. 'SE4iurbR66xpro0UFB8k')
 * @param {string} properties.experimentName - Human readable experiment name (i.e. 'Desktop Navbar 2.0', 'PDPv2', 'Infinite scroll vs load more', etc.)
 * @param {string} properties.experimentTrackingRoute - The route that the event was fired from, e.g. https://joybird.com/sofas-and-sectionals
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/NktlSrznkZ}
 */
export function experimentStarted(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(
      assertExperimentGroup(properties.experimentGroup)
    );
    messages = messages.concat(assertExperimentId(properties.experimentId));
    messages = messages.concat(assertExperimentName(properties.experimentName));
    messages = messages.concat(
      assertExperimentTrackingRoute(properties.experimentTrackingRoute)
    );
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Experiment Started',
        Object.keys(properties),
        [
          'experimentGroup',
          'experimentId',
          'experimentName',
          'experimentTrackingRoute',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'NktlSrznkZ',
        '2e0ad77bcac8e47edf8cfcebff7e3375888e01fcf8f94b1649cf6f75b221e067',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Experiment Started',
      {
        experiment_group: properties.experimentGroup,
        experiment_id: properties.experimentId,
        experiment_name: properties.experimentName,
        experiment_tracking_route: properties.experimentTrackingRoute,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'NktlSrznkZ',
        'Experiment Started',
        messages,
        [
          {
            id: 'LYznC_8HTG',
            name: 'experiment_tracking_route',
            value: properties.experimentTrackingRoute,
          },
          {
            id: 'UC9O3p1ESQ',
            name: 'experiment_name',
            value: properties.experimentName,
          },
          {
            id: 'lfH3EWVPWS',
            name: 'experiment_id',
            value: properties.experimentId,
          },
          {
            id: 'r8JNfMSYYf',
            name: 'experiment_group',
            value: properties.experimentGroup,
          },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Experiment Started': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Experiment Started',
        {
          experiment_group: properties.experimentGroup,
          experiment_id: properties.experimentId,
          experiment_name: properties.experimentName,
          experiment_tracking_route: properties.experimentTrackingRoute,
        },
        'NktlSrznkZ',
        '2e0ad77bcac8e47edf8cfcebff7e3375888e01fcf8f94b1649cf6f75b221e067'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Experiment Started', {
      experiment_group: properties.experimentGroup,
      experiment_id: properties.experimentId,
      experiment_name: properties.experimentName,
      experiment_tracking_route: properties.experimentTrackingRoute,
    });
  } else {
    // do nothing
  }
}

/**
 * Cart Viewed: Fired when a cart is displayed on the screen, whether on purpose or from adding to cart. This event also fires on joybird.com/cart
 *
 * @param {object} properties - the properties associated with this event
 * @param {Array<object>} properties.products - A list of products.
 * @param {string} properties.cartId - The id of the cart (i.e. 194823)
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/WMeVqQxdXM}
 */
export function cartViewed(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertProducts(properties.products));
    messages = messages.concat(assertCartId(properties.cartId));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Cart Viewed',
        Object.keys(properties),
        ['products', 'cartId']
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'WMeVqQxdXM',
        'f39abaa86d850c51419c908884ec410c34091e3854d9c9b14266f01aa3420ec7',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Cart Viewed',
      {
        products: properties.products.map(function(value) {
          return {
            product_id: value.productId,
            category: value.category,
            is_clearance: value.isClearance,
            name: value.name,
            price: value.price,
            quantity: value.quantity,
            sku: value.sku,
            variant: value.variant,
            is_protection_plan_eligible: value.isProtectionPlanEligible,
            has_protection_plan: value.hasProtectionPlan,
            is_decide_later: value.isDecideLater,
            tracking_url: value.trackingUrl,
            tracking_number: value.trackingNumber,
            protection_plan_cost: value.protectionPlanCost,
            delivery_type: value.deliveryType,
            shipping_method: value.shippingMethod,
            shipping_carrier: value.shippingCarrier,
            fabric_name: value.fabricName,
            fabric_color: value.fabricColor,
            currency: value.currency,
            full_price: value.fullPrice,
            is_flash_sale: value.isFlashSale,
            google_product_category: value.googleProductCategory,
          };
        }),
        cart_id: properties.cartId,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'WMeVqQxdXM',
        'Cart Viewed',
        messages,
        [
          {
            id: '-Be6jz-r5H',
            name: 'delivery_type',
            value: properties.deliveryType,
          },
          {
            id: '-r2A9Y6Dak',
            name: 'protection_plan_cost',
            value: properties.protectionPlanCost,
          },
          { id: '3PXRzRK2KK', name: 'category', value: properties.category },
          {
            id: '4HTRW0TFrB',
            name: 'shipping_method',
            value: properties.shippingMethod,
          },
          { id: 'EghVtONPP', name: 'name', value: properties.name },
          { id: 'F_0zRLZY6n', name: 'full_price', value: properties.fullPrice },
          {
            id: 'Fwb-BjQjH1V',
            name: 'is_decide_later',
            value: properties.isDecideLater,
          },
          { id: 'KALt_3pVFV', name: 'cart_id', value: properties.cartId },
          {
            id: 'KwMPoO_BRg',
            name: 'tracking_number',
            value: properties.trackingNumber,
          },
          {
            id: 'MoIQmnL5AHl',
            name: 'has_protection_plan',
            value: properties.hasProtectionPlan,
          },
          {
            id: 'NdU9dcPzjy',
            name: 'is_protection_plan_eligible',
            value: properties.isProtectionPlanEligible,
          },
          {
            id: 'YsXH4GchTs',
            name: 'shipping_carrier',
            value: properties.shippingCarrier,
          },
          {
            id: 'cZN2CHE3RG',
            name: 'fabric_color',
            value: properties.fabricColor,
          },
          { id: 'j-kP3_J7Rb', name: 'price', value: properties.price },
          { id: 'mEnst5CFw', name: 'currency', value: properties.currency },
          { id: 'nHu4WfjB0w', name: 'product_id', value: properties.productId },
          {
            id: 'ocjd8V8Of8',
            name: 'is_flash_sale',
            value: properties.isFlashSale,
          },
          {
            id: 'r0tvvT0Yd7',
            name: 'tracking_url',
            value: properties.trackingUrl,
          },
          { id: 'r7TPl6ZqL8', name: 'quantity', value: properties.quantity },
          { id: 'rGITDesDtb', name: 'products', value: properties.products },
          { id: 'uI2-rwjYtt', name: 'sku', value: properties.sku },
          {
            id: 'vaWiuR41RoGc8FaMrF5pT',
            name: 'google_product_category',
            value: properties.googleProductCategory,
          },
          {
            id: 'z-KPDmLIa_',
            name: 'fabric_name',
            value: properties.fabricName,
          },
          {
            id: 'zPeher-BjQ',
            name: 'is_clearance',
            value: properties.isClearance,
          },
          { id: 'zsMuCAiZ4D', name: 'variant', value: properties.variant },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Cart Viewed': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Cart Viewed',
        {
          products: properties.products.map(function(value) {
            return {
              product_id: value.productId,
              category: value.category,
              is_clearance: value.isClearance,
              name: value.name,
              price: value.price,
              quantity: value.quantity,
              sku: value.sku,
              variant: value.variant,
              is_protection_plan_eligible: value.isProtectionPlanEligible,
              has_protection_plan: value.hasProtectionPlan,
              is_decide_later: value.isDecideLater,
              tracking_url: value.trackingUrl,
              tracking_number: value.trackingNumber,
              protection_plan_cost: value.protectionPlanCost,
              delivery_type: value.deliveryType,
              shipping_method: value.shippingMethod,
              shipping_carrier: value.shippingCarrier,
              fabric_name: value.fabricName,
              fabric_color: value.fabricColor,
              currency: value.currency,
              full_price: value.fullPrice,
              is_flash_sale: value.isFlashSale,
              google_product_category: value.googleProductCategory,
            };
          }),
          cart_id: properties.cartId,
        },
        'WMeVqQxdXM',
        'f39abaa86d850c51419c908884ec410c34091e3854d9c9b14266f01aa3420ec7'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Cart Viewed', {
      products: properties.products.map(function(value) {
        return {
          product_id: value.productId,
          category: value.category,
          is_clearance: value.isClearance,
          name: value.name,
          price: value.price,
          quantity: value.quantity,
          sku: value.sku,
          variant: value.variant,
          is_protection_plan_eligible: value.isProtectionPlanEligible,
          has_protection_plan: value.hasProtectionPlan,
          is_decide_later: value.isDecideLater,
          tracking_url: value.trackingUrl,
          tracking_number: value.trackingNumber,
          protection_plan_cost: value.protectionPlanCost,
          delivery_type: value.deliveryType,
          shipping_method: value.shippingMethod,
          shipping_carrier: value.shippingCarrier,
          fabric_name: value.fabricName,
          fabric_color: value.fabricColor,
          currency: value.currency,
          full_price: value.fullPrice,
          is_flash_sale: value.isFlashSale,
          google_product_category: value.googleProductCategory,
        };
      }),
      cart_id: properties.cartId,
    });
  } else {
    // do nothing
  }
}

/**
 * Coupon Applied: Fired when a coupon is successfully applied & accepted. Coupons can be applied in cart or during checkout.
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.couponName - The coupon code used (i.e. 'SUMMER_SALE2020')
 * @param {float} properties.discount - Total discount amount (i.e. 153.82)
 * @param {string} properties.location - The location where the event occurred. Possibilities are listed below:
 * * For the 'Email Acquired' event, options are: 'Guest Checkout', 'Swatch Request', 'Justuno', or 'Account Creation'
 * * For the 'Product Clicked' event, options are: 'Home Page', 'Category Page',  'PDP', or 'Cart'
 * * For the 'Product Added to Wishlist' event, options are: 'Home Page', 'Category Page', or 'PDP'
 * * For the 'Protection Plan Added' event, options are: 'PDP', 'Cart', 'Checkout'
 * * For the 'Coupon Applied/Denied/Entered/Removed' events, options are: 'PDP' & 'Checkout'
 * * For the 'Fabric Favorited/Unfavorited' events, options are: 'PDP', 'Shop By Material', 'Pet Friendly Page', & 'Safeguard Fabrics Page'
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/aTPcBgZms2}
 */
export function couponApplied(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertCouponName(properties.couponName));
    messages = messages.concat(assertDiscount(properties.discount));
    messages = messages.concat(assertLocation(properties.location));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Coupon Applied',
        Object.keys(properties),
        ['couponName', 'discount', 'location']
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'aTPcBgZms2',
        'b97bb9c4a36b4d0a6af0ec3b4e14b08d1301a7fe8863195588bbf4bb1a05a2de',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Coupon Applied',
      {
        coupon_name: properties.couponName,
        discount: properties.discount,
        location: properties.location,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'aTPcBgZms2',
        'Coupon Applied',
        messages,
        [
          { id: 'B71GIESiV8', name: 'location', value: properties.location },
          {
            id: 'QpXvpQ98wn',
            name: 'coupon_name',
            value: properties.couponName,
          },
          { id: 'brVZTOFd99', name: 'discount', value: properties.discount },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Coupon Applied': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Coupon Applied',
        {
          coupon_name: properties.couponName,
          discount: properties.discount,
          location: properties.location,
        },
        'aTPcBgZms2',
        'b97bb9c4a36b4d0a6af0ec3b4e14b08d1301a7fe8863195588bbf4bb1a05a2de'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Coupon Applied', {
      coupon_name: properties.couponName,
      discount: properties.discount,
      location: properties.location,
    });
  } else {
    // do nothing
  }
}

/**
 * Coupon Denied: Fired when a coupon was declined. Coupons can be declined in cart or during checkout.
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.couponName - The coupon code used (i.e. 'SUMMER_SALE2020')
 * @param {string} properties.reason - Error message for why the coupon was denied
 * @param {string} properties.location - The location where the event occurred. Possibilities are listed below:
 * * For the 'Email Acquired' event, options are: 'Guest Checkout', 'Swatch Request', 'Justuno', or 'Account Creation'
 * * For the 'Product Clicked' event, options are: 'Home Page', 'Category Page',  'PDP', or 'Cart'
 * * For the 'Product Added to Wishlist' event, options are: 'Home Page', 'Category Page', or 'PDP'
 * * For the 'Protection Plan Added' event, options are: 'PDP', 'Cart', 'Checkout'
 * * For the 'Coupon Applied/Denied/Entered/Removed' events, options are: 'PDP' & 'Checkout'
 * * For the 'Fabric Favorited/Unfavorited' events, options are: 'PDP', 'Shop By Material', 'Pet Friendly Page', & 'Safeguard Fabrics Page'
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/FH3f5BGsKS}
 */
export function couponDenied(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertCouponName(properties.couponName));
    messages = messages.concat(assertReason(properties.reason));
    messages = messages.concat(assertLocation(properties.location));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Coupon Denied',
        Object.keys(properties),
        ['couponName', 'reason', 'location']
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'FH3f5BGsKS',
        'd12132555aa86180d6672a2e0f12d5ab5260459368fe8b33a766a582bbe16814',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Coupon Denied',
      {
        coupon_name: properties.couponName,
        reason: properties.reason,
        location: properties.location,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'FH3f5BGsKS',
        'Coupon Denied',
        messages,
        [
          { id: 'B71GIESiV8', name: 'location', value: properties.location },
          {
            id: 'QpXvpQ98wn',
            name: 'coupon_name',
            value: properties.couponName,
          },
          { id: 'qcqKEsz6p4', name: 'reason', value: properties.reason },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Coupon Denied': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Coupon Denied',
        {
          coupon_name: properties.couponName,
          reason: properties.reason,
          location: properties.location,
        },
        'FH3f5BGsKS',
        'd12132555aa86180d6672a2e0f12d5ab5260459368fe8b33a766a582bbe16814'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Coupon Denied', {
      coupon_name: properties.couponName,
      reason: properties.reason,
      location: properties.location,
    });
  } else {
    // do nothing
  }
}

/**
 * Coupon Entered: Fired when a user enters a coupon code and clicks "Apply". This should fire whether or not a coupon code has been successfully applied. Coupons can be entered in cart or during checkout.
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.couponName - The coupon code used (i.e. 'SUMMER_SALE2020')
 * @param {string} properties.location - The location where the event occurred. Possibilities are listed below:
 * * For the 'Email Acquired' event, options are: 'Guest Checkout', 'Swatch Request', 'Justuno', or 'Account Creation'
 * * For the 'Product Clicked' event, options are: 'Home Page', 'Category Page',  'PDP', or 'Cart'
 * * For the 'Product Added to Wishlist' event, options are: 'Home Page', 'Category Page', or 'PDP'
 * * For the 'Protection Plan Added' event, options are: 'PDP', 'Cart', 'Checkout'
 * * For the 'Coupon Applied/Denied/Entered/Removed' events, options are: 'PDP' & 'Checkout'
 * * For the 'Fabric Favorited/Unfavorited' events, options are: 'PDP', 'Shop By Material', 'Pet Friendly Page', & 'Safeguard Fabrics Page'
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/YNQGSX3kG2}
 */
export function couponEntered(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertCouponName(properties.couponName));
    messages = messages.concat(assertLocation(properties.location));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Coupon Entered',
        Object.keys(properties),
        ['couponName', 'location']
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'YNQGSX3kG2',
        'dd1769667f6cbffcbaf4414ac161454495669e6f5cc9f84302ca4a7fcda55d11',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Coupon Entered',
      {
        coupon_name: properties.couponName,
        location: properties.location,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'YNQGSX3kG2',
        'Coupon Entered',
        messages,
        [
          { id: 'B71GIESiV8', name: 'location', value: properties.location },
          {
            id: 'QpXvpQ98wn',
            name: 'coupon_name',
            value: properties.couponName,
          },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Coupon Entered': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Coupon Entered',
        {
          coupon_name: properties.couponName,
          location: properties.location,
        },
        'YNQGSX3kG2',
        'dd1769667f6cbffcbaf4414ac161454495669e6f5cc9f84302ca4a7fcda55d11'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Coupon Entered', {
      coupon_name: properties.couponName,
      location: properties.location,
    });
  } else {
    // do nothing
  }
}

/**
 * Coupon Removed: Fired when a coupon is removed from the text input. Coupons can be removed in cart or during checkout.
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.couponName - The coupon code used (i.e. 'SUMMER_SALE2020')
 * @param {string} properties.location - The location where the event occurred. Possibilities are listed below:
 * * For the 'Email Acquired' event, options are: 'Guest Checkout', 'Swatch Request', 'Justuno', or 'Account Creation'
 * * For the 'Product Clicked' event, options are: 'Home Page', 'Category Page',  'PDP', or 'Cart'
 * * For the 'Product Added to Wishlist' event, options are: 'Home Page', 'Category Page', or 'PDP'
 * * For the 'Protection Plan Added' event, options are: 'PDP', 'Cart', 'Checkout'
 * * For the 'Coupon Applied/Denied/Entered/Removed' events, options are: 'PDP' & 'Checkout'
 * * For the 'Fabric Favorited/Unfavorited' events, options are: 'PDP', 'Shop By Material', 'Pet Friendly Page', & 'Safeguard Fabrics Page'
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/evguKC8xtI}
 */
export function couponRemoved(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertCouponName(properties.couponName));
    messages = messages.concat(assertLocation(properties.location));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Coupon Removed',
        Object.keys(properties),
        ['couponName', 'location']
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'evguKC8xtI',
        '71ffb7c3dcb48c1221d479256ad1ae71057db0b70854ee71b7d941eb51c9f77b',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Coupon Removed',
      {
        coupon_name: properties.couponName,
        location: properties.location,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'evguKC8xtI',
        'Coupon Removed',
        messages,
        [
          { id: 'B71GIESiV8', name: 'location', value: properties.location },
          {
            id: 'QpXvpQ98wn',
            name: 'coupon_name',
            value: properties.couponName,
          },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Coupon Removed': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Coupon Removed',
        {
          coupon_name: properties.couponName,
          location: properties.location,
        },
        'evguKC8xtI',
        '71ffb7c3dcb48c1221d479256ad1ae71057db0b70854ee71b7d941eb51c9f77b'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Coupon Removed', {
      coupon_name: properties.couponName,
      location: properties.location,
    });
  } else {
    // do nothing
  }
}

/**
 * Account Created: Fired when a user creates a new account
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.userId_ - The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param {string} properties.location - The location where the event occurred. Possibilities are listed below:
 * * For the 'Email Acquired' event, options are: 'Guest Checkout', 'Swatch Request', 'Justuno', or 'Account Creation'
 * * For the 'Product Clicked' event, options are: 'Home Page', 'Category Page',  'PDP', or 'Cart'
 * * For the 'Product Added to Wishlist' event, options are: 'Home Page', 'Category Page', or 'PDP'
 * * For the 'Protection Plan Added' event, options are: 'PDP', 'Cart', 'Checkout'
 * * For the 'Coupon Applied/Denied/Entered/Removed' events, options are: 'PDP' & 'Checkout'
 * * For the 'Fabric Favorited/Unfavorited' events, options are: 'PDP', 'Shop By Material', 'Pet Friendly Page', & 'Safeguard Fabrics Page'
 * @param {string} properties.backendEmail - Email address from the server
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/Q2uAReN55i}
 */
export function accountCreated(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertUserId_(properties.userId_));
    messages = messages.concat(assertLocation(properties.location));
    messages = messages.concat(assertBackendEmail(properties.backendEmail));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Account Created',
        Object.keys(properties),
        ['userId_', 'location', 'backendEmail']
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'Q2uAReN55i',
        'eac258f2c08fba41345fca207d60a91a6611732d3c53b4eb00d6f929a67e7da3',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Account Created',
      {
        location: properties.location,
      },
      {
        backend_email: properties.backendEmail,
      },
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'Q2uAReN55i',
        'Account Created',
        messages,
        [{ id: 'B71GIESiV8', name: 'location', value: properties.location }],
        [
          {
            id: 'zjUFB7hRiT',
            name: 'backend_email',
            value: properties.backendEmail,
          },
        ],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Account Created': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Account Created',
        {
          location: properties.location,
        },
        'Q2uAReN55i',
        'eac258f2c08fba41345fca207d60a91a6611732d3c53b4eb00d6f929a67e7da3'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.setUserProperties(properties.userId_, {
      email: properties.backendEmail,
    });
    RudderstackJavascript.logEvent('Account Created', {
      location: properties.location,
    });
  } else {
    // do nothing
  }
}

/**
 * Engagement Incentivized Form: This is an automated event sent from Justuno. There is no dev work required
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.userId_ - The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param {string} properties.email - The email address (i.e. 'christoph@joybird.com')
 * @param {int} properties.nonInteraction - This property should always be set to 1. Any event with the `non_interaction` property equal to 1 will not decrease the bounce rate
 * @param {string} properties.title - The title of the form or modal
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/ORSqC_xmQW}
 */
export function engagementIncentivizedForm(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertUserId_(properties.userId_));
    messages = messages.concat(assertEmail(properties.email));
    messages = messages.concat(assertNonInteraction(properties.nonInteraction));
    messages = messages.concat(assertTitle(properties.title));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Engagement Incentivized Form',
        Object.keys(properties),
        ['userId_', 'email', 'nonInteraction', 'title']
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'ORSqC_xmQW',
        '92a4e5c871efd832f2eef2bd04f3f12a34c67d785121441f3c692f37bfacb04c',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Engagement Incentivized Form',
      {
        email: properties.email,
        non_interaction: properties.nonInteraction,
        title: properties.title,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'ORSqC_xmQW',
        'Engagement Incentivized Form',
        messages,
        [
          {
            id: '-3Hv24vVaC',
            name: 'non_interaction',
            value: properties.nonInteraction,
          },
          { id: '4rYN-Q_mp', name: 'email', value: properties.email },
          { id: 'ila-C3CyQj', name: 'title', value: properties.title },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Engagement Incentivized Form': " +
            messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Engagement Incentivized Form',
        {
          email: properties.email,
          non_interaction: properties.nonInteraction,
          title: properties.title,
        },
        'ORSqC_xmQW',
        '92a4e5c871efd832f2eef2bd04f3f12a34c67d785121441f3c692f37bfacb04c'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.identify(properties.userId_);
    RudderstackJavascript.logEvent('Engagement Incentivized Form', {
      email: properties.email,
      non_interaction: properties.nonInteraction,
      title: properties.title,
    });
  } else {
    // do nothing
  }
}

/**
 * Engagement Unlocked or CTA Click: This is an automated event sent from Justuno. There is no dev work required
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.userId_ - The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param {int} properties.nonInteraction - This property should always be set to 1. Any event with the `non_interaction` property equal to 1 will not decrease the bounce rate
 * @param {string} properties.title - The title of the form or modal
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/NeC9gBbkEc}
 */
export function engagementUnlockedOrCtaClick(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertUserId_(properties.userId_));
    messages = messages.concat(assertNonInteraction(properties.nonInteraction));
    messages = messages.concat(assertTitle(properties.title));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Engagement Unlocked or CTA Click',
        Object.keys(properties),
        ['userId_', 'nonInteraction', 'title']
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'NeC9gBbkEc',
        '0b63ed36b0eaf5414c60e1c1d4c9737346bacf4ea7dbea903da49dd0194102c3',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Engagement Unlocked or CTA Click',
      {
        non_interaction: properties.nonInteraction,
        title: properties.title,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'NeC9gBbkEc',
        'Engagement Unlocked or CTA Click',
        messages,
        [
          {
            id: '-3Hv24vVaC',
            name: 'non_interaction',
            value: properties.nonInteraction,
          },
          { id: 'ila-C3CyQj', name: 'title', value: properties.title },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Engagement Unlocked or CTA Click': " +
            messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Engagement Unlocked or CTA Click',
        {
          non_interaction: properties.nonInteraction,
          title: properties.title,
        },
        'NeC9gBbkEc',
        '0b63ed36b0eaf5414c60e1c1d4c9737346bacf4ea7dbea903da49dd0194102c3'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.identify(properties.userId_);
    RudderstackJavascript.logEvent('Engagement Unlocked or CTA Click', {
      non_interaction: properties.nonInteraction,
      title: properties.title,
    });
  } else {
    // do nothing
  }
}

/**
 * Logged In: Fired when a user logs in to joybird.com
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.userId_ - The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param {string} properties.firstName - User's first name
 * @param {string} properties.lastName - User's last name
 * @param {string} properties.hashedEmail - The lowercase md5 hash of the user's email address (i.e.
 * '2f7af4cc31af7bafb7beeb53208d6ff0')
 * @param {string} properties.email - The email address (i.e. 'christoph@joybird.com')
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/9Ub5vNjAgC}
 */
export function loggedIn(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertUserId_(properties.userId_));
    messages = messages.concat(assertFirstName(properties.firstName));
    messages = messages.concat(assertLastName(properties.lastName));
    messages = messages.concat(assertHashedEmail(properties.hashedEmail));
    messages = messages.concat(assertEmail(properties.email));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Logged In',
        Object.keys(properties),
        ['userId_', 'firstName', 'lastName', 'hashedEmail', 'email']
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '9Ub5vNjAgC',
        'c89e6422d6ebb806a245b5c0b5b1451e793d4384dc2de97c74289f87b1395fa3',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Logged In',
      {
        first_name: properties.firstName,
        last_name: properties.lastName,
        hashed_email: properties.hashedEmail,
        email: properties.email,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '9Ub5vNjAgC',
        'Logged In',
        messages,
        [
          { id: '4rYN-Q_mp', name: 'email', value: properties.email },
          { id: '6xBEsvKJnp', name: 'last_name', value: properties.lastName },
          { id: 'RD7HJjbic2', name: 'first_name', value: properties.firstName },
          {
            id: 'uO4O8vJeKW',
            name: 'hashed_email',
            value: properties.hashedEmail,
          },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Logged In': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Logged In',
        {
          first_name: properties.firstName,
          last_name: properties.lastName,
          hashed_email: properties.hashedEmail,
          email: properties.email,
        },
        '9Ub5vNjAgC',
        'c89e6422d6ebb806a245b5c0b5b1451e793d4384dc2de97c74289f87b1395fa3'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.identify(properties.userId_);
    RudderstackJavascript.logEvent('Logged In', {
      first_name: properties.firstName,
      last_name: properties.lastName,
      hashed_email: properties.hashedEmail,
      email: properties.email,
    });
  } else {
    // do nothing
  }
}

/**
 * Product Removed From Wishlist: Fired when a product has been removed from the wishlist
 *
 * @param {object} properties - the properties associated with this event
 * @param {int} properties.productId - The 3-5 digit product id (i.e. `623` corresponds to Hughes Sofa)
 * @param {string} properties.category - The product type (i.e. 'Chair', 'Sofa', etc.). This is NOT the category in terms of Joybird's use of the term 'category', this is the product type.
 * @param {bool} properties.isClearance - Whether or not the item was on clearance
 * @param {string} properties.name - Full product name (i.e. 'Hughes Grand Sofa')
 * @param {float} properties.price - The price the user pays. If there is a sale, this is the sale price, if there is no sale, this is the full price
 * @param {int} properties.quantity - The quantity of products
 * @param {string} properties.sku - The full sku (i.e. 'JB103853-CF200-WS03')
 * Product Viewed -> Send the full sku of the first image shown (not the fabric that's selected)
 * @param {string} properties.variant - All product options for a product, separated by a comma and a space (i.e. 'Taylor Felt Grey, Mocha, Left, Cone').
 * If a user selected 'Decide Later', the variant should be 'Decide Later'.
 * @param {float} properties.fullPrice - The full price of the product
 * @param {string} properties.productFamily - The family of the product (i.e. 'Hughes', 'Soto', ect.).
 * @param {Array<string>} properties.contentIds - The base product sku(s) (i.e. if the sku is 'JB11069110-CF423-WS03', the value for Content IDs should be ['JB11069110']).
 * @param {bool} properties.isFlashSale - Whether or not the item was on flash sale
 * @param {string} properties.currency - The currency (i.e. 'USD', 'CAD', etc.)
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/EVw49OTCJC}
 */
export function productRemovedFromWishlist(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertProductId(properties.productId));
    messages = messages.concat(assertCategory(properties.category));
    messages = messages.concat(assertIsClearance(properties.isClearance));
    messages = messages.concat(assertName(properties.name));
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(assertQuantity(properties.quantity));
    messages = messages.concat(assertSku(properties.sku));
    messages = messages.concat(assertVariant(properties.variant));
    messages = messages.concat(assertFullPrice(properties.fullPrice));
    messages = messages.concat(assertProductFamily(properties.productFamily));
    messages = messages.concat(assertContentIds(properties.contentIds));
    messages = messages.concat(assertIsFlashSale(properties.isFlashSale));
    messages = messages.concat(assertCurrency(properties.currency));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Product Removed From Wishlist',
        Object.keys(properties),
        [
          'productId',
          'category',
          'isClearance',
          'name',
          'price',
          'quantity',
          'sku',
          'variant',
          'fullPrice',
          'productFamily',
          'contentIds',
          'isFlashSale',
          'currency',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'EVw49OTCJC',
        '34d3cf435c327d8b1e54990610f8fcde7c3e8fe266ecbabc2f1db4793eb63e18',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Product Removed From Wishlist',
      {
        product_id: properties.productId,
        category: properties.category,
        is_clearance: properties.isClearance,
        name: properties.name,
        price: properties.price,
        quantity: properties.quantity,
        sku: properties.sku,
        variant: properties.variant,
        full_price: properties.fullPrice,
        product_family: properties.productFamily,
        content_ids: properties.contentIds,
        is_flash_sale: properties.isFlashSale,
        currency: properties.currency,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'EVw49OTCJC',
        'Product Removed From Wishlist',
        messages,
        [
          { id: '3PXRzRK2KK', name: 'category', value: properties.category },
          { id: 'EghVtONPP', name: 'name', value: properties.name },
          { id: 'F_0zRLZY6n', name: 'full_price', value: properties.fullPrice },
          {
            id: 'L98Svx9Tq_',
            name: 'content_ids',
            value: properties.contentIds,
          },
          { id: 'j-kP3_J7Rb', name: 'price', value: properties.price },
          { id: 'mEnst5CFw', name: 'currency', value: properties.currency },
          { id: 'nHu4WfjB0w', name: 'product_id', value: properties.productId },
          {
            id: 'ocjd8V8Of8',
            name: 'is_flash_sale',
            value: properties.isFlashSale,
          },
          { id: 'r7TPl6ZqL8', name: 'quantity', value: properties.quantity },
          {
            id: 'rYLq0zrdEe',
            name: 'product_family',
            value: properties.productFamily,
          },
          { id: 'uI2-rwjYtt', name: 'sku', value: properties.sku },
          {
            id: 'zPeher-BjQ',
            name: 'is_clearance',
            value: properties.isClearance,
          },
          { id: 'zsMuCAiZ4D', name: 'variant', value: properties.variant },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Product Removed From Wishlist': " +
            messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Product Removed From Wishlist',
        {
          product_id: properties.productId,
          category: properties.category,
          is_clearance: properties.isClearance,
          name: properties.name,
          price: properties.price,
          quantity: properties.quantity,
          sku: properties.sku,
          variant: properties.variant,
          full_price: properties.fullPrice,
          product_family: properties.productFamily,
          content_ids: properties.contentIds,
          is_flash_sale: properties.isFlashSale,
          currency: properties.currency,
        },
        'EVw49OTCJC',
        '34d3cf435c327d8b1e54990610f8fcde7c3e8fe266ecbabc2f1db4793eb63e18'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Product Removed From Wishlist', {
      product_id: properties.productId,
      category: properties.category,
      is_clearance: properties.isClearance,
      name: properties.name,
      price: properties.price,
      quantity: properties.quantity,
      sku: properties.sku,
      variant: properties.variant,
      full_price: properties.fullPrice,
      product_family: properties.productFamily,
      content_ids: properties.contentIds,
      is_flash_sale: properties.isFlashSale,
      currency: properties.currency,
    });
  } else {
    // do nothing
  }
}

/**
 * CTA Clicked: Fired any time a specific CTA was clicked. CTAs are listed under the `cta` property.
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.text - The text in the element
 * @param {string} properties.targetUrl - The url the CTA directs a user to
 * @param {string} properties.cta - The name of the CTA that was clicked (i.e. 'Shop Now', 'Full Screen Gallery', etc.)
 * @param {string} [properties.component] - The component the event occurred in.
 * 'Trade Newsletter Signup' - the trade-only email capture
 * 'Trade Application' - trade application pages
 * 'Product Recommendation Carousel' - the carousel with the heading 'Recommended for you
 * 'Recently Viewed Carousel' - the recently viewed carousel at the bottom of category pages & pdps
 * 'Best Sellers Carousel' - the best sellers carousel at the bottom of category pages
 * 'Collection Carousel' - the collection at the bottom of PDPs with products in the same family (i.e. if you're on the Hughes Sofa chair the Collection Carousel would have Hughes Chair, Hughes Loveseat, etc.)
 * 'Navbar' - the navbar component
 * 'Product to Product Carousel' - the product-to-product recommendation carousel on PDPs
 * 'Bambuser' - Bambuser video player
 * 'Product Card' - the product cards shown on category pages, PDPs, etc.
 * 'Cart' - the cart modal that pops up after clicking on cart icon
 * 'Newsletter Signup' - checkbox in footer/checkout/etc that allows marketing emails to be sent to customer
 * 'Swatch Request' - the swatch request modal
 * 'Share Cart' - the share cart modal
 * 'Account Creation' - the account creation modal
 * 'Product Grid' - the collection of product cards found on category pages and in search dropdown
 * 'Side Panel' - the right-hand panel on PDPs containing the product name, customizer, customer reviews, etc.
 * 'Delivery Update' - the modal that pops up on /tracking to inform users about a change to their delivery date
 * @param {string} [properties.location] - The location where the event occurred. Possibilities are listed below:
 * * For the 'Email Acquired' event, options are: 'Guest Checkout', 'Swatch Request', 'Justuno', or 'Account Creation'
 * * For the 'Product Clicked' event, options are: 'Home Page', 'Category Page',  'PDP', or 'Cart'
 * * For the 'Product Added to Wishlist' event, options are: 'Home Page', 'Category Page', or 'PDP'
 * * For the 'Protection Plan Added' event, options are: 'PDP', 'Cart', 'Checkout'
 * * For the 'Coupon Applied/Denied/Entered/Removed' events, options are: 'PDP' & 'Checkout'
 * * For the 'Fabric Favorited/Unfavorited' events, options are: 'PDP', 'Shop By Material', 'Pet Friendly Page', & 'Safeguard Fabrics Page'
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/f3JGhQNzHz}
 */
export function ctaClicked(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertText(properties.text));
    messages = messages.concat(assertTargetUrl(properties.targetUrl));
    messages = messages.concat(assertCta(properties.cta));
    messages = messages.concat(assertOptionalComponent(properties.component));
    messages = messages.concat(assertOptionalLocation(properties.location));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'CTA Clicked',
        Object.keys(properties),
        ['text', 'targetUrl', 'cta', 'component', 'location']
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'f3JGhQNzHz',
        '8279ad4aeabb991cd2e76d9026c5a9e36191ce362194515abba792f0dcf1620e',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'CTA Clicked',
      {
        text: properties.text,
        target_url: properties.targetUrl,
        cta: properties.cta,
        component: properties.component,
        location: properties.location,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'f3JGhQNzHz',
        'CTA Clicked',
        messages,
        [
          { id: 'B71GIESiV8', name: 'location', value: properties.location },
          { id: 'ZrQHFev1wX', name: 'cta', value: properties.cta },
          { id: 'nNUWXhOcId', name: 'text', value: properties.text },
          { id: 'oO5OZf_XuJ', name: 'target_url', value: properties.targetUrl },
          { id: 'wRrJhFCX_U', name: 'component', value: properties.component },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'CTA Clicked': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'CTA Clicked',
        {
          text: properties.text,
          target_url: properties.targetUrl,
          cta: properties.cta,
          component: properties.component,
          location: properties.location,
        },
        'f3JGhQNzHz',
        '8279ad4aeabb991cd2e76d9026c5a9e36191ce362194515abba792f0dcf1620e'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('CTA Clicked', {
      text: properties.text,
      target_url: properties.targetUrl,
      cta: properties.cta,
      component: properties.component,
      location: properties.location,
    });
  } else {
    // do nothing
  }
}

/**
 * Log Page View: An event for the generic page method implemented in Segment
 *
 * @param {object} properties - the properties associated with this event
 * @param {int} [properties.iterableCampaignId] - The campaign ID from Iterable. Used when sending purchase data back to Iterable for campaign attribution.
 * The data for this property will come from the utm_campaignID query parameter from the page URL.
 * Example:
 * https://joybird.com/fabric-of-the-month/?utm_source=iterable&utm_medium=email&utm_term=jbnewsletter&utm_content=FOTM_learn_more&utm_campaign=PROOF_CAMPAIGN_NAME&utm_leadstatus=hnp&utm_templateID=12790186&utm_campaignID=-12345
 * @param {string} [properties.campaignUtmSource] - The UTM source for the campaign. This is set by the Marketing team.
 * The data for this property will come from the utm_source query parameter from the page URL.
 * Example:
 * https://joybird.com/fabric-of-the-month/?utm_source=iterable&utm_medium=email&utm_term=jbnewsletter&utm_content=FOTM_learn_more&utm_campaign=PROOF_CAMPAIGN_NAME&utm_leadstatus=hnp&utm_templateID=12790186&utm_campaignID=-12345
 * @param {string} [properties.campaignUtmMedium] - The UTM medium for the campaign. This is set by the Marketing team.
 * The data for this property will come from the utm_medium query parameter from the page URL.
 * Example:
 * https://joybird.com/fabric-of-the-month/?utm_source=iterable&utm_medium=email&utm_term=jbnewsletter&utm_content=FOTM_learn_more&utm_campaign=PROOF_CAMPAIGN_NAME&utm_leadstatus=hnp&utm_templateID=12790186&utm_campaignID=-12345
 * @param {string} [properties.campaignUtmTerm] - The UTM term for the campaign. This is set by the Marketing team.
 * The data for this property will come from the utm_term query parameter from the page URL.
 * Example:
 * https://joybird.com/fabric-of-the-month/?utm_source=iterable&utm_medium=email&utm_term=jbnewsletter&utm_content=FOTM_learn_more&utm_campaign=PROOF_CAMPAIGN_NAME&utm_leadstatus=hnp&utm_templateID=12790186&utm_campaignID=-12345
 * @param {string} [properties.campaignUtmContent] - The UTM content for the campaign. This is set by the Marketing team.
 * The data for this property will come from the utm_content query parameter from the page URL.
 * Example:
 * https://joybird.com/fabric-of-the-month/?utm_source=iterable&utm_medium=email&utm_term=jbnewsletter&utm_content=FOTM_learn_more&utm_campaign=PROOF_CAMPAIGN_NAME&utm_leadstatus=hnp&utm_templateID=12790186&utm_campaignID=-12345
 * @param {string} [properties.campaignUtmCampaign] - The UTM campaign for the campaign. This is set by the Marketing team.
 * The data for this property will come from the utm_campaign query parameter from the page URL.
 * Example:
 * https://joybird.com/fabric-of-the-month/?utm_source=iterable&utm_medium=email&utm_term=jbnewsletter&utm_content=FOTM_learn_more&utm_campaign=PROOF_CAMPAIGN_NAME&utm_leadstatus=hnp&utm_templateID=12790186&utm_campaignID=-12345
 * @param {int} [properties.iterableTemplateId] - The template ID from Iterable. Used when sending purchase data back to Iterable for campaign attribution.
 * The data for this property will come from the utm_templateID query parameter from the page URL.
 * Example:
 * https://joybird.com/fabric-of-the-month/?utm_source=iterable&utm_medium=email&utm_term=jbnewsletter&utm_content=FOTM_learn_more&utm_campaign=PROOF_CAMPAIGN_NAME&utm_leadstatus=hnp&utm_templateID=12790186&utm_campaignID=-12345
 * @param {string} properties.customDestinationPageName_ - Name of the page or screen
 * @param {string} properties.pageType - The type of the page (i.e. 'Home', 'PDP', 'Category')
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/nJwmV1PLJl}
 */
export function logPageView(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(
      assertOptionalIterableCampaignId(properties.iterableCampaignId)
    );
    messages = messages.concat(
      assertOptionalCampaignUtmSource(properties.campaignUtmSource)
    );
    messages = messages.concat(
      assertOptionalCampaignUtmMedium(properties.campaignUtmMedium)
    );
    messages = messages.concat(
      assertOptionalCampaignUtmTerm(properties.campaignUtmTerm)
    );
    messages = messages.concat(
      assertOptionalCampaignUtmContent(properties.campaignUtmContent)
    );
    messages = messages.concat(
      assertOptionalCampaignUtmCampaign(properties.campaignUtmCampaign)
    );
    messages = messages.concat(
      assertOptionalIterableTemplateId(properties.iterableTemplateId)
    );
    messages = messages.concat(
      assertCustomDestinationPageName_(properties.customDestinationPageName_)
    );
    messages = messages.concat(assertPageType(properties.pageType));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Log Page View',
        Object.keys(properties),
        [
          'iterableCampaignId',
          'campaignUtmSource',
          'campaignUtmMedium',
          'campaignUtmTerm',
          'campaignUtmContent',
          'campaignUtmCampaign',
          'iterableTemplateId',
          'customDestinationPageName_',
          'pageType',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'nJwmV1PLJl',
        'd27e4d690e7e8bd2bad1389a4fbee15c9fb3975fd5992cfccc8aa8b6a1ee7d3d',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Log Page View',
      {
        iterable_campaign_id: properties.iterableCampaignId,
        campaign_utm_source: properties.campaignUtmSource,
        campaign_utm_medium: properties.campaignUtmMedium,
        campaign_utm_term: properties.campaignUtmTerm,
        campaign_utm_content: properties.campaignUtmContent,
        campaign_utm_campaign: properties.campaignUtmCampaign,
        iterable_template_id: properties.iterableTemplateId,
        page_type: properties.pageType,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'nJwmV1PLJl',
        'Log Page View',
        messages,
        [
          {
            id: '-yJgZgCLf0',
            name: 'campaign_utm_term',
            value: properties.campaignUtmTerm,
          },
          {
            id: '7-kG2dnolL',
            name: 'campaign_utm_medium',
            value: properties.campaignUtmMedium,
          },
          { id: 'LSca24_upS', name: 'page_type', value: properties.pageType },
          {
            id: 'ZC-o592Ouy',
            name: 'campaign_utm_source',
            value: properties.campaignUtmSource,
          },
          {
            id: 'cehAl0GP3c',
            name: 'campaign_utm_content',
            value: properties.campaignUtmContent,
          },
          {
            id: 'hahjHVdW76',
            name: 'campaign_utm_campaign',
            value: properties.campaignUtmCampaign,
          },
          {
            id: 'nkw4-m74P9',
            name: 'iterable_campaign_id',
            value: properties.iterableCampaignId,
          },
          {
            id: 'w9JwEo_jAXP',
            name: 'iterable_template_id',
            value: properties.iterableTemplateId,
          },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Log Page View': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    // destination RudderstackJavascript
    if (RudderstackJavascript.logPage) {
      RudderstackJavascript.logPage(properties.customDestinationPageName_, {
        iterable_campaign_id: properties.iterableCampaignId,
        campaign_utm_source: properties.campaignUtmSource,
        campaign_utm_medium: properties.campaignUtmMedium,
        campaign_utm_term: properties.campaignUtmTerm,
        campaign_utm_content: properties.campaignUtmContent,
        campaign_utm_campaign: properties.campaignUtmCampaign,
        iterable_template_id: properties.iterableTemplateId,
        page_type: properties.pageType,
      });
    } else if (RudderstackJavascript.page) {
      RudderstackJavascript.page(properties.customDestinationPageName_, {
        iterable_campaign_id: properties.iterableCampaignId,
        campaign_utm_source: properties.campaignUtmSource,
        campaign_utm_medium: properties.campaignUtmMedium,
        campaign_utm_term: properties.campaignUtmTerm,
        campaign_utm_content: properties.campaignUtmContent,
        campaign_utm_campaign: properties.campaignUtmCampaign,
        iterable_template_id: properties.iterableTemplateId,
        page_type: properties.pageType,
      });
    } else {
      InternalAvoLogger.error(
        'logPage/page method is not implemented in the destination',
        ''
      );
    }
  } else {
    // do nothing
  }
}

/**
 * Products Searched: Fired any time a user hits "Enter" or clicks away from the search box. It does not fire on each keypress
 * https://segment.com/docs/connections/spec/ecommerce/v2/#products-searched
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.query - Query the user searched with
 * @param {string} properties.location - The location where the event occurred. Possibilities are listed below:
 * * For the 'Email Acquired' event, options are: 'Guest Checkout', 'Swatch Request', 'Justuno', or 'Account Creation'
 * * For the 'Product Clicked' event, options are: 'Home Page', 'Category Page',  'PDP', or 'Cart'
 * * For the 'Product Added to Wishlist' event, options are: 'Home Page', 'Category Page', or 'PDP'
 * * For the 'Protection Plan Added' event, options are: 'PDP', 'Cart', 'Checkout'
 * * For the 'Coupon Applied/Denied/Entered/Removed' events, options are: 'PDP' & 'Checkout'
 * * For the 'Fabric Favorited/Unfavorited' events, options are: 'PDP', 'Shop By Material', 'Pet Friendly Page', & 'Safeguard Fabrics Page'
 * @param {string} properties.searchTarget - Describes how the user used the search bar.
 * -'Product Grid' refers to a user clicking on a product in the product grid
 * -'Other Results Link' refers to a user clicking on a link for 'Categories', 'Pages', or 'View results by'
 * -'Full Results' refers to a user hitting 'Enter' or clicking on the 'See full results button'
 * -'Exit Search' refers to a user clicking outside of the search bar and dropdown to return to the page that they were viewing before the search.
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/S4Okl_f3Vi}
 */
export function productsSearched(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertQuery(properties.query));
    messages = messages.concat(assertLocation(properties.location));
    messages = messages.concat(assertSearchTarget(properties.searchTarget));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Products Searched',
        Object.keys(properties),
        ['query', 'location', 'searchTarget']
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'S4Okl_f3Vi',
        'b05f20e20852876d15c99683f8f393a8d6b38e05a9984d5e5359c7850f361db6',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Products Searched',
      {
        query: properties.query,
        location: properties.location,
        search_target: properties.searchTarget,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'S4Okl_f3Vi',
        'Products Searched',
        messages,
        [
          { id: 'B71GIESiV8', name: 'location', value: properties.location },
          {
            id: 'Z-u59gjnyQ',
            name: 'search_target',
            value: properties.searchTarget,
          },
          { id: 'aIgVffpGJ1', name: 'query', value: properties.query },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Products Searched': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Products Searched',
        {
          query: properties.query,
          location: properties.location,
          search_target: properties.searchTarget,
        },
        'S4Okl_f3Vi',
        'b05f20e20852876d15c99683f8f393a8d6b38e05a9984d5e5359c7850f361db6'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Products Searched', {
      query: properties.query,
      location: properties.location,
      search_target: properties.searchTarget,
    });
  } else {
    // do nothing
  }
}

/**
 * Cookie Size: Fired with the size of the browser cookies.
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.userId_ - The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param {int} properties.cookieSize - Size of all the cookies in the user's browser
 * @param {Array<object>} properties.topCookies - An object with top cookies and their size.
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/v66H8fOVaa}
 */
export function cookieSize(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertUserId_(properties.userId_));
    messages = messages.concat(assertCookieSize(properties.cookieSize));
    messages = messages.concat(assertTopCookies(properties.topCookies));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Cookie Size',
        Object.keys(properties),
        ['userId_', 'cookieSize', 'topCookies']
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'v66H8fOVaa',
        '74d21e0d87b0ec60db2a21071c7ff5419d02a7fbcc5bfd0e26e7ccb6ac5847a0',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Cookie Size',
      {},
      {
        cookie_size: properties.cookieSize,
        top_cookies: properties.topCookies,
      },
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'v66H8fOVaa',
        'Cookie Size',
        messages,
        [],
        [
          {
            id: '-D2Sv66IYdW',
            name: 'top_cookies',
            value: properties.topCookies,
          },
          {
            id: '_bUst-pVux',
            name: 'cookie_size',
            value: properties.cookieSize,
          },
        ],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Cookie Size': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Cookie Size',
        {},
        'v66H8fOVaa',
        '74d21e0d87b0ec60db2a21071c7ff5419d02a7fbcc5bfd0e26e7ccb6ac5847a0'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.setUserProperties(properties.userId_, {
      cookie_size: properties.cookieSize,
      top_cookies: properties.topCookies,
    });
    RudderstackJavascript.logEvent('Cookie Size', {});
  } else {
    // do nothing
  }
}

/**
 * Hero Chat Visible: Fired when the hero chat is visible to the shopper.
 * https://docs.usehero.com/extend-hero/interaction-event-listeners#hero-is-ready
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.location - The location where the event occurred. Possibilities are listed below:
 * * For the 'Email Acquired' event, options are: 'Guest Checkout', 'Swatch Request', 'Justuno', or 'Account Creation'
 * * For the 'Product Clicked' event, options are: 'Home Page', 'Category Page',  'PDP', or 'Cart'
 * * For the 'Product Added to Wishlist' event, options are: 'Home Page', 'Category Page', or 'PDP'
 * * For the 'Protection Plan Added' event, options are: 'PDP', 'Cart', 'Checkout'
 * * For the 'Coupon Applied/Denied/Entered/Removed' events, options are: 'PDP' & 'Checkout'
 * * For the 'Fabric Favorited/Unfavorited' events, options are: 'PDP', 'Shop By Material', 'Pet Friendly Page', & 'Safeguard Fabrics Page'
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/e4i8614JvM}
 */
export function heroChatVisible(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertLocation(properties.location));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Hero Chat Visible',
        Object.keys(properties),
        ['location']
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'e4i8614JvM',
        'a75b37608512f85fba51f7c2bb9cf88ad920e6c0f43ca00558f53479e7b35c40',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Hero Chat Visible',
      {
        location: properties.location,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'e4i8614JvM',
        'Hero Chat Visible',
        messages,
        [{ id: 'B71GIESiV8', name: 'location', value: properties.location }],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Hero Chat Visible': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Hero Chat Visible',
        {
          location: properties.location,
        },
        'e4i8614JvM',
        'a75b37608512f85fba51f7c2bb9cf88ad920e6c0f43ca00558f53479e7b35c40'
      );
    }
  } else {
    // do nothing
  }
}

/**
 * Hero Chat in Use: Fired when the user has a conversation in-progress.
 * https://docs.usehero.com/extend-hero/interaction-event-listeners#hero-is-in-use
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.location - The location where the event occurred. Possibilities are listed below:
 * * For the 'Email Acquired' event, options are: 'Guest Checkout', 'Swatch Request', 'Justuno', or 'Account Creation'
 * * For the 'Product Clicked' event, options are: 'Home Page', 'Category Page',  'PDP', or 'Cart'
 * * For the 'Product Added to Wishlist' event, options are: 'Home Page', 'Category Page', or 'PDP'
 * * For the 'Protection Plan Added' event, options are: 'PDP', 'Cart', 'Checkout'
 * * For the 'Coupon Applied/Denied/Entered/Removed' events, options are: 'PDP' & 'Checkout'
 * * For the 'Fabric Favorited/Unfavorited' events, options are: 'PDP', 'Shop By Material', 'Pet Friendly Page', & 'Safeguard Fabrics Page'
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/VJYVgYd5bt}
 */
export function heroChatInUse(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertLocation(properties.location));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Hero Chat in Use',
        Object.keys(properties),
        ['location']
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'VJYVgYd5bt',
        '2251eae06a7ad4be303adb0f6f3fcf8391f2907102e30c3a005458016cc879f1',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Hero Chat in Use',
      {
        location: properties.location,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'VJYVgYd5bt',
        'Hero Chat in Use',
        messages,
        [{ id: 'B71GIESiV8', name: 'location', value: properties.location }],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Hero Chat in Use': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Hero Chat in Use',
        {
          location: properties.location,
        },
        'VJYVgYd5bt',
        '2251eae06a7ad4be303adb0f6f3fcf8391f2907102e30c3a005458016cc879f1'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Hero Chat in Use', {
      location: properties.location,
    });
  } else {
    // do nothing
  }
}

/**
 * Hero Chat Hidden: Fired when the hero chat is hidden.
 * https://docs.usehero.com/extend-hero/interaction-event-listeners#hero-has-been-hidden
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.location - The location where the event occurred. Possibilities are listed below:
 * * For the 'Email Acquired' event, options are: 'Guest Checkout', 'Swatch Request', 'Justuno', or 'Account Creation'
 * * For the 'Product Clicked' event, options are: 'Home Page', 'Category Page',  'PDP', or 'Cart'
 * * For the 'Product Added to Wishlist' event, options are: 'Home Page', 'Category Page', or 'PDP'
 * * For the 'Protection Plan Added' event, options are: 'PDP', 'Cart', 'Checkout'
 * * For the 'Coupon Applied/Denied/Entered/Removed' events, options are: 'PDP' & 'Checkout'
 * * For the 'Fabric Favorited/Unfavorited' events, options are: 'PDP', 'Shop By Material', 'Pet Friendly Page', & 'Safeguard Fabrics Page'
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/ADG-Y0RyEX}
 */
export function heroChatHidden(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertLocation(properties.location));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Hero Chat Hidden',
        Object.keys(properties),
        ['location']
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'ADG-Y0RyEX',
        'a95a1ab7bda714ab3edf107a184cde72730d5b65b0c11a859dc0816d73580686',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Hero Chat Hidden',
      {
        location: properties.location,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'ADG-Y0RyEX',
        'Hero Chat Hidden',
        messages,
        [{ id: 'B71GIESiV8', name: 'location', value: properties.location }],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Hero Chat Hidden': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Hero Chat Hidden',
        {
          location: properties.location,
        },
        'ADG-Y0RyEX',
        'a95a1ab7bda714ab3edf107a184cde72730d5b65b0c11a859dc0816d73580686'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Hero Chat Hidden', {
      location: properties.location,
    });
  } else {
    // do nothing
  }
}

/**
 * Hero Chat Ended: Fired when a chat has ended.
 * https://docs.usehero.com/extend-hero/interaction-event-listeners#hero-conversation-has-ended
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.location - The location where the event occurred. Possibilities are listed below:
 * * For the 'Email Acquired' event, options are: 'Guest Checkout', 'Swatch Request', 'Justuno', or 'Account Creation'
 * * For the 'Product Clicked' event, options are: 'Home Page', 'Category Page',  'PDP', or 'Cart'
 * * For the 'Product Added to Wishlist' event, options are: 'Home Page', 'Category Page', or 'PDP'
 * * For the 'Protection Plan Added' event, options are: 'PDP', 'Cart', 'Checkout'
 * * For the 'Coupon Applied/Denied/Entered/Removed' events, options are: 'PDP' & 'Checkout'
 * * For the 'Fabric Favorited/Unfavorited' events, options are: 'PDP', 'Shop By Material', 'Pet Friendly Page', & 'Safeguard Fabrics Page'
 * @param {string} properties.conversationId - A unique ID to be able to reference the specific conversation.
 * Reference: https://docs.usehero.com/extend-hero/interaction-event-listeners#hero-conversation-has-ended
 * @param {string} [properties.associateId] - The Hero ID of the associate in the conversation. Only populates when the shopper is using the Hero Messenger when the conversation ends.
 * Reference: https://docs.usehero.com/extend-hero/interaction-event-listeners#hero-conversation-has-ended
 * @param {string} [properties.associateEmployeeId] - The Employee ID of the associate in the conversation. Only displays if this feature has been enabled as part of the Associate sign-up process. Only populated when the shopper is using the Messenger when the conversation ends.
 * Reference: https://docs.usehero.com/extend-hero/interaction-event-listeners#hero-conversation-has-ended
 * @param {bool} [properties.now] - 'True' indicates that the event happened now, in real time. 'False' indicates the event happened in the past. Only populates when the shopper is using the Hero Messenger when the conversation ends.
 * Reference: https://docs.usehero.com/extend-hero/interaction-event-listeners#hero-conversation-has-ended
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/Dt3bAM5gnp}
 */
export function heroChatEnded(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertLocation(properties.location));
    messages = messages.concat(assertConversationId(properties.conversationId));
    messages = messages.concat(
      assertOptionalAssociateId(properties.associateId)
    );
    messages = messages.concat(
      assertOptionalAssociateEmployeeId(properties.associateEmployeeId)
    );
    messages = messages.concat(assertOptionalNow(properties.now));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Hero Chat Ended',
        Object.keys(properties),
        [
          'location',
          'conversationId',
          'associateId',
          'associateEmployeeId',
          'now',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'Dt3bAM5gnp',
        '4a9179b4cf13099d4e3dd17e48d29f383533bcc9fcdafdf9de5bc3cc92cb55c6',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Hero Chat Ended',
      {
        location: properties.location,
        conversation_id: properties.conversationId,
        associate_id: properties.associateId,
        associate_employee_id: properties.associateEmployeeId,
        now: properties.now,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'Dt3bAM5gnp',
        'Hero Chat Ended',
        messages,
        [
          { id: '5wx0Y-QWlE', name: 'now', value: properties.now },
          { id: 'B71GIESiV8', name: 'location', value: properties.location },
          {
            id: 'H-g_LoQM0',
            name: 'associate_id',
            value: properties.associateId,
          },
          {
            id: 'OL7LDS0Icb',
            name: 'conversation_id',
            value: properties.conversationId,
          },
          {
            id: 'ySpqRs9Laj',
            name: 'associate_employee_id',
            value: properties.associateEmployeeId,
          },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Hero Chat Ended': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Hero Chat Ended',
        {
          location: properties.location,
          conversation_id: properties.conversationId,
          associate_id: properties.associateId,
          associate_employee_id: properties.associateEmployeeId,
          now: properties.now,
        },
        'Dt3bAM5gnp',
        '4a9179b4cf13099d4e3dd17e48d29f383533bcc9fcdafdf9de5bc3cc92cb55c6'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Hero Chat Ended', {
      location: properties.location,
      conversation_id: properties.conversationId,
      associate_id: properties.associateId,
      associate_employee_id: properties.associateEmployeeId,
      now: properties.now,
    });
  } else {
    // do nothing
  }
}

/**
 * Fabric Favorited: Fired when a user double clicks the fabric icon to favorite the corresponding fabric.
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.location - The location where the event occurred. Possibilities are listed below:
 * * For the 'Email Acquired' event, options are: 'Guest Checkout', 'Swatch Request', 'Justuno', or 'Account Creation'
 * * For the 'Product Clicked' event, options are: 'Home Page', 'Category Page',  'PDP', or 'Cart'
 * * For the 'Product Added to Wishlist' event, options are: 'Home Page', 'Category Page', or 'PDP'
 * * For the 'Protection Plan Added' event, options are: 'PDP', 'Cart', 'Checkout'
 * * For the 'Coupon Applied/Denied/Entered/Removed' events, options are: 'PDP' & 'Checkout'
 * * For the 'Fabric Favorited/Unfavorited' events, options are: 'PDP', 'Shop By Material', 'Pet Friendly Page', & 'Safeguard Fabrics Page'
 * @param {int} properties.fabricId - The fabric id (i.e. For Bentley Daisy it's 263)
 * @param {string} properties.fabricName - The fabric name (i.e. 'Taylor Felt Grey')
 * If a user selected 'Decide Later', the fabric name should be 'Decide Later'.
 * @param {string} properties.fabricColor - The fabric's parent color (i.e. Green, Red, Blue, etc.).
 * If a user selected 'Decide Later', the fabric color should be 'Decide Later'.
 * @param {int} [properties.productId] - The 3-5 digit product id (i.e. `623` corresponds to Hughes Sofa)
 * @param {string} [properties.name] - Full product name (i.e. 'Hughes Grand Sofa')
 * @param {string} [properties.category] - The product type (i.e. 'Chair', 'Sofa', etc.). This is NOT the category in terms of Joybird's use of the term 'category', this is the product type.
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/-B3v4PWKCi}
 */
export function fabricFavorited(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertLocation(properties.location));
    messages = messages.concat(assertFabricId(properties.fabricId));
    messages = messages.concat(assertFabricName(properties.fabricName));
    messages = messages.concat(assertFabricColor(properties.fabricColor));
    messages = messages.concat(assertOptionalProductId(properties.productId));
    messages = messages.concat(assertOptionalName(properties.name));
    messages = messages.concat(assertOptionalCategory(properties.category));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Fabric Favorited',
        Object.keys(properties),
        [
          'location',
          'fabricId',
          'fabricName',
          'fabricColor',
          'productId',
          'name',
          'category',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '-B3v4PWKCi',
        'cc7c32942f8b20fd00fc0cb556ac04290a13e8847c0c5e08a4f699486dfb5f95',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Fabric Favorited',
      {
        location: properties.location,
        fabric_id: properties.fabricId,
        fabric_name: properties.fabricName,
        fabric_color: properties.fabricColor,
        product_id: properties.productId,
        name: properties.name,
        category: properties.category,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '-B3v4PWKCi',
        'Fabric Favorited',
        messages,
        [
          { id: '3PXRzRK2KK', name: 'category', value: properties.category },
          { id: 'B71GIESiV8', name: 'location', value: properties.location },
          { id: 'EghVtONPP', name: 'name', value: properties.name },
          {
            id: 'cZN2CHE3RG',
            name: 'fabric_color',
            value: properties.fabricColor,
          },
          { id: 'nHu4WfjB0w', name: 'product_id', value: properties.productId },
          { id: 'vl8jHhQKP6', name: 'fabric_id', value: properties.fabricId },
          {
            id: 'z-KPDmLIa_',
            name: 'fabric_name',
            value: properties.fabricName,
          },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Fabric Favorited': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Fabric Favorited',
        {
          location: properties.location,
          fabric_id: properties.fabricId,
          fabric_name: properties.fabricName,
          fabric_color: properties.fabricColor,
          product_id: properties.productId,
          name: properties.name,
          category: properties.category,
        },
        '-B3v4PWKCi',
        'cc7c32942f8b20fd00fc0cb556ac04290a13e8847c0c5e08a4f699486dfb5f95'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Fabric Favorited', {
      location: properties.location,
      fabric_id: properties.fabricId,
      fabric_name: properties.fabricName,
      fabric_color: properties.fabricColor,
      product_id: properties.productId,
      name: properties.name,
      category: properties.category,
    });
  } else {
    // do nothing
  }
}

/**
 * Fabric Unfavorited: Fired when a user double clicks a favorited fabric icon to unfavorite it.
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.location - The location where the event occurred. Possibilities are listed below:
 * * For the 'Email Acquired' event, options are: 'Guest Checkout', 'Swatch Request', 'Justuno', or 'Account Creation'
 * * For the 'Product Clicked' event, options are: 'Home Page', 'Category Page',  'PDP', or 'Cart'
 * * For the 'Product Added to Wishlist' event, options are: 'Home Page', 'Category Page', or 'PDP'
 * * For the 'Protection Plan Added' event, options are: 'PDP', 'Cart', 'Checkout'
 * * For the 'Coupon Applied/Denied/Entered/Removed' events, options are: 'PDP' & 'Checkout'
 * * For the 'Fabric Favorited/Unfavorited' events, options are: 'PDP', 'Shop By Material', 'Pet Friendly Page', & 'Safeguard Fabrics Page'
 * @param {int} properties.fabricId - The fabric id (i.e. For Bentley Daisy it's 263)
 * @param {string} properties.fabricName - The fabric name (i.e. 'Taylor Felt Grey')
 * If a user selected 'Decide Later', the fabric name should be 'Decide Later'.
 * @param {string} properties.fabricColor - The fabric's parent color (i.e. Green, Red, Blue, etc.).
 * If a user selected 'Decide Later', the fabric color should be 'Decide Later'.
 * @param {int} [properties.productId] - The 3-5 digit product id (i.e. `623` corresponds to Hughes Sofa)
 * @param {string} [properties.name] - Full product name (i.e. 'Hughes Grand Sofa')
 * @param {string} [properties.category] - The product type (i.e. 'Chair', 'Sofa', etc.). This is NOT the category in terms of Joybird's use of the term 'category', this is the product type.
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/GoqVEFP6OJ}
 */
export function fabricUnfavorited(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertLocation(properties.location));
    messages = messages.concat(assertFabricId(properties.fabricId));
    messages = messages.concat(assertFabricName(properties.fabricName));
    messages = messages.concat(assertFabricColor(properties.fabricColor));
    messages = messages.concat(assertOptionalProductId(properties.productId));
    messages = messages.concat(assertOptionalName(properties.name));
    messages = messages.concat(assertOptionalCategory(properties.category));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Fabric Unfavorited',
        Object.keys(properties),
        [
          'location',
          'fabricId',
          'fabricName',
          'fabricColor',
          'productId',
          'name',
          'category',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'GoqVEFP6OJ',
        '819719db6ffc87a2a98678675faeb8b069b372b07341e369350b57ce9be64aae',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Fabric Unfavorited',
      {
        location: properties.location,
        fabric_id: properties.fabricId,
        fabric_name: properties.fabricName,
        fabric_color: properties.fabricColor,
        product_id: properties.productId,
        name: properties.name,
        category: properties.category,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'GoqVEFP6OJ',
        'Fabric Unfavorited',
        messages,
        [
          { id: '3PXRzRK2KK', name: 'category', value: properties.category },
          { id: 'B71GIESiV8', name: 'location', value: properties.location },
          { id: 'EghVtONPP', name: 'name', value: properties.name },
          {
            id: 'cZN2CHE3RG',
            name: 'fabric_color',
            value: properties.fabricColor,
          },
          { id: 'nHu4WfjB0w', name: 'product_id', value: properties.productId },
          { id: 'vl8jHhQKP6', name: 'fabric_id', value: properties.fabricId },
          {
            id: 'z-KPDmLIa_',
            name: 'fabric_name',
            value: properties.fabricName,
          },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Fabric Unfavorited': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Fabric Unfavorited',
        {
          location: properties.location,
          fabric_id: properties.fabricId,
          fabric_name: properties.fabricName,
          fabric_color: properties.fabricColor,
          product_id: properties.productId,
          name: properties.name,
          category: properties.category,
        },
        'GoqVEFP6OJ',
        '819719db6ffc87a2a98678675faeb8b069b372b07341e369350b57ce9be64aae'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Fabric Unfavorited', {
      location: properties.location,
      fabric_id: properties.fabricId,
      fabric_name: properties.fabricName,
      fabric_color: properties.fabricColor,
      product_id: properties.productId,
      name: properties.name,
      category: properties.category,
    });
  } else {
    // do nothing
  }
}

/**
 * Cylindo Spin Started: Fired when a user spins a product in the Cylindo Viewer
 * https://viewer.cylindo.com/3.x/v3.3/documentation/index.html#/viewer-listen-to-events
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.category - The product type (i.e. 'Chair', 'Sofa', etc.). This is NOT the category in terms of Joybird's use of the term 'category', this is the product type.
 * @param {string} properties.fabricName - The fabric name (i.e. 'Taylor Felt Grey')
 * If a user selected 'Decide Later', the fabric name should be 'Decide Later'.
 * @param {int} properties.fabricId - The fabric id (i.e. For Bentley Daisy it's 263)
 * @param {string} properties.sku - The full sku (i.e. 'JB103853-CF200-WS03')
 * Product Viewed -> Send the full sku of the first image shown (not the fabric that's selected)
 * @param {string} properties.productFamily - The family of the product (i.e. 'Hughes', 'Soto', ect.).
 * @param {int} properties.productId - The 3-5 digit product id (i.e. `623` corresponds to Hughes Sofa)
 * @param {float} properties.price - The price the user pays. If there is a sale, this is the sale price, if there is no sale, this is the full price
 * @param {string} properties.fabricColor - The fabric's parent color (i.e. Green, Red, Blue, etc.).
 * If a user selected 'Decide Later', the fabric color should be 'Decide Later'.
 * @param {string} properties.name - Full product name (i.e. 'Hughes Grand Sofa')
 * @param {string} properties.variant - All product options for a product, separated by a comma and a space (i.e. 'Taylor Felt Grey, Mocha, Left, Cone').
 * If a user selected 'Decide Later', the variant should be 'Decide Later'.
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/o4Tcgtsjho}
 */
export function cylindoSpinStarted(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertCategory(properties.category));
    messages = messages.concat(assertFabricName(properties.fabricName));
    messages = messages.concat(assertFabricId(properties.fabricId));
    messages = messages.concat(assertSku(properties.sku));
    messages = messages.concat(assertProductFamily(properties.productFamily));
    messages = messages.concat(assertProductId(properties.productId));
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(assertFabricColor(properties.fabricColor));
    messages = messages.concat(assertName(properties.name));
    messages = messages.concat(assertVariant(properties.variant));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Cylindo Spin Started',
        Object.keys(properties),
        [
          'category',
          'fabricName',
          'fabricId',
          'sku',
          'productFamily',
          'productId',
          'price',
          'fabricColor',
          'name',
          'variant',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'o4Tcgtsjho',
        '733c9b0446a17ee81264503b0155cc52e7c96d0cf4c27fd74620e0ff13b91b1f',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Cylindo Spin Started',
      {
        category: properties.category,
        fabric_name: properties.fabricName,
        fabric_id: properties.fabricId,
        sku: properties.sku,
        product_family: properties.productFamily,
        product_id: properties.productId,
        price: properties.price,
        fabric_color: properties.fabricColor,
        name: properties.name,
        variant: properties.variant,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'o4Tcgtsjho',
        'Cylindo Spin Started',
        messages,
        [
          { id: '3PXRzRK2KK', name: 'category', value: properties.category },
          { id: 'EghVtONPP', name: 'name', value: properties.name },
          {
            id: 'cZN2CHE3RG',
            name: 'fabric_color',
            value: properties.fabricColor,
          },
          { id: 'j-kP3_J7Rb', name: 'price', value: properties.price },
          { id: 'nHu4WfjB0w', name: 'product_id', value: properties.productId },
          {
            id: 'rYLq0zrdEe',
            name: 'product_family',
            value: properties.productFamily,
          },
          { id: 'uI2-rwjYtt', name: 'sku', value: properties.sku },
          { id: 'vl8jHhQKP6', name: 'fabric_id', value: properties.fabricId },
          {
            id: 'z-KPDmLIa_',
            name: 'fabric_name',
            value: properties.fabricName,
          },
          { id: 'zsMuCAiZ4D', name: 'variant', value: properties.variant },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Cylindo Spin Started': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Cylindo Spin Started',
        {
          category: properties.category,
          fabric_name: properties.fabricName,
          fabric_id: properties.fabricId,
          sku: properties.sku,
          product_family: properties.productFamily,
          product_id: properties.productId,
          price: properties.price,
          fabric_color: properties.fabricColor,
          name: properties.name,
          variant: properties.variant,
        },
        'o4Tcgtsjho',
        '733c9b0446a17ee81264503b0155cc52e7c96d0cf4c27fd74620e0ff13b91b1f'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Cylindo Spin Started', {
      category: properties.category,
      fabric_name: properties.fabricName,
      fabric_id: properties.fabricId,
      sku: properties.sku,
      product_family: properties.productFamily,
      product_id: properties.productId,
      price: properties.price,
      fabric_color: properties.fabricColor,
      name: properties.name,
      variant: properties.variant,
    });
  } else {
    // do nothing
  }
}

/**
 * Cylindo Spin Ended: Fired when a user stops spinning a product in the Cylindo Viewer
 * https://viewer.cylindo.com/3.x/v3.3/documentation/index.html#/viewer-listen-to-events
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.category - The product type (i.e. 'Chair', 'Sofa', etc.). This is NOT the category in terms of Joybird's use of the term 'category', this is the product type.
 * @param {int} properties.fabricId - The fabric id (i.e. For Bentley Daisy it's 263)
 * @param {string} properties.fabricName - The fabric name (i.e. 'Taylor Felt Grey')
 * If a user selected 'Decide Later', the fabric name should be 'Decide Later'.
 * @param {string} properties.fabricColor - The fabric's parent color (i.e. Green, Red, Blue, etc.).
 * If a user selected 'Decide Later', the fabric color should be 'Decide Later'.
 * @param {string} properties.name - Full product name (i.e. 'Hughes Grand Sofa')
 * @param {int} properties.productId - The 3-5 digit product id (i.e. `623` corresponds to Hughes Sofa)
 * @param {string} properties.productFamily - The family of the product (i.e. 'Hughes', 'Soto', ect.).
 * @param {string} properties.sku - The full sku (i.e. 'JB103853-CF200-WS03')
 * Product Viewed -> Send the full sku of the first image shown (not the fabric that's selected)
 * @param {string} properties.variant - All product options for a product, separated by a comma and a space (i.e. 'Taylor Felt Grey, Mocha, Left, Cone').
 * If a user selected 'Decide Later', the variant should be 'Decide Later'.
 * @param {float} properties.price - The price the user pays. If there is a sale, this is the sale price, if there is no sale, this is the full price
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/W_YJ52SntZ}
 */
export function cylindoSpinEnded(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertCategory(properties.category));
    messages = messages.concat(assertFabricId(properties.fabricId));
    messages = messages.concat(assertFabricName(properties.fabricName));
    messages = messages.concat(assertFabricColor(properties.fabricColor));
    messages = messages.concat(assertName(properties.name));
    messages = messages.concat(assertProductId(properties.productId));
    messages = messages.concat(assertProductFamily(properties.productFamily));
    messages = messages.concat(assertSku(properties.sku));
    messages = messages.concat(assertVariant(properties.variant));
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Cylindo Spin Ended',
        Object.keys(properties),
        [
          'category',
          'fabricId',
          'fabricName',
          'fabricColor',
          'name',
          'productId',
          'productFamily',
          'sku',
          'variant',
          'price',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'W_YJ52SntZ',
        '73961f6a589216c9e0f9031d327ae02eb8d8fb3f34650d2a0d96755d404b7e01',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Cylindo Spin Ended',
      {
        category: properties.category,
        fabric_id: properties.fabricId,
        fabric_name: properties.fabricName,
        fabric_color: properties.fabricColor,
        name: properties.name,
        product_id: properties.productId,
        product_family: properties.productFamily,
        sku: properties.sku,
        variant: properties.variant,
        price: properties.price,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'W_YJ52SntZ',
        'Cylindo Spin Ended',
        messages,
        [
          { id: '3PXRzRK2KK', name: 'category', value: properties.category },
          { id: 'EghVtONPP', name: 'name', value: properties.name },
          {
            id: 'cZN2CHE3RG',
            name: 'fabric_color',
            value: properties.fabricColor,
          },
          { id: 'j-kP3_J7Rb', name: 'price', value: properties.price },
          { id: 'nHu4WfjB0w', name: 'product_id', value: properties.productId },
          {
            id: 'rYLq0zrdEe',
            name: 'product_family',
            value: properties.productFamily,
          },
          { id: 'uI2-rwjYtt', name: 'sku', value: properties.sku },
          { id: 'vl8jHhQKP6', name: 'fabric_id', value: properties.fabricId },
          {
            id: 'z-KPDmLIa_',
            name: 'fabric_name',
            value: properties.fabricName,
          },
          { id: 'zsMuCAiZ4D', name: 'variant', value: properties.variant },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Cylindo Spin Ended': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Cylindo Spin Ended',
        {
          category: properties.category,
          fabric_id: properties.fabricId,
          fabric_name: properties.fabricName,
          fabric_color: properties.fabricColor,
          name: properties.name,
          product_id: properties.productId,
          product_family: properties.productFamily,
          sku: properties.sku,
          variant: properties.variant,
          price: properties.price,
        },
        'W_YJ52SntZ',
        '73961f6a589216c9e0f9031d327ae02eb8d8fb3f34650d2a0d96755d404b7e01'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Cylindo Spin Ended', {
      category: properties.category,
      fabric_id: properties.fabricId,
      fabric_name: properties.fabricName,
      fabric_color: properties.fabricColor,
      name: properties.name,
      product_id: properties.productId,
      product_family: properties.productFamily,
      sku: properties.sku,
      variant: properties.variant,
      price: properties.price,
    });
  } else {
    // do nothing
  }
}

/**
 * Cylindo Zoomed In: Fired when a user zooms in on the Cylindo Viewer
 * https://viewer.cylindo.com/3.x/v3.3/documentation/index.html#/viewer-listen-to-events
 *
 * @param {object} properties - the properties associated with this event
 * @param {int} properties.productId - The 3-5 digit product id (i.e. `623` corresponds to Hughes Sofa)
 * @param {string} properties.category - The product type (i.e. 'Chair', 'Sofa', etc.). This is NOT the category in terms of Joybird's use of the term 'category', this is the product type.
 * @param {int} properties.fabricId - The fabric id (i.e. For Bentley Daisy it's 263)
 * @param {string} properties.fabricName - The fabric name (i.e. 'Taylor Felt Grey')
 * If a user selected 'Decide Later', the fabric name should be 'Decide Later'.
 * @param {string} properties.variant - All product options for a product, separated by a comma and a space (i.e. 'Taylor Felt Grey, Mocha, Left, Cone').
 * If a user selected 'Decide Later', the variant should be 'Decide Later'.
 * @param {string} properties.sku - The full sku (i.e. 'JB103853-CF200-WS03')
 * Product Viewed -> Send the full sku of the first image shown (not the fabric that's selected)
 * @param {string} properties.productFamily - The family of the product (i.e. 'Hughes', 'Soto', ect.).
 * @param {string} properties.fabricColor - The fabric's parent color (i.e. Green, Red, Blue, etc.).
 * If a user selected 'Decide Later', the fabric color should be 'Decide Later'.
 * @param {string} properties.name - Full product name (i.e. 'Hughes Grand Sofa')
 * @param {float} properties.price - The price the user pays. If there is a sale, this is the sale price, if there is no sale, this is the full price
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/86qDZEPihM}
 */
export function cylindoZoomedIn(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertProductId(properties.productId));
    messages = messages.concat(assertCategory(properties.category));
    messages = messages.concat(assertFabricId(properties.fabricId));
    messages = messages.concat(assertFabricName(properties.fabricName));
    messages = messages.concat(assertVariant(properties.variant));
    messages = messages.concat(assertSku(properties.sku));
    messages = messages.concat(assertProductFamily(properties.productFamily));
    messages = messages.concat(assertFabricColor(properties.fabricColor));
    messages = messages.concat(assertName(properties.name));
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Cylindo Zoomed In',
        Object.keys(properties),
        [
          'productId',
          'category',
          'fabricId',
          'fabricName',
          'variant',
          'sku',
          'productFamily',
          'fabricColor',
          'name',
          'price',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '86qDZEPihM',
        '72108533bf3ff9aa8d8a4cce6b4ef2d56069053d88f4c0bdaa556c7b70a1b231',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Cylindo Zoomed In',
      {
        product_id: properties.productId,
        category: properties.category,
        fabric_id: properties.fabricId,
        fabric_name: properties.fabricName,
        variant: properties.variant,
        sku: properties.sku,
        product_family: properties.productFamily,
        fabric_color: properties.fabricColor,
        name: properties.name,
        price: properties.price,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '86qDZEPihM',
        'Cylindo Zoomed In',
        messages,
        [
          { id: '3PXRzRK2KK', name: 'category', value: properties.category },
          { id: 'EghVtONPP', name: 'name', value: properties.name },
          {
            id: 'cZN2CHE3RG',
            name: 'fabric_color',
            value: properties.fabricColor,
          },
          { id: 'j-kP3_J7Rb', name: 'price', value: properties.price },
          { id: 'nHu4WfjB0w', name: 'product_id', value: properties.productId },
          {
            id: 'rYLq0zrdEe',
            name: 'product_family',
            value: properties.productFamily,
          },
          { id: 'uI2-rwjYtt', name: 'sku', value: properties.sku },
          { id: 'vl8jHhQKP6', name: 'fabric_id', value: properties.fabricId },
          {
            id: 'z-KPDmLIa_',
            name: 'fabric_name',
            value: properties.fabricName,
          },
          { id: 'zsMuCAiZ4D', name: 'variant', value: properties.variant },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Cylindo Zoomed In': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Cylindo Zoomed In',
        {
          product_id: properties.productId,
          category: properties.category,
          fabric_id: properties.fabricId,
          fabric_name: properties.fabricName,
          variant: properties.variant,
          sku: properties.sku,
          product_family: properties.productFamily,
          fabric_color: properties.fabricColor,
          name: properties.name,
          price: properties.price,
        },
        '86qDZEPihM',
        '72108533bf3ff9aa8d8a4cce6b4ef2d56069053d88f4c0bdaa556c7b70a1b231'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Cylindo Zoomed In', {
      product_id: properties.productId,
      category: properties.category,
      fabric_id: properties.fabricId,
      fabric_name: properties.fabricName,
      variant: properties.variant,
      sku: properties.sku,
      product_family: properties.productFamily,
      fabric_color: properties.fabricColor,
      name: properties.name,
      price: properties.price,
    });
  } else {
    // do nothing
  }
}

/**
 * Cylindo Zoomed Out: Fired when a user zooms out on the Cylindo Viewer
 * https://viewer.cylindo.com/3.x/v3.3/documentation/index.html#/viewer-listen-to-events
 *
 * @param {object} properties - the properties associated with this event
 * @param {int} properties.productId - The 3-5 digit product id (i.e. `623` corresponds to Hughes Sofa)
 * @param {string} properties.name - Full product name (i.e. 'Hughes Grand Sofa')
 * @param {string} properties.category - The product type (i.e. 'Chair', 'Sofa', etc.). This is NOT the category in terms of Joybird's use of the term 'category', this is the product type.
 * @param {string} properties.productFamily - The family of the product (i.e. 'Hughes', 'Soto', ect.).
 * @param {string} properties.sku - The full sku (i.e. 'JB103853-CF200-WS03')
 * Product Viewed -> Send the full sku of the first image shown (not the fabric that's selected)
 * @param {string} properties.variant - All product options for a product, separated by a comma and a space (i.e. 'Taylor Felt Grey, Mocha, Left, Cone').
 * If a user selected 'Decide Later', the variant should be 'Decide Later'.
 * @param {float} properties.price - The price the user pays. If there is a sale, this is the sale price, if there is no sale, this is the full price
 * @param {int} properties.fabricId - The fabric id (i.e. For Bentley Daisy it's 263)
 * @param {string} properties.fabricName - The fabric name (i.e. 'Taylor Felt Grey')
 * If a user selected 'Decide Later', the fabric name should be 'Decide Later'.
 * @param {string} properties.fabricColor - The fabric's parent color (i.e. Green, Red, Blue, etc.).
 * If a user selected 'Decide Later', the fabric color should be 'Decide Later'.
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/5LyXKcMeK}
 */
export function cylindoZoomedOut(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertProductId(properties.productId));
    messages = messages.concat(assertName(properties.name));
    messages = messages.concat(assertCategory(properties.category));
    messages = messages.concat(assertProductFamily(properties.productFamily));
    messages = messages.concat(assertSku(properties.sku));
    messages = messages.concat(assertVariant(properties.variant));
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(assertFabricId(properties.fabricId));
    messages = messages.concat(assertFabricName(properties.fabricName));
    messages = messages.concat(assertFabricColor(properties.fabricColor));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Cylindo Zoomed Out',
        Object.keys(properties),
        [
          'productId',
          'name',
          'category',
          'productFamily',
          'sku',
          'variant',
          'price',
          'fabricId',
          'fabricName',
          'fabricColor',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '5LyXKcMeK',
        'd1d96580a8064339ff34f1c49eaa2c632ebd3b00f5a153d42c32b8d47f90bf0e',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Cylindo Zoomed Out',
      {
        product_id: properties.productId,
        name: properties.name,
        category: properties.category,
        product_family: properties.productFamily,
        sku: properties.sku,
        variant: properties.variant,
        price: properties.price,
        fabric_id: properties.fabricId,
        fabric_name: properties.fabricName,
        fabric_color: properties.fabricColor,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '5LyXKcMeK',
        'Cylindo Zoomed Out',
        messages,
        [
          { id: '3PXRzRK2KK', name: 'category', value: properties.category },
          { id: 'EghVtONPP', name: 'name', value: properties.name },
          {
            id: 'cZN2CHE3RG',
            name: 'fabric_color',
            value: properties.fabricColor,
          },
          { id: 'j-kP3_J7Rb', name: 'price', value: properties.price },
          { id: 'nHu4WfjB0w', name: 'product_id', value: properties.productId },
          {
            id: 'rYLq0zrdEe',
            name: 'product_family',
            value: properties.productFamily,
          },
          { id: 'uI2-rwjYtt', name: 'sku', value: properties.sku },
          { id: 'vl8jHhQKP6', name: 'fabric_id', value: properties.fabricId },
          {
            id: 'z-KPDmLIa_',
            name: 'fabric_name',
            value: properties.fabricName,
          },
          { id: 'zsMuCAiZ4D', name: 'variant', value: properties.variant },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Cylindo Zoomed Out': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Cylindo Zoomed Out',
        {
          product_id: properties.productId,
          name: properties.name,
          category: properties.category,
          product_family: properties.productFamily,
          sku: properties.sku,
          variant: properties.variant,
          price: properties.price,
          fabric_id: properties.fabricId,
          fabric_name: properties.fabricName,
          fabric_color: properties.fabricColor,
        },
        '5LyXKcMeK',
        'd1d96580a8064339ff34f1c49eaa2c632ebd3b00f5a153d42c32b8d47f90bf0e'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Cylindo Zoomed Out', {
      product_id: properties.productId,
      name: properties.name,
      category: properties.category,
      product_family: properties.productFamily,
      sku: properties.sku,
      variant: properties.variant,
      price: properties.price,
      fabric_id: properties.fabricId,
      fabric_name: properties.fabricName,
      fabric_color: properties.fabricColor,
    });
  } else {
    // do nothing
  }
}

/**
 * Quickview Opened: Fired when a quickview modal is opened.
 *
 * @param {object} properties - the properties associated with this event
 * @param {int} properties.productId - The 3-5 digit product id (i.e. `623` corresponds to Hughes Sofa)
 * @param {string} properties.category - The product type (i.e. 'Chair', 'Sofa', etc.). This is NOT the category in terms of Joybird's use of the term 'category', this is the product type.
 * @param {bool} properties.isClearance - Whether or not the item was on clearance
 * @param {string} properties.name - Full product name (i.e. 'Hughes Grand Sofa')
 * @param {float} properties.price - The price the user pays. If there is a sale, this is the sale price, if there is no sale, this is the full price
 * @param {int} properties.quantity - The quantity of products
 * @param {string} properties.sku - The full sku (i.e. 'JB103853-CF200-WS03')
 * Product Viewed -> Send the full sku of the first image shown (not the fabric that's selected)
 * @param {string} properties.variant - All product options for a product, separated by a comma and a space (i.e. 'Taylor Felt Grey, Mocha, Left, Cone').
 * If a user selected 'Decide Later', the variant should be 'Decide Later'.
 * @param {float} properties.fullPrice - The full price of the product
 * @param {string} properties.productFamily - The family of the product (i.e. 'Hughes', 'Soto', ect.).
 * @param {Array<string>} properties.contentIds - The base product sku(s) (i.e. if the sku is 'JB11069110-CF423-WS03', the value for Content IDs should be ['JB11069110']).
 * @param {bool} properties.isFlashSale - Whether or not the item was on flash sale
 * @param {string} properties.location - The location where the event occurred. Possibilities are listed below:
 * * For the 'Email Acquired' event, options are: 'Guest Checkout', 'Swatch Request', 'Justuno', or 'Account Creation'
 * * For the 'Product Clicked' event, options are: 'Home Page', 'Category Page',  'PDP', or 'Cart'
 * * For the 'Product Added to Wishlist' event, options are: 'Home Page', 'Category Page', or 'PDP'
 * * For the 'Protection Plan Added' event, options are: 'PDP', 'Cart', 'Checkout'
 * * For the 'Coupon Applied/Denied/Entered/Removed' events, options are: 'PDP' & 'Checkout'
 * * For the 'Fabric Favorited/Unfavorited' events, options are: 'PDP', 'Shop By Material', 'Pet Friendly Page', & 'Safeguard Fabrics Page'
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/XMnGwvbU11}
 */
export function quickviewOpened(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertProductId(properties.productId));
    messages = messages.concat(assertCategory(properties.category));
    messages = messages.concat(assertIsClearance(properties.isClearance));
    messages = messages.concat(assertName(properties.name));
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(assertQuantity(properties.quantity));
    messages = messages.concat(assertSku(properties.sku));
    messages = messages.concat(assertVariant(properties.variant));
    messages = messages.concat(assertFullPrice(properties.fullPrice));
    messages = messages.concat(assertProductFamily(properties.productFamily));
    messages = messages.concat(assertContentIds(properties.contentIds));
    messages = messages.concat(assertIsFlashSale(properties.isFlashSale));
    messages = messages.concat(assertLocation(properties.location));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Quickview Opened',
        Object.keys(properties),
        [
          'productId',
          'category',
          'isClearance',
          'name',
          'price',
          'quantity',
          'sku',
          'variant',
          'fullPrice',
          'productFamily',
          'contentIds',
          'isFlashSale',
          'location',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'XMnGwvbU11',
        'd34e416b5ad3a62e7396ad75ad357df653224ccfd03d71ad320f99f6f13cadcf',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Quickview Opened',
      {
        product_id: properties.productId,
        category: properties.category,
        is_clearance: properties.isClearance,
        name: properties.name,
        price: properties.price,
        quantity: properties.quantity,
        sku: properties.sku,
        variant: properties.variant,
        full_price: properties.fullPrice,
        product_family: properties.productFamily,
        content_ids: properties.contentIds,
        is_flash_sale: properties.isFlashSale,
        location: properties.location,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'XMnGwvbU11',
        'Quickview Opened',
        messages,
        [
          { id: '3PXRzRK2KK', name: 'category', value: properties.category },
          { id: 'B71GIESiV8', name: 'location', value: properties.location },
          { id: 'EghVtONPP', name: 'name', value: properties.name },
          { id: 'F_0zRLZY6n', name: 'full_price', value: properties.fullPrice },
          {
            id: 'L98Svx9Tq_',
            name: 'content_ids',
            value: properties.contentIds,
          },
          { id: 'j-kP3_J7Rb', name: 'price', value: properties.price },
          { id: 'nHu4WfjB0w', name: 'product_id', value: properties.productId },
          {
            id: 'ocjd8V8Of8',
            name: 'is_flash_sale',
            value: properties.isFlashSale,
          },
          { id: 'r7TPl6ZqL8', name: 'quantity', value: properties.quantity },
          {
            id: 'rYLq0zrdEe',
            name: 'product_family',
            value: properties.productFamily,
          },
          { id: 'uI2-rwjYtt', name: 'sku', value: properties.sku },
          {
            id: 'zPeher-BjQ',
            name: 'is_clearance',
            value: properties.isClearance,
          },
          { id: 'zsMuCAiZ4D', name: 'variant', value: properties.variant },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Quickview Opened': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Quickview Opened',
        {
          product_id: properties.productId,
          category: properties.category,
          is_clearance: properties.isClearance,
          name: properties.name,
          price: properties.price,
          quantity: properties.quantity,
          sku: properties.sku,
          variant: properties.variant,
          full_price: properties.fullPrice,
          product_family: properties.productFamily,
          content_ids: properties.contentIds,
          is_flash_sale: properties.isFlashSale,
          location: properties.location,
        },
        'XMnGwvbU11',
        'd34e416b5ad3a62e7396ad75ad357df653224ccfd03d71ad320f99f6f13cadcf'
      );
    }
  } else {
    // do nothing
  }
}

/**
 * Product Shared: Fired when an individual product is shared.
 *
 * @param {object} properties - the properties associated with this event
 * @param {int} properties.productId - The 3-5 digit product id (i.e. `623` corresponds to Hughes Sofa)
 * @param {string} properties.category - The product type (i.e. 'Chair', 'Sofa', etc.). This is NOT the category in terms of Joybird's use of the term 'category', this is the product type.
 * @param {bool} properties.isClearance - Whether or not the item was on clearance
 * @param {string} properties.name - Full product name (i.e. 'Hughes Grand Sofa')
 * @param {float} properties.price - The price the user pays. If there is a sale, this is the sale price, if there is no sale, this is the full price
 * @param {int} properties.quantity - The quantity of products
 * @param {string} properties.sku - The full sku (i.e. 'JB103853-CF200-WS03')
 * Product Viewed -> Send the full sku of the first image shown (not the fabric that's selected)
 * @param {string} properties.variant - All product options for a product, separated by a comma and a space (i.e. 'Taylor Felt Grey, Mocha, Left, Cone').
 * If a user selected 'Decide Later', the variant should be 'Decide Later'.
 * @param {float} properties.fullPrice - The full price of the product
 * @param {string} properties.productFamily - The family of the product (i.e. 'Hughes', 'Soto', ect.).
 * @param {Array<string>} properties.contentIds - The base product sku(s) (i.e. if the sku is 'JB11069110-CF423-WS03', the value for Content IDs should be ['JB11069110']).
 * @param {bool} properties.isFlashSale - Whether or not the item was on flash sale
 * @param {string} properties.email - The email address (i.e. 'christoph@joybird.com')
 * @param {string} [properties.message] - The message in the product shared modal
 * @param {string} properties.firstName - User's first name
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/InUEX0N23N}
 */
export function productShared(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertProductId(properties.productId));
    messages = messages.concat(assertCategory(properties.category));
    messages = messages.concat(assertIsClearance(properties.isClearance));
    messages = messages.concat(assertName(properties.name));
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(assertQuantity(properties.quantity));
    messages = messages.concat(assertSku(properties.sku));
    messages = messages.concat(assertVariant(properties.variant));
    messages = messages.concat(assertFullPrice(properties.fullPrice));
    messages = messages.concat(assertProductFamily(properties.productFamily));
    messages = messages.concat(assertContentIds(properties.contentIds));
    messages = messages.concat(assertIsFlashSale(properties.isFlashSale));
    messages = messages.concat(assertEmail(properties.email));
    messages = messages.concat(assertOptionalMessage(properties.message));
    messages = messages.concat(assertFirstName(properties.firstName));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Product Shared',
        Object.keys(properties),
        [
          'productId',
          'category',
          'isClearance',
          'name',
          'price',
          'quantity',
          'sku',
          'variant',
          'fullPrice',
          'productFamily',
          'contentIds',
          'isFlashSale',
          'email',
          'message',
          'firstName',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'InUEX0N23N',
        '3559311cbd97f43c27b22c93c975801afbb4f93df43c37700d5629de2460ecb0',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Product Shared',
      {
        product_id: properties.productId,
        category: properties.category,
        is_clearance: properties.isClearance,
        name: properties.name,
        price: properties.price,
        quantity: properties.quantity,
        sku: properties.sku,
        variant: properties.variant,
        full_price: properties.fullPrice,
        product_family: properties.productFamily,
        content_ids: properties.contentIds,
        is_flash_sale: properties.isFlashSale,
        email: properties.email,
        message: properties.message,
        first_name: properties.firstName,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'InUEX0N23N',
        'Product Shared',
        messages,
        [
          { id: '3PXRzRK2KK', name: 'category', value: properties.category },
          { id: '4rYN-Q_mp', name: 'email', value: properties.email },
          { id: 'EghVtONPP', name: 'name', value: properties.name },
          { id: 'F_0zRLZY6n', name: 'full_price', value: properties.fullPrice },
          {
            id: 'L98Svx9Tq_',
            name: 'content_ids',
            value: properties.contentIds,
          },
          { id: 'RD7HJjbic2', name: 'first_name', value: properties.firstName },
          { id: 'j-kP3_J7Rb', name: 'price', value: properties.price },
          { id: 'nHu4WfjB0w', name: 'product_id', value: properties.productId },
          {
            id: 'ocjd8V8Of8',
            name: 'is_flash_sale',
            value: properties.isFlashSale,
          },
          { id: 'r7TPl6ZqL8', name: 'quantity', value: properties.quantity },
          {
            id: 'rYLq0zrdEe',
            name: 'product_family',
            value: properties.productFamily,
          },
          { id: 'uI2-rwjYtt', name: 'sku', value: properties.sku },
          { id: 'xOg92BnGoS', name: 'message', value: properties.message },
          {
            id: 'zPeher-BjQ',
            name: 'is_clearance',
            value: properties.isClearance,
          },
          { id: 'zsMuCAiZ4D', name: 'variant', value: properties.variant },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Product Shared': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Product Shared',
        {
          product_id: properties.productId,
          category: properties.category,
          is_clearance: properties.isClearance,
          name: properties.name,
          price: properties.price,
          quantity: properties.quantity,
          sku: properties.sku,
          variant: properties.variant,
          full_price: properties.fullPrice,
          product_family: properties.productFamily,
          content_ids: properties.contentIds,
          is_flash_sale: properties.isFlashSale,
          email: properties.email,
          message: properties.message,
          first_name: properties.firstName,
        },
        'InUEX0N23N',
        '3559311cbd97f43c27b22c93c975801afbb4f93df43c37700d5629de2460ecb0'
      );
    }
  } else {
    // do nothing
  }
}

/**
 * Warranty Form Started: Fired the second the "Start Your Request" button is clicked. Does not wait for a response from any APIs.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/ihcgcUNvx0/trigger/Jptdno1zh
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.email - The email address (i.e. 'christoph@joybird.com')
 * @param {string} properties.orderId - The stringified order id
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/ihcgcUNvx0}
 */
export function warrantyFormStarted(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertEmail(properties.email));
    messages = messages.concat(assertOrderId(properties.orderId));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Warranty Form Started',
        Object.keys(properties),
        ['email', 'orderId']
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'ihcgcUNvx0',
        '2c2d31b955a823259a45fa6cb28f06ebec239334a5f8dcc76725843ea8170519',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Warranty Form Started',
      {
        email: properties.email,
        order_id: properties.orderId,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'ihcgcUNvx0',
        'Warranty Form Started',
        messages,
        [
          { id: '4rYN-Q_mp', name: 'email', value: properties.email },
          { id: 'Qo1JxjBu_f', name: 'order_id', value: properties.orderId },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Warranty Form Started': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Warranty Form Started',
        {
          email: properties.email,
          order_id: properties.orderId,
        },
        'ihcgcUNvx0',
        '2c2d31b955a823259a45fa6cb28f06ebec239334a5f8dcc76725843ea8170519'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Warranty Form Started', {
      email: properties.email,
      order_id: properties.orderId,
    });
  } else {
    // do nothing
  }
}

/**
 * Warranty Form Submitted: This event is fired once the user clicks "Send Your Request" on the warranty form and receives a response from the API.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/1XOQ06I2gk/trigger/EAEc-aoY5
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.email - The email address (i.e. 'christoph@joybird.com')
 * @param {string} properties.orderId - The stringified order id
 * @param {string} [properties.error] - The error message, if any. Send as empty string if the is none.
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/1XOQ06I2gk}
 */
export function warrantyFormSubmitted(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertEmail(properties.email));
    messages = messages.concat(assertOrderId(properties.orderId));
    messages = messages.concat(assertOptionalError(properties.error));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Warranty Form Submitted',
        Object.keys(properties),
        ['email', 'orderId', 'error']
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '1XOQ06I2gk',
        '9672c476c0b9faf9c0a3e040c7a8890aead076c17ba6abbf06311d4f96d16fbb',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Warranty Form Submitted',
      {
        email: properties.email,
        order_id: properties.orderId,
        error: properties.error,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '1XOQ06I2gk',
        'Warranty Form Submitted',
        messages,
        [
          { id: '4rYN-Q_mp', name: 'email', value: properties.email },
          { id: 'Qo1JxjBu_f', name: 'order_id', value: properties.orderId },
          { id: 'scucIInsa', name: 'error', value: properties.error },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Warranty Form Submitted': " +
            messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Warranty Form Submitted',
        {
          email: properties.email,
          order_id: properties.orderId,
          error: properties.error,
        },
        '1XOQ06I2gk',
        '9672c476c0b9faf9c0a3e040c7a8890aead076c17ba6abbf06311d4f96d16fbb'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('Warranty Form Submitted', {
      email: properties.email,
      order_id: properties.orderId,
      error: properties.error,
    });
  } else {
    // do nothing
  }
}

/**
 * On-Site Chat Ended: Fired when the on-site chat has ended.
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.location - The location where the event occurred. Possibilities are listed below:
 * * For the 'Email Acquired' event, options are: 'Guest Checkout', 'Swatch Request', 'Justuno', or 'Account Creation'
 * * For the 'Product Clicked' event, options are: 'Home Page', 'Category Page',  'PDP', or 'Cart'
 * * For the 'Product Added to Wishlist' event, options are: 'Home Page', 'Category Page', or 'PDP'
 * * For the 'Protection Plan Added' event, options are: 'PDP', 'Cart', 'Checkout'
 * * For the 'Coupon Applied/Denied/Entered/Removed' events, options are: 'PDP' & 'Checkout'
 * * For the 'Fabric Favorited/Unfavorited' events, options are: 'PDP', 'Shop By Material', 'Pet Friendly Page', & 'Safeguard Fabrics Page'
 * @param {string} properties.talkativeCustomerId - The site visitor's customer ID from Talkative, if the user used the on-site chat.
 * This information is stored in a cookie by Talkative: talkative_ecs__eu__[wildcard UUID]__customer__uuid
 * Additional documentation at https://support.gettalkative.com/knowledge/cookie-policy-1
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/msPJ5KdEj}
 */
export function onSiteChatEnded(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertLocation(properties.location));
    messages = messages.concat(
      assertTalkativeCustomerId(properties.talkativeCustomerId)
    );
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'On-Site Chat Ended',
        Object.keys(properties),
        ['location', 'talkativeCustomerId']
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'msPJ5KdEj',
        '54cef89ad793cc3e1944cd6585c50cf35f3173a5de90b505fe18e68f1ee049a7',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'On-Site Chat Ended',
      {
        location: properties.location,
        talkative_customer_id: properties.talkativeCustomerId,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'msPJ5KdEj',
        'On-Site Chat Ended',
        messages,
        [
          { id: 'B71GIESiV8', name: 'location', value: properties.location },
          {
            id: 'E46jtrSf8',
            name: 'talkative_customer_id',
            value: properties.talkativeCustomerId,
          },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'On-Site Chat Ended': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'On-Site Chat Ended',
        {
          location: properties.location,
          talkative_customer_id: properties.talkativeCustomerId,
        },
        'msPJ5KdEj',
        '54cef89ad793cc3e1944cd6585c50cf35f3173a5de90b505fe18e68f1ee049a7'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('On-Site Chat Ended', {
      location: properties.location,
      talkative_customer_id: properties.talkativeCustomerId,
    });
  } else {
    // do nothing
  }
}

/**
 * Trade Application Visited: An event that fires when a page visit occurs on a trade application page. Current pages are:
 * https://joybird.com/business/ (standard URL included in site navigation)
 * https://joybird.com/trade-application/ (URL used in promotional materials)
 *
 * @param {object} properties - the properties associated with this event
 * @param {int} [properties.iterableCampaignId] - The campaign ID from Iterable. Used when sending purchase data back to Iterable for campaign attribution.
 * The data for this property will come from the utm_campaignID query parameter from the page URL.
 * Example:
 * https://joybird.com/fabric-of-the-month/?utm_source=iterable&utm_medium=email&utm_term=jbnewsletter&utm_content=FOTM_learn_more&utm_campaign=PROOF_CAMPAIGN_NAME&utm_leadstatus=hnp&utm_templateID=12790186&utm_campaignID=-12345
 * @param {string} [properties.campaignUtmSource] - The UTM source for the campaign. This is set by the Marketing team.
 * The data for this property will come from the utm_source query parameter from the page URL.
 * Example:
 * https://joybird.com/fabric-of-the-month/?utm_source=iterable&utm_medium=email&utm_term=jbnewsletter&utm_content=FOTM_learn_more&utm_campaign=PROOF_CAMPAIGN_NAME&utm_leadstatus=hnp&utm_templateID=12790186&utm_campaignID=-12345
 * @param {string} [properties.campaignUtmMedium] - The UTM medium for the campaign. This is set by the Marketing team.
 * The data for this property will come from the utm_medium query parameter from the page URL.
 * Example:
 * https://joybird.com/fabric-of-the-month/?utm_source=iterable&utm_medium=email&utm_term=jbnewsletter&utm_content=FOTM_learn_more&utm_campaign=PROOF_CAMPAIGN_NAME&utm_leadstatus=hnp&utm_templateID=12790186&utm_campaignID=-12345
 * @param {string} [properties.campaignUtmTerm] - The UTM term for the campaign. This is set by the Marketing team.
 * The data for this property will come from the utm_term query parameter from the page URL.
 * Example:
 * https://joybird.com/fabric-of-the-month/?utm_source=iterable&utm_medium=email&utm_term=jbnewsletter&utm_content=FOTM_learn_more&utm_campaign=PROOF_CAMPAIGN_NAME&utm_leadstatus=hnp&utm_templateID=12790186&utm_campaignID=-12345
 * @param {string} [properties.campaignUtmContent] - The UTM content for the campaign. This is set by the Marketing team.
 * The data for this property will come from the utm_content query parameter from the page URL.
 * Example:
 * https://joybird.com/fabric-of-the-month/?utm_source=iterable&utm_medium=email&utm_term=jbnewsletter&utm_content=FOTM_learn_more&utm_campaign=PROOF_CAMPAIGN_NAME&utm_leadstatus=hnp&utm_templateID=12790186&utm_campaignID=-12345
 * @param {string} [properties.campaignUtmCampaign] - The UTM campaign for the campaign. This is set by the Marketing team.
 * The data for this property will come from the utm_campaign query parameter from the page URL.
 * Example:
 * https://joybird.com/fabric-of-the-month/?utm_source=iterable&utm_medium=email&utm_term=jbnewsletter&utm_content=FOTM_learn_more&utm_campaign=PROOF_CAMPAIGN_NAME&utm_leadstatus=hnp&utm_templateID=12790186&utm_campaignID=-12345
 * @param {int} [properties.iterableTemplateId] - The template ID from Iterable. Used when sending purchase data back to Iterable for campaign attribution.
 * The data for this property will come from the utm_templateID query parameter from the page URL.
 * Example:
 * https://joybird.com/fabric-of-the-month/?utm_source=iterable&utm_medium=email&utm_term=jbnewsletter&utm_content=FOTM_learn_more&utm_campaign=PROOF_CAMPAIGN_NAME&utm_leadstatus=hnp&utm_templateID=12790186&utm_campaignID=-12345
 * @param {string} properties.userId_ - The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param {string} properties.email - The email address (i.e. 'christoph@joybird.com')
 * @param {string} properties.backendEmail - Email address from the server
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/d_K7TwQG2Y}
 */
export function tradeApplicationVisited(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(
      assertOptionalIterableCampaignId(properties.iterableCampaignId)
    );
    messages = messages.concat(
      assertOptionalCampaignUtmSource(properties.campaignUtmSource)
    );
    messages = messages.concat(
      assertOptionalCampaignUtmMedium(properties.campaignUtmMedium)
    );
    messages = messages.concat(
      assertOptionalCampaignUtmTerm(properties.campaignUtmTerm)
    );
    messages = messages.concat(
      assertOptionalCampaignUtmContent(properties.campaignUtmContent)
    );
    messages = messages.concat(
      assertOptionalCampaignUtmCampaign(properties.campaignUtmCampaign)
    );
    messages = messages.concat(
      assertOptionalIterableTemplateId(properties.iterableTemplateId)
    );
    messages = messages.concat(assertUserId_(properties.userId_));
    messages = messages.concat(assertEmail(properties.email));
    messages = messages.concat(assertBackendEmail(properties.backendEmail));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Trade Application Visited',
        Object.keys(properties),
        [
          'iterableCampaignId',
          'campaignUtmSource',
          'campaignUtmMedium',
          'campaignUtmTerm',
          'campaignUtmContent',
          'campaignUtmCampaign',
          'iterableTemplateId',
          'userId_',
          'email',
          'backendEmail',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'd_K7TwQG2Y',
        '04eb72c7faa38bbf16e7d815afce700ac25a4a08f27a15a74c1bb5f9c246afb0',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Trade Application Visited',
      {
        iterable_campaign_id: properties.iterableCampaignId,
        campaign_utm_source: properties.campaignUtmSource,
        campaign_utm_medium: properties.campaignUtmMedium,
        campaign_utm_term: properties.campaignUtmTerm,
        campaign_utm_content: properties.campaignUtmContent,
        campaign_utm_campaign: properties.campaignUtmCampaign,
        iterable_template_id: properties.iterableTemplateId,
        email: properties.email,
      },
      {
        backend_email: properties.backendEmail,
      },
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'd_K7TwQG2Y',
        'Trade Application Visited',
        messages,
        [
          {
            id: '-yJgZgCLf0',
            name: 'campaign_utm_term',
            value: properties.campaignUtmTerm,
          },
          { id: '4rYN-Q_mp', name: 'email', value: properties.email },
          {
            id: '7-kG2dnolL',
            name: 'campaign_utm_medium',
            value: properties.campaignUtmMedium,
          },
          {
            id: 'ZC-o592Ouy',
            name: 'campaign_utm_source',
            value: properties.campaignUtmSource,
          },
          {
            id: 'cehAl0GP3c',
            name: 'campaign_utm_content',
            value: properties.campaignUtmContent,
          },
          {
            id: 'hahjHVdW76',
            name: 'campaign_utm_campaign',
            value: properties.campaignUtmCampaign,
          },
          {
            id: 'nkw4-m74P9',
            name: 'iterable_campaign_id',
            value: properties.iterableCampaignId,
          },
          {
            id: 'w9JwEo_jAXP',
            name: 'iterable_template_id',
            value: properties.iterableTemplateId,
          },
        ],
        [
          {
            id: 'zjUFB7hRiT',
            name: 'backend_email',
            value: properties.backendEmail,
          },
        ],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Trade Application Visited': " +
            messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Trade Application Visited',
        {
          iterable_campaign_id: properties.iterableCampaignId,
          campaign_utm_source: properties.campaignUtmSource,
          campaign_utm_medium: properties.campaignUtmMedium,
          campaign_utm_term: properties.campaignUtmTerm,
          campaign_utm_content: properties.campaignUtmContent,
          campaign_utm_campaign: properties.campaignUtmCampaign,
          iterable_template_id: properties.iterableTemplateId,
          email: properties.email,
        },
        'd_K7TwQG2Y',
        '04eb72c7faa38bbf16e7d815afce700ac25a4a08f27a15a74c1bb5f9c246afb0'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.setUserProperties(properties.userId_, {
      email: properties.backendEmail,
    });
    RudderstackJavascript.logEvent('Trade Application Visited', {
      iterable_campaign_id: properties.iterableCampaignId,
      campaign_utm_source: properties.campaignUtmSource,
      campaign_utm_medium: properties.campaignUtmMedium,
      campaign_utm_term: properties.campaignUtmTerm,
      campaign_utm_content: properties.campaignUtmContent,
      campaign_utm_campaign: properties.campaignUtmCampaign,
      iterable_template_id: properties.iterableTemplateId,
      email: properties.email,
    });
  } else {
    // do nothing
  }
}

/**
 * Trade Application Submitted: An event that fires when the customer clicks on the "Apply" button on trade application page. Current pages are:
 * https://joybird.com/business/ (standard URL included in site navigation)
 * https://joybird.com/trade-application/ (URL used in promotional materials)
 * For this event, the email property should be filled with the email address entered in the application form.
 *
 * When to trigger this event:
 * 1. Click the "Apply" button on the page
 * View in Avo: https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/uxgLlkBILr/trigger/1O_BMblt7
 *
 * @param {object} properties - the properties associated with this event
 * @param {int} [properties.iterableCampaignId] - The campaign ID from Iterable. Used when sending purchase data back to Iterable for campaign attribution.
 * The data for this property will come from the utm_campaignID query parameter from the page URL.
 * Example:
 * https://joybird.com/fabric-of-the-month/?utm_source=iterable&utm_medium=email&utm_term=jbnewsletter&utm_content=FOTM_learn_more&utm_campaign=PROOF_CAMPAIGN_NAME&utm_leadstatus=hnp&utm_templateID=12790186&utm_campaignID=-12345
 * @param {string} [properties.campaignUtmSource] - The UTM source for the campaign. This is set by the Marketing team.
 * The data for this property will come from the utm_source query parameter from the page URL.
 * Example:
 * https://joybird.com/fabric-of-the-month/?utm_source=iterable&utm_medium=email&utm_term=jbnewsletter&utm_content=FOTM_learn_more&utm_campaign=PROOF_CAMPAIGN_NAME&utm_leadstatus=hnp&utm_templateID=12790186&utm_campaignID=-12345
 * @param {string} [properties.campaignUtmMedium] - The UTM medium for the campaign. This is set by the Marketing team.
 * The data for this property will come from the utm_medium query parameter from the page URL.
 * Example:
 * https://joybird.com/fabric-of-the-month/?utm_source=iterable&utm_medium=email&utm_term=jbnewsletter&utm_content=FOTM_learn_more&utm_campaign=PROOF_CAMPAIGN_NAME&utm_leadstatus=hnp&utm_templateID=12790186&utm_campaignID=-12345
 * @param {string} [properties.campaignUtmTerm] - The UTM term for the campaign. This is set by the Marketing team.
 * The data for this property will come from the utm_term query parameter from the page URL.
 * Example:
 * https://joybird.com/fabric-of-the-month/?utm_source=iterable&utm_medium=email&utm_term=jbnewsletter&utm_content=FOTM_learn_more&utm_campaign=PROOF_CAMPAIGN_NAME&utm_leadstatus=hnp&utm_templateID=12790186&utm_campaignID=-12345
 * @param {string} [properties.campaignUtmContent] - The UTM content for the campaign. This is set by the Marketing team.
 * The data for this property will come from the utm_content query parameter from the page URL.
 * Example:
 * https://joybird.com/fabric-of-the-month/?utm_source=iterable&utm_medium=email&utm_term=jbnewsletter&utm_content=FOTM_learn_more&utm_campaign=PROOF_CAMPAIGN_NAME&utm_leadstatus=hnp&utm_templateID=12790186&utm_campaignID=-12345
 * @param {string} [properties.campaignUtmCampaign] - The UTM campaign for the campaign. This is set by the Marketing team.
 * The data for this property will come from the utm_campaign query parameter from the page URL.
 * Example:
 * https://joybird.com/fabric-of-the-month/?utm_source=iterable&utm_medium=email&utm_term=jbnewsletter&utm_content=FOTM_learn_more&utm_campaign=PROOF_CAMPAIGN_NAME&utm_leadstatus=hnp&utm_templateID=12790186&utm_campaignID=-12345
 * @param {int} [properties.iterableTemplateId] - The template ID from Iterable. Used when sending purchase data back to Iterable for campaign attribution.
 * The data for this property will come from the utm_templateID query parameter from the page URL.
 * Example:
 * https://joybird.com/fabric-of-the-month/?utm_source=iterable&utm_medium=email&utm_term=jbnewsletter&utm_content=FOTM_learn_more&utm_campaign=PROOF_CAMPAIGN_NAME&utm_leadstatus=hnp&utm_templateID=12790186&utm_campaignID=-12345
 * @param {string} properties.userId_ - The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param {string} properties.email - The email address (i.e. 'christoph@joybird.com')
 * @param {bool} properties.optedInTrade - Whether or not the user opted in to trade emails
 * @param {string} properties.backendEmail - Email address from the server
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/uxgLlkBILr}
 */
export function tradeApplicationSubmitted(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(
      assertOptionalIterableCampaignId(properties.iterableCampaignId)
    );
    messages = messages.concat(
      assertOptionalCampaignUtmSource(properties.campaignUtmSource)
    );
    messages = messages.concat(
      assertOptionalCampaignUtmMedium(properties.campaignUtmMedium)
    );
    messages = messages.concat(
      assertOptionalCampaignUtmTerm(properties.campaignUtmTerm)
    );
    messages = messages.concat(
      assertOptionalCampaignUtmContent(properties.campaignUtmContent)
    );
    messages = messages.concat(
      assertOptionalCampaignUtmCampaign(properties.campaignUtmCampaign)
    );
    messages = messages.concat(
      assertOptionalIterableTemplateId(properties.iterableTemplateId)
    );
    messages = messages.concat(assertUserId_(properties.userId_));
    messages = messages.concat(assertEmail(properties.email));
    messages = messages.concat(assertOptedInTrade(properties.optedInTrade));
    messages = messages.concat(assertBackendEmail(properties.backendEmail));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'Trade Application Submitted',
        Object.keys(properties),
        [
          'iterableCampaignId',
          'campaignUtmSource',
          'campaignUtmMedium',
          'campaignUtmTerm',
          'campaignUtmContent',
          'campaignUtmCampaign',
          'iterableTemplateId',
          'userId_',
          'email',
          'optedInTrade',
          'backendEmail',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'uxgLlkBILr',
        '6bcb177a1a61b8d54d869fc6894b1bf55f3186fb82e578b190c2b8df10712dc6',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'Trade Application Submitted',
      {
        iterable_campaign_id: properties.iterableCampaignId,
        campaign_utm_source: properties.campaignUtmSource,
        campaign_utm_medium: properties.campaignUtmMedium,
        campaign_utm_term: properties.campaignUtmTerm,
        campaign_utm_content: properties.campaignUtmContent,
        campaign_utm_campaign: properties.campaignUtmCampaign,
        iterable_template_id: properties.iterableTemplateId,
        email: properties.email,
        opted_in_trade: properties.optedInTrade,
      },
      {
        backend_email: properties.backendEmail,
      },
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'uxgLlkBILr',
        'Trade Application Submitted',
        messages,
        [
          {
            id: '-yJgZgCLf0',
            name: 'campaign_utm_term',
            value: properties.campaignUtmTerm,
          },
          { id: '4rYN-Q_mp', name: 'email', value: properties.email },
          {
            id: '7-kG2dnolL',
            name: 'campaign_utm_medium',
            value: properties.campaignUtmMedium,
          },
          {
            id: 'CwSBlkF81y',
            name: 'opted_in_trade',
            value: properties.optedInTrade,
          },
          {
            id: 'ZC-o592Ouy',
            name: 'campaign_utm_source',
            value: properties.campaignUtmSource,
          },
          {
            id: 'cehAl0GP3c',
            name: 'campaign_utm_content',
            value: properties.campaignUtmContent,
          },
          {
            id: 'hahjHVdW76',
            name: 'campaign_utm_campaign',
            value: properties.campaignUtmCampaign,
          },
          {
            id: 'nkw4-m74P9',
            name: 'iterable_campaign_id',
            value: properties.iterableCampaignId,
          },
          {
            id: 'w9JwEo_jAXP',
            name: 'iterable_template_id',
            value: properties.iterableTemplateId,
          },
        ],
        [
          {
            id: 'zjUFB7hRiT',
            name: 'backend_email',
            value: properties.backendEmail,
          },
        ],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Trade Application Submitted': " +
            messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Trade Application Submitted',
        {
          iterable_campaign_id: properties.iterableCampaignId,
          campaign_utm_source: properties.campaignUtmSource,
          campaign_utm_medium: properties.campaignUtmMedium,
          campaign_utm_term: properties.campaignUtmTerm,
          campaign_utm_content: properties.campaignUtmContent,
          campaign_utm_campaign: properties.campaignUtmCampaign,
          iterable_template_id: properties.iterableTemplateId,
          email: properties.email,
          opted_in_trade: properties.optedInTrade,
        },
        'uxgLlkBILr',
        '6bcb177a1a61b8d54d869fc6894b1bf55f3186fb82e578b190c2b8df10712dc6'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.setUserProperties(properties.userId_, {
      email: properties.backendEmail,
    });
    RudderstackJavascript.logEvent('Trade Application Submitted', {
      iterable_campaign_id: properties.iterableCampaignId,
      campaign_utm_source: properties.campaignUtmSource,
      campaign_utm_medium: properties.campaignUtmMedium,
      campaign_utm_term: properties.campaignUtmTerm,
      campaign_utm_content: properties.campaignUtmContent,
      campaign_utm_campaign: properties.campaignUtmCampaign,
      iterable_template_id: properties.iterableTemplateId,
      email: properties.email,
      opted_in_trade: properties.optedInTrade,
    });
  } else {
    // do nothing
  }
}

/**
 * PDP Gallery Interacted: Fired when a user successfully performs a supported interaction within the PDP gallery.
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.category - The product type (i.e. 'Chair', 'Sofa', etc.). This is NOT the category in terms of Joybird's use of the term 'category', this is the product type.
 * @param {string} properties.productFamily - The family of the product (i.e. 'Hughes', 'Soto', ect.).
 * @param {string} properties.name - Full product name (i.e. 'Hughes Grand Sofa')
 * @param {string} properties.variant - All product options for a product, separated by a comma and a space (i.e. 'Taylor Felt Grey, Mocha, Left, Cone').
 * If a user selected 'Decide Later', the variant should be 'Decide Later'.
 * @param {string} properties.sku - The full sku (i.e. 'JB103853-CF200-WS03')
 * Product Viewed -> Send the full sku of the first image shown (not the fabric that's selected)
 * @param {float} properties.price - The price the user pays. If there is a sale, this is the sale price, if there is no sale, this is the full price
 * @param {int} properties.fabricId - The fabric id (i.e. For Bentley Daisy it's 263)
 * @param {int} properties.productId - The 3-5 digit product id (i.e. `623` corresponds to Hughes Sofa)
 * @param {bool} [properties.lifestyleGalleryOpened] - Indicates that the user opened the Lifestyle Gallery. This property should only be populated when the Lifestyle Gallery Opened interaction occurs.
 * @param {bool} [properties.measureActivated] - Indicates that the user activated the Measure (Dimensions) view. This property should only be populated when the Measure interaction occurs.
 * @param {bool} [properties.openStateActivated] - Indicates that the user activated the Open State view. This property should only be populated when the Open State interaction occurs.
 * @param {bool} [properties.zoomedInteracted] - Indicates that the user zoomed in or out within the Lifestyle gallery. This property should only be populated when the Zoom In or Zoom Out interaction occurs.
 * @param {bool} [properties.arStarted] - Indicates that the user started the AR experience. This property should only be populated when the interaction with AR button occurs.
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/xXDFowUn1bVMGfJQZzl93}
 */
export function pdpGalleryInteracted(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertCategory(properties.category));
    messages = messages.concat(assertProductFamily(properties.productFamily));
    messages = messages.concat(assertName(properties.name));
    messages = messages.concat(assertVariant(properties.variant));
    messages = messages.concat(assertSku(properties.sku));
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(assertFabricId(properties.fabricId));
    messages = messages.concat(assertProductId(properties.productId));
    messages = messages.concat(
      assertOptionalLifestyleGalleryOpened(properties.lifestyleGalleryOpened)
    );
    messages = messages.concat(
      assertOptionalMeasureActivated(properties.measureActivated)
    );
    messages = messages.concat(
      assertOptionalOpenStateActivated(properties.openStateActivated)
    );
    messages = messages.concat(
      assertOptionalZoomedInteracted(properties.zoomedInteracted)
    );
    messages = messages.concat(assertOptionalArStarted(properties.arStarted));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'PDP Gallery Interacted',
        Object.keys(properties),
        [
          'category',
          'productFamily',
          'name',
          'variant',
          'sku',
          'price',
          'fabricId',
          'productId',
          'lifestyleGalleryOpened',
          'measureActivated',
          'openStateActivated',
          'zoomedInteracted',
          'arStarted',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'xXDFowUn1bVMGfJQZzl93',
        '5c68d0a5323f7cf51423bc668ffd5b46a8539b7db63397b7448b60d884131486',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'PDP Gallery Interacted',
      {
        category: properties.category,
        product_family: properties.productFamily,
        name: properties.name,
        variant: properties.variant,
        sku: properties.sku,
        price: properties.price,
        fabric_id: properties.fabricId,
        product_id: properties.productId,
        lifestyle_gallery_opened: properties.lifestyleGalleryOpened,
        measure_activated: properties.measureActivated,
        open_state_activated: properties.openStateActivated,
        zoomed_interacted: properties.zoomedInteracted,
        ar_started: properties.arStarted,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'xXDFowUn1bVMGfJQZzl93',
        'PDP Gallery Interacted',
        messages,
        [
          { id: '3PXRzRK2KK', name: 'category', value: properties.category },
          {
            id: '7RtLBjDvYoNCbOX-Fheeg',
            name: 'measure_activated',
            value: properties.measureActivated,
          },
          { id: 'EghVtONPP', name: 'name', value: properties.name },
          {
            id: 'NBu0amJ6z4HGuuABGnHFB',
            name: 'lifestyle_gallery_opened',
            value: properties.lifestyleGalleryOpened,
          },
          {
            id: 'Nhnz3V8o29gKWOcn5w_py',
            name: 'open_state_activated',
            value: properties.openStateActivated,
          },
          {
            id: 'iogUfmRrHgxOuwV7mmJch',
            name: 'ar_started',
            value: properties.arStarted,
          },
          { id: 'j-kP3_J7Rb', name: 'price', value: properties.price },
          {
            id: 'kwRtnkOtKKkvFrtXNgdZd',
            name: 'zoomed_interacted',
            value: properties.zoomedInteracted,
          },
          { id: 'nHu4WfjB0w', name: 'product_id', value: properties.productId },
          {
            id: 'rYLq0zrdEe',
            name: 'product_family',
            value: properties.productFamily,
          },
          { id: 'uI2-rwjYtt', name: 'sku', value: properties.sku },
          { id: 'vl8jHhQKP6', name: 'fabric_id', value: properties.fabricId },
          { id: 'zsMuCAiZ4D', name: 'variant', value: properties.variant },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'PDP Gallery Interacted': " + messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'PDP Gallery Interacted',
        {
          category: properties.category,
          product_family: properties.productFamily,
          name: properties.name,
          variant: properties.variant,
          sku: properties.sku,
          price: properties.price,
          fabric_id: properties.fabricId,
          product_id: properties.productId,
          lifestyle_gallery_opened: properties.lifestyleGalleryOpened,
          measure_activated: properties.measureActivated,
          open_state_activated: properties.openStateActivated,
          zoomed_interacted: properties.zoomedInteracted,
          ar_started: properties.arStarted,
        },
        'xXDFowUn1bVMGfJQZzl93',
        '5c68d0a5323f7cf51423bc668ffd5b46a8539b7db63397b7448b60d884131486'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('PDP Gallery Interacted', {
      category: properties.category,
      product_family: properties.productFamily,
      name: properties.name,
      variant: properties.variant,
      sku: properties.sku,
      price: properties.price,
      fabric_id: properties.fabricId,
      product_id: properties.productId,
      lifestyle_gallery_opened: properties.lifestyleGalleryOpened,
      measure_activated: properties.measureActivated,
      open_state_activated: properties.openStateActivated,
      zoomed_interacted: properties.zoomedInteracted,
      ar_started: properties.arStarted,
    });
  } else {
    // do nothing
  }
}

/**
 * PDP Gallery Image Viewed: Fired when the user navigates to a different image within the Lifestyle Gallery. The initially displayed image does not trigger this event. This event should fire each time the user changes to a new lifestyle image.
 *
 * @param {object} properties - the properties associated with this event
 * @param {string} properties.category - The product type (i.e. 'Chair', 'Sofa', etc.). This is NOT the category in terms of Joybird's use of the term 'category', this is the product type.
 * @param {string} properties.productFamily - The family of the product (i.e. 'Hughes', 'Soto', ect.).
 * @param {int} properties.productId - The 3-5 digit product id (i.e. `623` corresponds to Hughes Sofa)
 * @param {string} properties.name - Full product name (i.e. 'Hughes Grand Sofa')
 * @param {string} properties.variant - All product options for a product, separated by a comma and a space (i.e. 'Taylor Felt Grey, Mocha, Left, Cone').
 * If a user selected 'Decide Later', the variant should be 'Decide Later'.
 * @param {string} properties.sku - The full sku (i.e. 'JB103853-CF200-WS03')
 * Product Viewed -> Send the full sku of the first image shown (not the fabric that's selected)
 * @param {float} properties.price - The price the user pays. If there is a sale, this is the sale price, if there is no sale, this is the full price
 * @param {int} [properties.imageIndex] - The 1-based position of the image within the Lifestyle Gallery.
 * @param {string} [properties.imageId] - An identifier of the viewed Lifestyle Gallery image.
 *
 * @see {@link https://www.avo.app/schemas/dJpfothnobBXH6sZkM2n/events/-XXLoyX8ck7QlOwU07ib2}
 */
export function pdpGalleryImageViewed(properties) {
  properties = properties || {};
  if (__AVO_DEV__ || __WEB_DEBUGGER__) {
    // assert properties
    var messages = [];
    messages = messages.concat(assertCategory(properties.category));
    messages = messages.concat(assertProductFamily(properties.productFamily));
    messages = messages.concat(assertProductId(properties.productId));
    messages = messages.concat(assertName(properties.name));
    messages = messages.concat(assertVariant(properties.variant));
    messages = messages.concat(assertSku(properties.sku));
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(assertOptionalImageIndex(properties.imageIndex));
    messages = messages.concat(assertOptionalImageId(properties.imageId));
    messages = messages.concat(
      AvoAssert.assertNoAdditionalProperties(
        'PDP Gallery Image Viewed',
        Object.keys(properties),
        [
          'category',
          'productFamily',
          'productId',
          'name',
          'variant',
          'sku',
          'price',
          'imageIndex',
          'imageId',
        ]
      )
    );
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '-XXLoyX8ck7QlOwU07ib2',
        'c05198aca4fff9206998ff07e79d166b3c80095d5f1f5488ca6ca22178bb055a',
        messages.map(function(m) {
          return Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            }
          );
        }),
        'event'
      );
    }

    InternalAvoLogger.logEventSent(
      'PDP Gallery Image Viewed',
      {
        category: properties.category,
        product_family: properties.productFamily,
        product_id: properties.productId,
        name: properties.name,
        variant: properties.variant,
        sku: properties.sku,
        price: properties.price,
        image_index: properties.imageIndex,
        image_id: properties.imageId,
      },
      {},
      {}
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '-XXLoyX8ck7QlOwU07ib2',
        'PDP Gallery Image Viewed',
        messages,
        [
          {
            id: '1ewdiPaa6hIgJp-wC9s1x',
            name: 'image_id',
            value: properties.imageId,
          },
          { id: '3PXRzRK2KK', name: 'category', value: properties.category },
          { id: 'EghVtONPP', name: 'name', value: properties.name },
          {
            id: 'EvbevBHEwEUhoozp05cYk',
            name: 'image_index',
            value: properties.imageIndex,
          },
          { id: 'j-kP3_J7Rb', name: 'price', value: properties.price },
          { id: 'nHu4WfjB0w', name: 'product_id', value: properties.productId },
          {
            id: 'rYLq0zrdEe',
            name: 'product_family',
            value: properties.productFamily,
          },
          { id: 'uI2-rwjYtt', name: 'sku', value: properties.sku },
          { id: 'zsMuCAiZ4D', name: 'variant', value: properties.variant },
        ],
        [],
        []
      );
    }
    if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'PDP Gallery Image Viewed': " +
            messages[0].message
        );
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }

  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'PDP Gallery Image Viewed',
        {
          category: properties.category,
          product_family: properties.productFamily,
          product_id: properties.productId,
          name: properties.name,
          variant: properties.variant,
          sku: properties.sku,
          price: properties.price,
          image_index: properties.imageIndex,
          image_id: properties.imageId,
        },
        '-XXLoyX8ck7QlOwU07ib2',
        'c05198aca4fff9206998ff07e79d166b3c80095d5f1f5488ca6ca22178bb055a'
      );
    }
    // destination RudderstackJavascript
    RudderstackJavascript.logEvent('PDP Gallery Image Viewed', {
      category: properties.category,
      product_family: properties.productFamily,
      product_id: properties.productId,
      name: properties.name,
      variant: properties.variant,
      sku: properties.sku,
      price: properties.price,
      image_index: properties.imageIndex,
      image_id: properties.imageId,
    });
  } else {
    // do nothing
  }
}

export default {
  setAvoLogger: setAvoLogger,
  Location: Location,
  PaymentMethod: PaymentMethod,
  PageType: PageType,
  PlanName: PlanName,
  SearchTarget: SearchTarget,
  Cta: Cta,
  Currency: Currency,
  Component: Component,
  orderCompleted: orderCompleted,
  productAdded: productAdded,
  productAddedToWishlist: productAddedToWishlist,
  checkoutStarted: checkoutStarted,
  checkoutStepViewed: checkoutStepViewed,
  checkoutStepCompleted: checkoutStepCompleted,
  dsQuizStarted: dsQuizStarted,
  dsQuizStepCompleted: dsQuizStepCompleted,
  dsQuizCompleted: dsQuizCompleted,
  emailAcquired: emailAcquired,
  productClicked: productClicked,
  protectionPlanAdded: protectionPlanAdded,
  productRemoved: productRemoved,
  variationSelected: variationSelected,
  swatchesRequested: swatchesRequested,
  upholsteryFiltered: upholsteryFiltered,
  upsellProductAdded: upsellProductAdded,
  productListFiltered: productListFiltered,
  productListViewed: productListViewed,
  productViewed: productViewed,
  targetedOverlay: targetedOverlay,
  experimentStarted: experimentStarted,
  cartViewed: cartViewed,
  couponApplied: couponApplied,
  couponDenied: couponDenied,
  couponEntered: couponEntered,
  couponRemoved: couponRemoved,
  accountCreated: accountCreated,
  engagementIncentivizedForm: engagementIncentivizedForm,
  engagementUnlockedOrCtaClick: engagementUnlockedOrCtaClick,
  loggedIn: loggedIn,
  productRemovedFromWishlist: productRemovedFromWishlist,
  ctaClicked: ctaClicked,
  logPageView: logPageView,
  productsSearched: productsSearched,
  cookieSize: cookieSize,
  heroChatVisible: heroChatVisible,
  heroChatInUse: heroChatInUse,
  heroChatHidden: heroChatHidden,
  heroChatEnded: heroChatEnded,
  fabricFavorited: fabricFavorited,
  fabricUnfavorited: fabricUnfavorited,
  cylindoSpinStarted: cylindoSpinStarted,
  cylindoSpinEnded: cylindoSpinEnded,
  cylindoZoomedIn: cylindoZoomedIn,
  cylindoZoomedOut: cylindoZoomedOut,
  quickviewOpened: quickviewOpened,
  productShared: productShared,
  warrantyFormStarted: warrantyFormStarted,
  warrantyFormSubmitted: warrantyFormSubmitted,
  onSiteChatEnded: onSiteChatEnded,
  tradeApplicationVisited: tradeApplicationVisited,
  tradeApplicationSubmitted: tradeApplicationSubmitted,
  pdpGalleryInteracted: pdpGalleryInteracted,
  pdpGalleryImageViewed: pdpGalleryImageViewed,
  initAvo: initAvo,
  WebDebuggerPosition: WebDebuggerPosition,
  avoInspectorApiKey: avoInspectorApiKey,
};

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["orderCompleted","productAdded","productAddedToWishlist","checkoutStarted","checkoutStepViewed","checkoutStepCompleted","dsQuizStarted","dsQuizStepCompleted","dsQuizCompleted","emailAcquired","productClicked","protectionPlanAdded","productRemoved","variationSelected","swatchesRequested","upholsteryFiltered","upsellProductAdded","productListFiltered","productListViewed","productViewed","targetedOverlay","experimentStarted","cartViewed","couponApplied","couponDenied","couponEntered","couponRemoved","accountCreated","engagementIncentivizedForm","engagementUnlockedOrCtaClick","loggedIn","productRemovedFromWishlist","ctaClicked","logPageView","productsSearched","cookieSize","heroChatVisible","heroChatInUse","heroChatHidden","heroChatEnded","fabricFavorited","fabricUnfavorited","cylindoSpinStarted","cylindoSpinEnded","cylindoZoomedIn","cylindoZoomedOut","quickviewOpened","productShared","warrantyFormStarted","warrantyFormSubmitted","onSiteChatEnded","tradeApplicationVisited","tradeApplicationSubmitted","pdpGalleryInteracted","pdpGalleryImageViewed"]
